import { useInView } from "react-intersection-observer";
export function Server() {
  const [ref, inView] = useInView({ threshold: 0.5 });
  return (
    <svg
      ref={ref}
      className={`h-full mx-auto ${inView ? "animated" : ""}`}
      id="freepik_stories-application-programming-interface"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
      version="1.1"
    >
      <g
        id="freepik--Floor--inject-9"
        style={{ transformOrigin: "249.995px 342.2px 0px" }}
        className="animable"
      >
        <g
          id="freepik--floor--inject-9"
          style={{ transformOrigin: "249.995px 342.2px 0px" }}
          className="animable"
        >
          <path
            id="freepik--floor--inject-9"
            d="M77.66,242.7c-95.18,54.95-95.17,144,0,199s249.49,54.95,344.67,0,95.17-144,0-199S172.84,187.75,77.66,242.7Z"
            style={{
              fill: "hsl(351, 40%, 96%)",
              transformOrigin: "249.995px 342.2px 0px",
            }}
            className="animable"
          ></path>
          <path
            d="M391.5,227.62l6.84,3.94-15.75,9.1-15.75-9.1,14-8.09-1-.38-13.84,8L350.26,222l9.48-5.48-1.09-.32-9.21,5.32-15.75-9.09,3.05-1.77-1.19-.26L332.87,212l-5.6-3.23-2.46-.47,7.24,4.18-15.76,9.09-15.75-9.09L311.6,206l-1.3-.19L299.72,212,284,202.86h0l-1.9-.14.26.15L266.58,212l-15.76-9.09,2.35-1.36h-1.63l-1.54.89-1.54-.89h-1.62l2.34,1.36L233.43,212l-15.76-9.09.26-.15-1.9.14h0L200.28,212l-10.58-6.11-1.31.2,11.07,6.39-15.75,9.09L168,212.43l7.25-4.19-2.46.48L167.13,212l-2.68-1.55-1.19.26,3.05,1.77-15.75,9.09-9.22-5.32-1.08.32,9.48,5.48L134,231.09l-13.86-8-1,.37,14,8.1-15.75,9.1-15.75-9.1,6.86-4q-3.17,1.31-6.28,2.68L56.15,256.89c-1.7,1.28-3.35,2.58-5,3.89l15.69,9.06-15.75,9.09-12.26-7.07-.6.6,12,7L34.54,288.5l-6.9-4-.51.65L33.72,289l-14.91,8.61c-.28.48-.56,1-.83,1.44l15.74,9.08L18,317.21l-6.55-3.78c-.1.26-.19.52-.28.78l6,3.47-8.5,4.91c-.09.36-.16.73-.25,1.09L18,318.16l15.75,9.09L18,336.35,7.19,330.12c0,.29-.09.58-.13.88l10.09,5.82L6.3,343.09c0,.31,0,.62,0,.93L18,337.29l15.75,9.1L18,355.48,6.56,348.89c0,.34.07.68.1,1L17.15,356l-8.69,5c.07.28.13.56.2.84L18,356.43l15.75,9.1L18,374.62l-6.61-3.81c.14.39.28.79.43,1.19l5.36,3.1L13.84,377l.33.75,3.8-2.19,15.75,9.09-12,6.93.45.69,12.36-7.14,15.76,9.09-15.76,9.1-7.64-4.41,1.34,1.72,5.48,3.16-1.94,1.13.55.62,2.21-1.27,15.76,9.09-6.59,3.8.64.58,6.77-3.91,15.75,9.1-9.49,5.48c.23.18.48.35.72.53l9.59-5.54,15.75,9.1-10.76,6.21.8.49L84.26,433l15.76,9.1-10.45,6,.87.44,10.4-6,15.75,9.1L108,456.58l.95.4,8.42-4.86,15.75,9.09-5,2.88,1,.35,4.77-2.75,14.78,8.54,3,.77-.37-.22,15.75-9.09,15.75,9.09L174,475.91l1.23.24,8.47-4.89,14.67,8.46c1,.14,2.11.26,3.16.38l15.32-8.84,15.76,9.09-3.52,2,1.52.07,2.82-1.62,3.22,1.86,1.74.06-4.14-2.4L250,471.26l15.75,9.09-4.14,2.4,1.74-.06,3.22-1.86,2.82,1.62,1.52-.07-3.52-2,15.76-9.09,15.32,8.84,3.15-.37,14.67-8.47,8.48,4.89,1.23-.24-8.89-5.13,15.76-9.09,15.75,9.09-.38.22,3-.77L366,461.69l4.77,2.75,1.05-.35-5-2.88,15.76-9.09L391,457l.95-.4-8.55-4.93,15.75-9.1,10.4,6,.88-.45-10.46-6,15.75-9.1,10.8,6.23.79-.49-10.76-6.21,15.75-9.1L441.9,429l.73-.53-9.5-5.48,15.75-9.1,6.77,3.91.64-.58-6.59-3.8,15.76-9.1,2.21,1.28.56-.62-2-1.13,5.49-3.17,1.34-1.72-7.65,4.42-15.76-9.1,15.76-9.09,12.36,7.14.45-.69-12-6.93L482,375.57l3.8,2.19c.11-.25.22-.5.34-.75l-3.32-1.91,5.36-3.1c.15-.4.29-.8.43-1.2L482,374.62l-15.75-9.09,15.75-9.1,9.32,5.38c.06-.28.12-.56.19-.84l-8.69-5,10.49-6.06c0-.34.08-.67.11-1L482,355.48l-15.75-9.09,15.75-9.1L493.68,344c0-.31,0-.62,0-.93l-10.85-6.27L492.94,331c0-.3-.09-.59-.13-.88L482,336.35l-15.75-9.1L482,318.16l9.57,5.52c-.09-.36-.17-.73-.25-1.09l-8.5-4.91,6-3.47c-.09-.26-.18-.52-.28-.78L482,317.21l-15.75-9.1L482,299c-.27-.49-.56-1-.83-1.45L466.28,289l6.59-3.81-.51-.65-6.9,4-15.76-9.09,12-7-.6-.6-12.26,7.07-15.75-9.09,15.68-9.06c-1.62-1.31-3.28-2.62-5-3.91l-46-26.58C395.71,229.38,393.61,228.49,391.5,227.62Zm6.84,23.08-15.75,9.1-15.75-9.1,15.75-9.09Zm-65.47,95.22-15.76-9.1,15.76-9.09,15.75,9.09Zm16.57-8.63,15.75,9.1-15.75,9.09-15.75-9.09Zm-198.06-.47,15.75-9.09,15.76,9.09-15.76,9.1Zm14.93,9.57-15.75,9.09-15.75-9.09,15.75-9.1Zm17.4-9.1,15.75,9.1-15.75,9.09L168,346.39Zm99.44-.94-15.76-9.1,15.76-9.09,15.75,9.09Zm16.57-8.62,15.75,9.09-15.75,9.1L284,336.82Zm-17.39,9.09-15.76,9.1-15.75-9.1,15.75-9.09ZM250,336.35l-15.75-9.1L250,318.16l15.75,9.09Zm-.82.47-15.75,9.1-15.76-9.1,15.76-9.09Zm-32.33-.47-15.75-9.1,15.75-9.09,15.76,9.09Zm-.82.47-15.75,9.1-15.75-9.1,15.75-9.09Zm-15.75,10L216,356l-15.75,9.09L184.53,356Zm.82-.47,15.75-9.1,15.76,9.1-15.76,9.09Zm32.33.47,15.75,9.1-15.75,9.09L217.67,356Zm.82-.47,15.75-9.1,15.75,9.1L250,355.48Zm32.32.47,15.76,9.1-15.76,9.09L250.82,356Zm.82-.47,15.76-9.1,15.75,9.1-15.75,9.09Zm32.33.47,15.75,9.1-15.75,9.09L284,356Zm.82-.47,15.75-9.1,15.76,9.1-15.76,9.09Zm16.57-28.71,15.76-9.09,15.75,9.09-15.75,9.1Zm14.94,9.57-15.76,9.1-15.75-9.1,15.75-9.09Zm-32.33-.47L284,317.68l15.75-9.09,15.75,9.09Zm-16.57-9.57-15.76-9.1L283.15,299l15.75,9.09Zm-.82.47-15.76,9.1-15.75-9.1,15.75-9.09ZM250,317.21l-15.75-9.1L250,299l15.75,9.09Zm-.82.47-15.75,9.1-15.76-9.1,15.76-9.09Zm-32.33-.47-15.75-9.1L216.85,299l15.76,9.09Zm-.82.47-15.75,9.1-15.75-9.1,15.75-9.09Zm-16.57,9.57-15.75,9.1L168,327.25l15.76-9.09Zm-32.33-.47-15.75-9.1,15.75-9.09,15.76,9.09Zm-.82.47-15.75,9.1-15.75-9.1,15.75-9.09Zm-16.57,9.57L134,345.92l-15.76-9.1L134,327.73Zm0,19.14L134,365.05,118.23,356l15.76-9.1Zm.82.47,15.75,9.1-15.75,9.09-15.75-9.09Zm.82-.47,15.75-9.1,15.75,9.1-15.75,9.09Zm32.33.47,15.75,9.1-15.75,9.09L168,365.53ZM200.28,366,216,375.1l-15.75,9.09-15.75-9.09Zm.82-.47,15.75-9.1,15.76,9.1-15.76,9.09Zm32.33.47,15.75,9.1-15.75,9.09-15.76-9.09Zm.82-.47,15.75-9.1,15.75,9.1L250,374.62Zm32.32.47,15.76,9.1-15.76,9.09-15.75-9.09Zm.82-.47,15.76-9.1,15.75,9.1-15.75,9.09Zm32.33.47,15.75,9.1-15.75,9.09L284,375.1Zm.82-.47,15.75-9.1,15.76,9.1-15.76,9.09ZM317.11,356l15.76-9.1,15.75,9.1-15.75,9.09Zm32.33.47,15.75,9.1-15.75,9.09-15.75-9.09Zm.82-.47,15.75-9.1,15.76,9.1L366,365.05Zm0-19.14L366,327.73l15.75,9.09L366,345.91Zm-.82-.47-15.75-9.1,15.75-9.09,15.75,9.09Zm-15.75-28.24L349.44,299l15.75,9.09-15.75,9.1Zm-.82-.47-15.75-9.09,15.75-9.1,15.75,9.1Zm-.82.47-15.76,9.1-15.75-9.1L316.29,299Zm-32.33-.47L284,298.55l15.75-9.1,15.75,9.1Zm-16.57-9.57L267.39,289l15.76-9.1L298.9,289Zm-.82.48-15.76,9.09-15.75-9.09,15.75-9.1ZM250,298.07,234.25,289l15.75-9.1,15.75,9.1Zm-.82.48-15.75,9.09-15.76-9.09,15.76-9.1Zm-32.33-.48L201.1,289l15.75-9.1,15.76,9.1Zm-.82.48-15.75,9.09-15.75-9.09,15.75-9.1Zm-16.57,9.56-15.75,9.1L168,308.11,183.71,299Zm-32.33-.47-15.75-9.09,15.75-9.1,15.76,9.1Zm-.82.47-15.75,9.1-15.75-9.1L150.56,299Zm-16.57,9.57L134,326.78l-15.75-9.1L134,308.59Zm-16.58,9.57-15.75,9.1-15.75-9.1,15.75-9.09Zm-16.57,9.57-15.75,9.1-15.75-9.1,15.75-9.09Zm.82.47,15.75,9.1-15.75,9.09-15.75-9.09Zm15.75,28.24-15.75,9.09-15.75-9.09,15.75-9.1Zm.83.47,15.75,9.1L134,384.19l-15.75-9.09Zm16.57,9.57,15.75,9.09-15.75,9.1-15.75-9.1Zm.82-.47,15.75-9.1,15.76,9.1-15.76,9.09Zm32.33.47,15.75,9.09-15.75,9.1L168,384.66Zm16.57,9.57L216,394.23l-15.75,9.1-15.75-9.1Zm.82-.48,15.75-9.09,15.76,9.09-15.76,9.1Zm32.33.48,15.75,9.09-15.75,9.1-15.76-9.1Zm.82-.48L250,375.57l15.75,9.09L250,393.76Zm32.32.48,15.76,9.09-15.76,9.1-15.75-9.1Zm.82-.48,15.76-9.09,15.75,9.09-15.75,9.1Zm32.33.48,15.75,9.09-15.75,9.1L284,394.23Zm.82-.48,15.75-9.09,15.76,9.09-15.76,9.1Zm16.57-9.56,15.76-9.1,15.75,9.1-15.75,9.09Zm32.33.47,15.75,9.09-15.75,9.1-15.75-9.1Zm.82-.47L366,366l15.76,9.1L366,384.19Zm16.58-9.57,15.75-9.1,15.75,9.1-15.75,9.09Zm0-19.14,15.75-9.1,15.75,9.1-15.75,9.09Zm16.57-9.57,15.75-9.09,15.75,9.09-15.75,9.1Zm-.82-.47-15.75-9.1,15.75-9.09,15.75,9.09ZM366,326.78l-15.76-9.1L366,308.59l15.76,9.09Zm-15.76-28.23,15.76-9.1,15.75,9.1L366,307.64Zm-.82-.48L333.69,289l15.75-9.1,15.75,9.1Zm-16.57-9.57-15.76-9.09,15.76-9.1,15.75,9.1Zm-.82.48-15.76,9.09L300.54,289l15.75-9.1Zm-32.33-.48L284,279.41l15.75-9.1,15.75,9.1Zm-16.57-9.57-15.75-9.09,15.75-9.1,15.75,9.1Zm-.82.48-15.76,9.09-15.75-9.09,15.75-9.1ZM250,278.93l-15.75-9.09,15.75-9.1,15.75,9.1Zm-.82.48-15.75,9.09-15.76-9.09,15.76-9.1Zm-32.33-.48-15.75-9.09,15.75-9.1,15.76,9.1Zm-.82.48-15.75,9.09-15.75-9.09,15.75-9.1ZM199.46,289l-15.75,9.09L168,289l15.76-9.1Zm-32.33-.48-15.75-9.09,15.75-9.1,15.76,9.1Zm-.82.48-15.75,9.09L134.81,289l15.75-9.1Zm-16.57,9.57L134,307.64l-15.76-9.09,15.76-9.1Zm-16.58,9.56-15.75,9.1-15.75-9.1L117.41,299Zm-16.57,9.57-15.75,9.1-15.75-9.1,15.75-9.09ZM100,327.25l-15.76,9.1-15.75-9.1,15.75-9.09Zm0,19.14-15.76,9.09-15.75-9.09,15.75-9.1Zm.82.47,15.75,9.1-15.75,9.09L85.09,356Zm15.75,28.24-15.75,9.09L85.09,375.1l15.75-9.1Zm.82.47,15.75,9.09-15.75,9.1-15.75-9.1ZM134,385.14l15.76,9.09L134,403.33l-15.76-9.1Zm16.58,9.57,15.75,9.09-15.75,9.1-15.75-9.1Zm.82-.48,15.75-9.09,15.76,9.09-15.76,9.1Zm32.33.48,15.75,9.09-15.75,9.1L168,403.8Zm16.57,9.57L216,413.37l-15.75,9.1-15.75-9.1Zm.82-.48,15.75-9.09,15.76,9.09-15.76,9.1Zm32.33.48,15.75,9.09-15.75,9.1-15.76-9.1Zm.82-.48L250,394.71l15.75,9.09L250,412.9Zm32.32.48,15.76,9.09-15.76,9.1-15.75-9.1Zm.82-.48,15.76-9.09,15.75,9.09-15.75,9.1Zm32.33.48,15.75,9.09-15.75,9.1L284,413.37Zm.82-.48,15.75-9.09,15.76,9.09-15.76,9.1Zm16.57-9.57,15.76-9.09,15.75,9.09-15.75,9.1Zm32.33.48,15.75,9.09-15.75,9.1-15.75-9.1Zm.82-.48L366,385.14l15.76,9.09L366,403.33Zm16.58-9.57,15.75-9.09,15.75,9.09-15.75,9.1Zm16.57-9.56,15.75-9.1,15.75,9.1-15.75,9.09Zm0-19.14,15.75-9.1,15.75,9.1-15.75,9.09ZM400,346.39l15.76-9.1,15.75,9.1-15.75,9.09Zm0-19.14,15.76-9.09,15.75,9.09-15.75,9.1Zm-.82-.47-15.75-9.1,15.75-9.09,15.75,9.09Zm-16.57-9.57-15.75-9.1L382.59,299l15.75,9.09ZM366.84,289l15.75-9.1,15.75,9.1-15.75,9.09Zm-.82-.48-15.76-9.09,15.76-9.1,15.75,9.1Zm-16.58-9.57-15.75-9.09,15.75-9.1,15.75,9.1Zm-16.57-9.57-15.75-9.09,15.75-9.09,15.75,9.09Zm-.82.48-15.76,9.09-15.75-9.09,15.75-9.1Zm-32.33-.47L284,260.27l15.75-9.09,15.75,9.09Zm-16.57-9.57-15.76-9.1,15.76-9.09,15.75,9.09Zm-.82.47-15.76,9.1-15.75-9.1,15.75-9.09ZM250,259.8l-15.75-9.1L250,241.61l15.75,9.09Zm-.82.47-15.75,9.1-15.76-9.1,15.76-9.09Zm-32.33-.47-15.75-9.1,15.75-9.09,15.76,9.09Zm-.82.47-15.75,9.1-15.75-9.1,15.75-9.09Zm-16.57,9.57-15.75,9.09L168,269.84l15.76-9.1Zm-32.33-.47-15.75-9.1,15.75-9.09,15.76,9.09Zm-.82.47-15.75,9.09-15.75-9.09,15.75-9.1Zm-16.57,9.57L134,288.5l-15.76-9.09,15.76-9.1ZM133.16,289l-15.75,9.09L101.66,289l15.75-9.1Zm-32.32-.48-15.75-9.09,15.75-9.1,15.75,9.1Zm15.75,10.05-15.75,9.09-15.75-9.09,15.75-9.1ZM100,308.11l-15.76,9.1-15.75-9.1L84.26,299Zm-16.58,9.57-15.75,9.1-15.75-9.1,15.75-9.09Zm0,19.14-15.75,9.1-15.75-9.1,15.75-9.09Zm0,19.14-15.75,9.09L51.94,356l15.75-9.1Zm.82.47,15.76,9.1-15.76,9.09-15.75-9.09ZM100,384.66l-15.76,9.1-15.75-9.1,15.75-9.09Zm.82.48,15.75,9.09-15.75,9.1-15.75-9.1Zm16.57,9.57,15.75,9.09-15.75,9.1-15.75-9.1ZM134,404.28l15.75,9.09L134,422.47l-15.75-9.1Zm16.57,9.56,15.75,9.1L150.56,432l-15.75-9.09Zm.82-.47,15.75-9.09,15.75,9.09-15.75,9.1Zm32.33.47,15.75,9.1L183.71,432,168,422.94Zm16.57,9.57,15.75,9.1-15.75,9.09-15.75-9.09Zm.82-.47,15.75-9.1,15.76,9.1L216.85,432Zm32.33.47,15.75,9.1-15.75,9.09-15.76-9.09Zm.82-.47,15.75-9.1,15.75,9.1L250,432Zm32.32.47,15.76,9.1-15.76,9.09-15.75-9.09Zm.82-.47,15.76-9.1,15.75,9.1L283.15,432Zm32.33.47,15.75,9.1-15.75,9.09L284,432.51Zm.82-.47,15.75-9.1,15.76,9.1L316.29,432Zm16.57-9.57,15.76-9.09,15.75,9.09-15.75,9.1Zm32.33.47,15.75,9.1L349.44,432l-15.75-9.09Zm.82-.47L366,404.28l15.76,9.09L366,422.47Zm16.58-9.57,15.75-9.09,15.75,9.09-15.75,9.1Zm16.57-9.57,15.75-9.09,15.75,9.09-15.75,9.1ZM400,384.66l15.76-9.09,15.75,9.09-15.75,9.1Zm0-19.13,15.76-9.1,15.75,9.1-15.75,9.09ZM416.56,356l15.75-9.1,15.75,9.1-15.75,9.09Zm0-19.14,15.75-9.09,15.75,9.09-15.75,9.1Zm0-19.14,15.75-9.09,15.75,9.09-15.75,9.1Zm-.82-.47L400,308.11,415.74,299l15.75,9.09Zm-16.58-9.57-15.75-9.09,15.75-9.1,15.76,9.1Zm-15.75-28.23,15.75-9.1,15.75,9.1-15.75,9.09Zm-.82-.48-15.75-9.09,15.75-9.1,15.75,9.1ZM366,269.37l-15.76-9.1L366,251.18l15.76,9.09Zm-16.58-9.57-15.75-9.1,15.75-9.09,15.75,9.09Zm-16.57-9.57-15.75-9.1L332.87,232l15.75,9.09Zm-.82.47-15.76,9.1-15.75-9.1,15.76-9.09Zm-32.33-.47L284,241.13,299.72,232l15.75,9.09Zm-16.57-9.57-15.76-9.1,15.76-9.09,15.75,9.09Zm-.82.47-15.76,9.1-15.75-9.1L266.57,232ZM250,240.66l-15.75-9.1L250,222.47l15.75,9.09Zm-.82.47-15.75,9.1-15.76-9.1L233.43,232Zm-32.33-.47-15.75-9.1,15.75-9.09,15.76,9.09Zm-.82.47-15.75,9.1-15.75-9.1L200.28,232Zm-16.57,9.57-15.75,9.1L168,250.7l15.76-9.09Zm-32.33-.47-15.75-9.1L167.13,232l15.76,9.09Zm-.82.47-15.75,9.1-15.75-9.1,15.75-9.09Zm-16.57,9.57L134,269.37l-15.76-9.1L134,251.18Zm-16.57,9.57-15.76,9.09-15.75-9.09,15.75-9.1Zm-32.33-.47-15.75-9.1,15.75-9.09,15.75,9.09Zm-.82.47-15.76,9.09-15.75-9.09,15.75-9.1ZM100,289l-15.76,9.09L68.51,289l15.75-9.1Zm-16.58,9.57-15.75,9.09-15.75-9.09,15.75-9.1Zm-16.57,9.56-15.75,9.1-15.75-9.1L51.12,299Zm0,19.14-15.75,9.1-15.76-9.1,15.76-9.09Zm0,19.14-15.75,9.09-15.76-9.09,15.76-9.1Zm0,19.14-15.75,9.09-15.76-9.09,15.76-9.1Zm.82.47,15.75,9.1-15.75,9.09L51.94,375.1Zm15.75,28.23-15.75,9.1-15.75-9.1,15.75-9.09Zm.82.48L100,403.8l-15.76,9.1-15.75-9.1Zm16.58,9.57,15.75,9.09-15.75,9.1-15.76-9.1Zm16.57,9.56,15.75,9.1L117.41,432l-15.75-9.09ZM134,423.41l15.76,9.1L134,441.6l-15.75-9.09ZM150.56,433l15.75,9.1-15.75,9.09-15.75-9.09Zm.82-.47,15.75-9.1,15.76,9.1-15.76,9.09Zm32.33.47,15.75,9.1-15.75,9.09L168,442.08Zm16.57,9.57,15.75,9.1-15.75,9.09-15.75-9.09Zm.82-.47,15.75-9.1,15.76,9.1-15.76,9.09Zm32.33.47,15.75,9.1-15.75,9.09-15.76-9.09Zm.82-.47L250,433l15.75,9.1L250,451.17Zm32.32.47,15.76,9.1-15.76,9.09-15.75-9.09Zm.82-.47,15.76-9.1,15.75,9.1-15.75,9.09Zm32.33.47,15.75,9.1-15.75,9.09L284,451.65Zm.82-.47,15.75-9.1,15.76,9.1-15.76,9.09Zm16.57-9.57,15.76-9.1,15.75,9.1-15.75,9.09Zm32.33.47,15.75,9.1-15.75,9.09-15.75-9.09Zm.82-.47,15.75-9.1,15.76,9.1L366,441.6Zm16.58-9.57,15.75-9.1,15.75,9.1L382.59,432Zm16.57-9.57,15.75-9.09,15.75,9.09-15.75,9.1ZM400,403.8l15.76-9.09,15.75,9.09-15.76,9.1Zm16.58-9.57,15.75-9.09,15.75,9.09-15.75,9.1Zm0-19.13,15.75-9.1,15.75,9.1-15.75,9.09Zm16.57-9.57,15.75-9.1,15.76,9.1-15.76,9.09Zm0-19.14,15.75-9.1,15.76,9.1-15.76,9.09Zm0-19.14,15.75-9.09,15.76,9.09-15.76,9.1Zm0-19.14L448.88,299l15.76,9.09-15.76,9.1Zm-.82-.47-15.75-9.09,15.75-9.1,15.75,9.1Zm-16.57-9.57L400,289l15.76-9.1,15.75,9.1ZM400,269.84l15.76-9.1,15.75,9.1-15.75,9.09Zm-.82-.47-15.75-9.1,15.75-9.09,15.76,9.09Zm-17.39-28.24L366,250.23l-15.75-9.1L366,232Zm-16.58-9.57-15.75,9.1-15.75-9.1,15.75-9.09ZM332.87,212.9l15.75,9.1-15.75,9.09L317.11,222Zm-.82,18.66-15.75,9.1-15.76-9.1,15.75-9.09ZM315.47,222l-15.75,9.09L284,222l15.75-9.1Zm-32.32-18.67,15.75,9.1-15.75,9.09-15.75-9.09ZM282.33,222l-15.76,9.09L250.82,222l15.76-9.1ZM250,203.33l15.75,9.1L250,221.52l-15.75-9.09ZM249.18,222l-15.75,9.09L217.67,222l15.76-9.1Zm-32.33-18.67,15.76,9.1-15.76,9.09-15.75-9.09Zm-16.57,9.57L216,222l-15.75,9.09L184.53,222Zm-.82,18.66-15.75,9.1L168,231.56l15.76-9.09ZM167.13,212.9l15.76,9.1-15.76,9.09L151.38,222Zm-16.57,9.57,15.75,9.09-15.75,9.1-15.75-9.1ZM134,232l15.75,9.09L134,250.23l-15.76-9.1Zm-.82,18.66-15.76,9.1-15.75-9.1,15.75-9.09ZM100.84,232l15.75,9.09-15.75,9.1-15.75-9.1Zm-16.57,9.57L100,250.7l-15.76,9.1-15.75-9.1ZM51.94,260.27l15.75-9.09,15.75,9.09-15.75,9.1Zm15.75,10,15.75,9.1L67.69,288.5l-15.75-9.09Zm-16.57,9.57L66.87,289l-15.75,9.09L35.36,289ZM18.79,298.55l15.75-9.1,15.76,9.1-15.76,9.09Zm0,19.13,15.75-9.09,15.76,9.09-15.76,9.1Zm0,19.14,15.75-9.09,15.76,9.09-15.76,9.1Zm0,19.14,15.75-9.1L50.3,356l-15.76,9.09Zm0,19.14L34.54,366l15.76,9.1-15.76,9.09Zm16.57,9.56,15.76-9.09,15.75,9.09-15.75,9.1Zm0,19.14,15.76-9.09,15.75,9.09-15.75,9.1Zm16.58,9.57,15.75-9.09,15.75,9.09-15.75,9.1Zm16.57,9.57,15.75-9.1,15.76,9.1L84.26,432Zm16.58,9.57,15.75-9.1,15.75,9.1-15.75,9.09Zm16.57,9.57,15.75-9.1,15.75,9.1-15.75,9.09Zm16.57,9.57,15.75-9.1,15.76,9.1L134,460.74Zm32.33,18.66-15.75-9.1,15.75-9.09,15.75,9.09Zm.82-18.66,15.75-9.1,15.75,9.1-15.75,9.09ZM168,461.21l15.76-9.09,15.75,9.09-15.76,9.1Zm32.33,18.67-15.75-9.1,15.75-9.09L216,470.78Zm.82-18.67,15.75-9.09,15.76,9.09-15.76,9.1Zm32.33,18.67-15.76-9.1,15.76-9.09,15.75,9.09Zm.82-18.67L250,452.12l15.75,9.09L250,470.31Zm32.32,18.67-15.75-9.1,15.75-9.09,15.76,9.09Zm.82-18.67,15.76-9.09,15.75,9.09-15.75,9.1Zm32.33,18.67L284,470.78l15.75-9.09,15.75,9.09Zm16.57-9.57-15.75-9.1,15.75-9.09,15.76,9.09Zm.82-18.66,15.76-9.1,15.75,9.1-15.75,9.09Zm32.33,18.66-15.75-9.1,15.75-9.09,15.75,9.09ZM366,460.74l-15.75-9.09,15.75-9.1,15.76,9.1Zm16.58-9.57-15.76-9.09,15.76-9.1,15.75,9.1Zm16.57-9.57-15.75-9.09,15.75-9.1,15.75,9.1ZM415.73,432,400,422.94l15.75-9.1,15.76,9.1Zm16.58-9.56-15.75-9.1,15.75-9.09,15.75,9.09Zm32.32-18.67-15.75,9.1-15.75-9.1,15.75-9.09Zm-15.75-10-15.75-9.1,15.75-9.09,15.76,9.09Zm32.33-18.66-15.75,9.09L449.7,375.1l15.76-9.1Zm0-19.14-15.75,9.09L449.7,356l15.76-9.1Zm0-19.14-15.75,9.09-15.76-9.09,15.76-9.09Zm0-19.14-15.75,9.1-15.76-9.1,15.76-9.09Zm0-19.13-15.75,9.09-15.76-9.09,15.76-9.1ZM464.64,289l-15.76,9.09L433.13,289l15.75-9.1Zm-16.58-9.57-15.75,9.09-15.75-9.09,15.75-9.1Zm0-19.14-15.75,9.09-15.75-9.09,15.75-9.09Zm-16.57-9.57-15.75,9.1L400,250.7l15.76-9.09Zm-16.58-9.57-15.75,9.1-15.75-9.1L399.16,232Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "249.99px 342.15px 0px",
            }}
            id="el3csq8x3ya6n"
            className="animable"
          ></path>
        </g>
      </g>
      <g
        id="freepik--Shadows--inject-9"
        style={{ transformOrigin: "252.138px 374.969px 0px" }}
        className="animable"
      >
        <path
          id="freepik--Shadow--inject-9"
          d="M152.28,361.13l-56,32.29a5.34,5.34,0,0,1-4.86,0L35.54,361.13c-1.34-.78-1.34-2,0-2.81l56-32.3a5.4,5.4,0,0,1,4.86,0l55.9,32.3C153.62,359.1,153.62,360.35,152.28,361.13Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "93.9113px 359.724px 0px",
          }}
          className="animable"
        ></path>
        <path
          id="freepik--shadow--inject-9"
          d="M468.54,346.8l-65.47,37.81a6.42,6.42,0,0,1-5.79,0l-97-56c-1.6-.93-1.6-2.42,0-3.34l65.48-37.81a6.42,6.42,0,0,1,5.79,0l97,56C470.14,344.38,470.14,345.88,468.54,346.8Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "384.411px 336.035px 0px",
          }}
          className="animable"
        ></path>
        <path
          id="freepik--shadow--inject-9"
          d="M174.54,433.7l78.62-45.38a5.27,5.27,0,0,1,4.74,0l44.41,25.58c1.77,1,1.77,2.69,0,3.71l-78.06,45.06a4.63,4.63,0,0,1-4.18,0l-45.54-26.23C173.24,435.68,173.24,434.45,174.54,433.7Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "238.601px 425.463px 0px",
          }}
          className="animable"
        ></path>
      </g>
      <g
        id="freepik--device-2--inject-9"
        style={{ transformOrigin: "240.443px 422.283px 0px" }}
        className="animable"
      >
        <g
          id="freepik--Mobile--inject-9"
          style={{ transformOrigin: "240.443px 422.283px 0px" }}
          className="animable"
        >
          <g
            id="freepik--mobile--inject-9"
            style={{ transformOrigin: "240.443px 422.283px 0px" }}
            className="animable"
          >
            <path
              d="M255.58,386l-74.15,42.79a3.64,3.64,0,0,0-2.06,3.79,4.42,4.42,0,0,0,2.06,3.8l38.64,22.31a6,6,0,0,0,5.47,0l74.15-42.78a3.83,3.83,0,0,0,1.85-3.56c0-1.23-.34-3.17-1.85-4L261.05,386A5.16,5.16,0,0,0,255.58,386Z"
              style={{
                fill: "rgb(55, 71, 79)",
                transformOrigin: "240.443px 422.283px 0px",
              }}
              id="ela453rdqld07"
              className="animable"
            ></path>
            <path
              d="M257.58,387.64l39.74,22.94-74.51,43v5.74a5.54,5.54,0,0,0,2.73-.66l74.15-42.78a3.83,3.83,0,0,0,1.85-3.56c0-1.23-.34-3.17-1.85-4L261.05,386a5.26,5.26,0,0,0-3.47-.73v2.42Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "262.18px 422.271px 0px",
              }}
              id="elbdtoxo36yk"
              className="animable"
            ></path>
            <path
              d="M182.13,431.57l38.76,22.37a4.27,4.27,0,0,0,3.83,0l73.5-42.41c1.62-.93,1.61-2.47,0-3.4l-37.72-21.78a4.83,4.83,0,0,0-4.35,0l-74,42.7A1.33,1.33,0,0,0,182.13,431.57Z"
              style={{
                fill: "rgb(69, 90, 100)",
                transformOrigin: "240.333px 420.113px 0px",
              }}
              id="elz7j7bp4z41l"
              className="animable"
            ></path>
            <path
              d="M275.23,426a2.33,2.33,0,0,0-1.07,1.79.68.68,0,0,0,.29.63l.76.44a.79.79,0,0,0,.78-.09l6.6-3.81a2.35,2.35,0,0,0,1.08-1.79.7.7,0,0,0-.28-.62l-.77-.45a.78.78,0,0,0-.78.09Z"
              style={{
                fill: "rgb(69, 90, 100)",
                transformOrigin: "278.914px 425.479px 0px",
              }}
              id="elbohcojde1m"
              className="animable"
            ></path>
            <path
              d="M276,426.42l6.6-3.82c.59-.34,1.08-.1,1.08.55a2.35,2.35,0,0,1-1.08,1.79l-6.6,3.81c-.6.34-1.08.1-1.08-.55A2.29,2.29,0,0,1,276,426.42Z"
              style={{
                fill: "rgb(55, 71, 79)",
                transformOrigin: "279.3px 425.675px 0px",
              }}
              id="elp6hkxs2zilr"
              className="animable"
            ></path>
            <path
              d="M286.79,419.31a2.3,2.3,0,0,0-1.07,1.79.69.69,0,0,0,.29.63l.76.43a.79.79,0,0,0,.77-.08l6.61-3.82a2.3,2.3,0,0,0,1.07-1.78.69.69,0,0,0-.27-.62c-.13-.08-.64-.38-.78-.45a.77.77,0,0,0-.77.09Z"
              style={{
                fill: "rgb(69, 90, 100)",
                transformOrigin: "290.47px 418.785px 0px",
              }}
              id="elm9z8q9wi8v"
              className="animable"
            ></path>
            <path
              d="M287.54,419.74l6.61-3.81c.59-.34,1.07-.1,1.07.55a2.3,2.3,0,0,1-1.07,1.78l-6.61,3.82c-.59.34-1.07.1-1.07-.55A2.33,2.33,0,0,1,287.54,419.74Z"
              style={{
                fill: "rgb(55, 71, 79)",
                transformOrigin: "290.845px 419.005px 0px",
              }}
              id="elfdx38xb9leo"
              className="animable"
            ></path>
            <path
              d="M254.37,389.1l-68.52,39.53a1.27,1.27,0,0,0,0,2.4l35.07,20.24a4.58,4.58,0,0,0,4.14,0l69.07-39.85c.93-.54,1.11-1.35.53-2,0-.05-.09-.1-.15-.15a4.17,4.17,0,0,0-.38-.27l-9.86-5.69-.64-.37a1.4,1.4,0,0,0-1.29,0,1.49,1.49,0,0,1-1.33,0l-11.49-6.63c-.38-.22-.4-.56-.05-.77s.36-.5.07-.7l-.06,0-9.65-5.57-.21-.12A5.82,5.82,0,0,0,254.37,389.1Z"
              id="eljlbatm4vsw"
              style={{ transformOrigin: "239.994px 420.132px 0px" }}
              className="animable"
            ></path>
            <path
              d="M282.33,404.43a1.46,1.46,0,0,1,1.29,0l.64.38,9.86,5.69a2.16,2.16,0,0,1,.38.27,1,1,0,0,1,.15.14l0,0a2,2,0,0,1-.56.46l-69.07,39.85a4.58,4.58,0,0,1-4.14,0L185.84,431a2.42,2.42,0,0,1-.56-.46,2.08,2.08,0,0,1,.57-.46l68.52-39.54a5.82,5.82,0,0,1,5.24,0l.21.12,9.39,5.42v1.26a.49.49,0,0,0,.3.4L281,404.41A1.45,1.45,0,0,0,282.33,404.43Z"
              style={{
                fill: "rgb(255, 255, 255)",
                transformOrigin: "239.965px 420.816px 0px",
              }}
              id="elyl6h8i2jlbi"
              className="animable"
            ></path>
            <path
              d="M281.42,400.68l-5.27-3a1.16,1.16,0,0,0-1.1,0c-.3.17-.28.45,0,.63l5.27,3a1.19,1.19,0,0,0,1.1,0C281.75,401.14,281.73,400.86,281.42,400.68Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "278.246px 399.493px 0px",
              }}
              id="el2oev2dnqgm"
              className="animable"
            ></path>
            <path
              d="M273.66,396a1.44,1.44,0,0,0-1.28,0,.39.39,0,0,0,0,.74,1.44,1.44,0,0,0,1.28,0A.39.39,0,0,0,273.66,396Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "273.02px 396.37px 0px",
              }}
              id="elo3u0uchrnt"
              className="animable"
            ></path>
          </g>
        </g>
      </g>
      <g
        id="freepik--Charts--inject-9"
        style={{ transformOrigin: "237.875px 398.42px 0px" }}
        className="animable"
      >
        <g
          id="freepik--Graphs--inject-9"
          style={{ transformOrigin: "237.875px 398.42px 0px" }}
          className="animable"
        >
          <g
            id="freepik--bar-graph--inject-9"
            style={{ transformOrigin: "232.034px 394.613px 0px" }}
            className="animable"
          >
            <g id="elaea9xn9sue8">
              <g
                style={{
                  opacity: "0.3",
                  transformOrigin: "240.38px 414.228px 0px",
                }}
                className="animable"
              >
                <path
                  d="M239.27,420.11l-.07,0L230.29,415a.15.15,0,0,1-.07-.12.14.14,0,0,1,.07-.12l11.14-6.43a.15.15,0,0,1,.13,0l8.91,5.14a.15.15,0,0,1,.07.12.14.14,0,0,1-.07.12l-11.13,6.43Zm-8.64-5.28,8.64,5,10.86-6.27-8.64-5Z"
                  style={{
                    fill: "rgb(143, 18, 35)",
                    transformOrigin: "240.38px 414.228px 0px",
                  }}
                  id="el4xdi372f9ma"
                  className="animable"
                ></path>
              </g>
            </g>
            <polygon
              points="239.27 418.69 239.26 384.01 232.59 380.16 232.59 414.83 239.27 418.69"
              style={{
                fill: "rgb(143, 18, 35)",
                transformOrigin: "235.93px 399.425px 0px",
              }}
              id="el0j5wjlw67owg"
              className="animable"
            ></polygon>
            <g id="elygta0n12jvi">
              <polygon
                points="239.27 418.69 239.26 384.01 232.59 380.16 232.59 414.83 239.27 418.69"
                style={{
                  opacity: "0.2",
                  transformOrigin: "235.93px 399.425px 0px",
                }}
                className="animable"
              ></polygon>
            </g>
            <polygon
              points="239.27 418.69 248.17 413.54 248.18 378.87 239.26 384.01 239.27 418.69"
              style={{
                fill: "rgb(143, 18, 35)",
                transformOrigin: "243.72px 398.78px 0px",
              }}
              id="el8fvfbcn0yu6"
              className="animable"
            ></polygon>
            <polygon
              points="248.18 378.87 241.5 375.01 232.59 380.16 239.26 384.01 248.18 378.87"
              style={{
                fill: "rgb(143, 18, 35)",
                transformOrigin: "240.385px 379.51px 0px",
              }}
              id="elci6qgcro6r"
              className="animable"
            ></polygon>
            <g id="elsoelyaouovb">
              <polygon
                points="248.18 378.87 241.5 375.01 232.59 380.16 239.26 384.01 248.18 378.87"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: "0.25",
                  transformOrigin: "240.385px 379.51px 0px",
                }}
                className="animable"
              ></polygon>
            </g>
            <g id="elgrsin0swqsf">
              <path
                d="M248.18,378.87l-9,5-2.92-1.63-3.67-2,3.6,2.15,3,1.77c-.07,1-.09,30.53-.08,31.53a26.54,26.54,0,0,0,.2,3.08,26.52,26.52,0,0,0,.19-3.08c0-1,0-30.46-.07-31.44Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: "0.3",
                  transformOrigin: "240.385px 398.82px 0px",
                }}
                className="animable"
              ></path>
            </g>
            <g id="elz1jdoj0x3zk">
              <g
                style={{
                  opacity: "0.3",
                  transformOrigin: "223.681px 423.837px 0px",
                }}
                className="animable"
              >
                <path
                  d="M222.57,429.75l-.07,0-8.91-5.14a.14.14,0,0,1,0-.24l11.13-6.43a.17.17,0,0,1,.14,0l8.91,5.15a.14.14,0,0,1,.07.12.14.14,0,0,1-.07.11l-11.14,6.43Zm-8.64-5.28,8.64,5,10.86-6.27-8.64-5Z"
                  style={{
                    fill: "rgb(143, 18, 35)",
                    transformOrigin: "223.681px 423.837px 0px",
                  }}
                  id="eltykcsr1uyy"
                  className="animable"
                ></path>
              </g>
            </g>
            <polygon
              points="222.57 428.33 222.56 407.35 215.88 403.5 215.88 424.47 222.57 428.33"
              style={{
                fill: "rgb(143, 18, 35)",
                transformOrigin: "219.225px 415.915px 0px",
              }}
              id="el797qloo02nu"
              className="animable"
            ></polygon>
            <g id="eliskegvlgrz">
              <polygon
                points="222.57 428.33 222.56 407.35 215.88 403.5 215.88 424.47 222.57 428.33"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: "0.1",
                  transformOrigin: "219.225px 415.915px 0px",
                }}
                className="animable"
              ></polygon>
            </g>
            <polygon
              points="222.57 428.33 231.47 423.19 231.47 402.21 222.56 407.35 222.57 428.33"
              style={{
                fill: "rgb(143, 18, 35)",
                transformOrigin: "227.015px 415.27px 0px",
              }}
              id="elga0rhezxj4q"
              className="animable"
            ></polygon>
            <g id="elhzpn8nja7qo">
              <polygon
                points="222.57 428.33 231.47 423.19 231.47 402.21 222.56 407.35 222.57 428.33"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: "0.3",
                  transformOrigin: "227.015px 415.27px 0px",
                }}
                className="animable"
              ></polygon>
            </g>
            <polygon
              points="231.47 402.21 224.79 398.36 215.88 403.5 222.56 407.35 231.47 402.21"
              style={{
                fill: "rgb(143, 18, 35)",
                transformOrigin: "223.675px 402.855px 0px",
              }}
              id="elo6b198eevt"
              className="animable"
            ></polygon>
            <g id="elh8esd7x75iu">
              <polygon
                points="231.47 402.21 224.79 398.36 215.88 403.5 222.56 407.35 231.47 402.21"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: "0.55",
                  transformOrigin: "223.675px 402.855px 0px",
                }}
                className="animable"
              ></polygon>
            </g>
            <g id="el7z9gj9z2bqd">
              <path
                d="M222.68,407.52l8.79-5.31-9,5-2.92-1.63-3.67-2,3.61,2.15c1,.59,2,1.19,3,1.77,0,1-.06,6.06-.07,7.1s0,6.38,0,7.44,0,2.12.06,3.18.07,2.13.14,3.19c.06-1.06.11-2.12.13-3.19s.06-2.12.06-3.18,0-6.38,0-7.44S222.71,408.52,222.68,407.52Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: "0.3",
                  transformOrigin: "223.675px 415.31px 0px",
                }}
                className="animable"
              ></path>
            </g>
            <g id="el7tuhrgm98ea">
              <g
                style={{
                  opacity: "0.3",
                  transformOrigin: "206.97px 433.472px 0px",
                }}
                className="animable"
              >
                <path
                  d="M205.86,439.39a.07.07,0,0,1-.06,0l-8.91-5.14a.14.14,0,0,1-.07-.12.15.15,0,0,1,.07-.12L208,427.57a.12.12,0,0,1,.14,0l8.91,5.14a.14.14,0,0,1,.07.12.15.15,0,0,1-.07.12l-11.14,6.42A.08.08,0,0,1,205.86,439.39Zm-8.63-5.28,8.63,5,10.86-6.27-8.63-5Z"
                  style={{
                    fill: "rgb(143, 18, 35)",
                    transformOrigin: "206.97px 433.472px 0px",
                  }}
                  id="elrrkczpp5ng"
                  className="animable"
                ></path>
              </g>
            </g>
            <polygon
              points="205.86 437.97 205.86 428.25 199.18 424.39 199.18 434.11 205.86 437.97"
              style={{
                fill: "rgb(143, 18, 35)",
                transformOrigin: "202.52px 431.18px 0px",
              }}
              id="elxyf05a1pi9n"
              className="animable"
            ></polygon>
            <g id="eljy8j7rkr01">
              <polygon
                points="205.86 437.97 205.86 428.25 199.18 424.39 199.18 434.11 205.86 437.97"
                style={{
                  opacity: "0.45",
                  transformOrigin: "202.52px 431.18px 0px",
                }}
                className="animable"
              ></polygon>
            </g>
            <polygon
              points="205.86 437.97 214.77 432.83 214.77 423.11 205.86 428.25 205.86 437.97"
              style={{
                fill: "rgb(143, 18, 35)",
                transformOrigin: "210.315px 430.54px 0px",
              }}
              id="el3y4mxt3b9i8"
              className="animable"
            ></polygon>
            <g id="elur4p7ma25gm">
              <polygon
                points="205.86 437.97 214.77 432.83 214.77 423.11 205.86 428.25 205.86 437.97"
                style={{
                  opacity: "0.3",
                  transformOrigin: "210.315px 430.54px 0px",
                }}
                className="animable"
              ></polygon>
            </g>
            <polygon
              points="214.77 423.11 208.09 419.25 199.18 424.39 205.86 428.25 214.77 423.11"
              style={{
                fill: "rgb(143, 18, 35)",
                transformOrigin: "206.975px 423.75px 0px",
              }}
              id="elmue5m7d35y"
              className="animable"
            ></polygon>
            <g id="elci6fyxg97in">
              <polygon
                points="214.77 423.11 208.09 419.25 199.18 424.39 205.86 428.25 214.77 423.11"
                style={{
                  opacity: "0.15",
                  transformOrigin: "206.975px 423.75px 0px",
                }}
                className="animable"
              ></polygon>
            </g>
            <g id="el9f1fdt8l87c">
              <path
                d="M214.77,423.11l-9,5-2.93-1.63-3.67-2.05,3.61,2.16,3,1.76c-.07.61-.09,7.16-.07,7.77a10.1,10.1,0,0,0,.19,1.89,9.34,9.34,0,0,0,.2-1.89c0-.58,0-7.1-.07-7.67Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: "0.3",
                  transformOrigin: "206.97px 430.56px 0px",
                }}
                className="animable"
              ></path>
            </g>
            <g id="el9902d97ajeq">
              <g
                style={{
                  opacity: "0.3",
                  transformOrigin: "257.089px 404.544px 0px",
                }}
                className="animable"
              >
                <path
                  d="M256,410.47l-.07,0L247,405.3a.14.14,0,0,1-.07-.11.14.14,0,0,1,.07-.12l11.14-6.43a.11.11,0,0,1,.13,0l8.91,5.14a.14.14,0,0,1,0,.24L256,410.45Zm-8.64-5.28,8.64,5,10.86-6.27-8.64-5Z"
                  style={{
                    fill: "rgb(143, 18, 35)",
                    transformOrigin: "257.089px 404.544px 0px",
                  }}
                  id="elzna01o3vgo"
                  className="animable"
                ></path>
              </g>
            </g>
            <polygon
              points="255.97 409.04 255.97 358.83 249.29 354.97 249.29 405.19 255.97 409.04"
              style={{
                fill: "rgb(143, 18, 35)",
                transformOrigin: "252.63px 382.005px 0px",
              }}
              id="eloix9d989y2p"
              className="animable"
            ></polygon>
            <g id="ellt8kcsbhanh">
              <polygon
                points="255.97 409.04 255.97 358.83 249.29 354.97 249.29 405.19 255.97 409.04"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: "0.3",
                  transformOrigin: "252.63px 382.005px 0px",
                }}
                className="animable"
              ></polygon>
            </g>
            <polygon
              points="255.97 409.04 264.88 403.9 264.88 353.69 255.97 358.83 255.97 409.04"
              style={{
                fill: "rgb(143, 18, 35)",
                transformOrigin: "260.425px 381.365px 0px",
              }}
              id="els95706wtkkk"
              className="animable"
            ></polygon>
            <g id="elxjz1dktb1jj">
              <polygon
                points="255.97 409.04 264.88 403.9 264.88 353.69 255.97 358.83 255.97 409.04"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: "0.55",
                  transformOrigin: "260.425px 381.365px 0px",
                }}
                className="animable"
              ></polygon>
            </g>
            <polygon
              points="264.88 353.69 258.2 349.83 249.29 354.97 255.97 358.83 264.88 353.69"
              style={{
                fill: "rgb(143, 18, 35)",
                transformOrigin: "257.085px 354.33px 0px",
              }}
              id="el84a4s9mkb19"
              className="animable"
            ></polygon>
            <g id="elzxmc9fa0oti">
              <polygon
                points="264.88 353.69 258.2 349.83 249.29 354.97 255.97 358.83 264.88 353.69"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: "0.75",
                  transformOrigin: "257.085px 354.33px 0px",
                }}
                className="animable"
              ></polygon>
            </g>
            <g id="el10g6xrxzlpll">
              <path
                d="M256.08,359l8.8-5.31-9,5L253,357l-3.67-2,3.6,2.16,3,1.76c0,1.18-.06,2.36-.07,3.54s0,38.21,0,39.41,0,2.4.06,3.6.07,2.4.14,3.6c.07-1.2.11-2.4.14-3.6s.05-2.4.05-3.6,0-38.21,0-39.41S256.12,360.14,256.08,359Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: "0.3",
                  transformOrigin: "257.105px 381.38px 0px",
                }}
                className="animable"
              ></path>
            </g>
          </g>
          <g
            id="freepik--Graph--inject-9"
            style={{ transformOrigin: "248.303px 404.077px 0px" }}
            className="animable"
          >
            <path
              d="M272.83,371.88h-.06a.12.12,0,0,1,0-.17l4.3-8.22a.12.12,0,1,1,.22.11l-4.3,8.22A.12.12,0,0,1,272.83,371.88Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "275.019px 367.657px 0px",
              }}
              id="elrqku2qkrywe"
              className="animable"
            ></path>
            <path
              d="M267.17,389.47h0a.13.13,0,0,1-.08-.16L271.77,374a.14.14,0,0,1,.16-.08.13.13,0,0,1,.09.16l-4.73,15.32A.12.12,0,0,1,267.17,389.47Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "269.555px 381.693px 0px",
              }}
              id="elwpxfqvdcxl"
              className="animable"
            ></path>
            <path
              d="M266.24,390.21a.13.13,0,0,1-.08,0l-4.3-3.25a.13.13,0,0,1,0-.18.12.12,0,0,1,.17,0l4.31,3.25a.14.14,0,0,1,0,.18A.12.12,0,0,1,266.24,390.21Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "264.098px 388.483px 0px",
              }}
              id="el9a1z3w7jqm7"
              className="animable"
            ></path>
            <path
              d="M256.34,400.3h0a.12.12,0,0,1-.07-.16l4.59-12.62a.13.13,0,0,1,.17-.07.13.13,0,0,1,.07.16l-4.6,12.61A.14.14,0,0,1,256.34,400.3Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "258.684px 393.872px 0px",
              }}
              id="ela5lh65dhmf"
              className="animable"
            ></path>
            <path
              d="M255.24,401.28h0l-4.07-1a.12.12,0,0,1-.09-.15.11.11,0,0,1,.15-.09l4.08,1a.15.15,0,0,1,.09.16A.14.14,0,0,1,255.24,401.28Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "253.239px 400.658px 0px",
              }}
              id="elyf5try0f578"
              className="animable"
            ></path>
            <path
              d="M245.47,414.47h0a.13.13,0,0,1-.08-.16l4.6-13.23a.12.12,0,0,1,.16-.08.12.12,0,0,1,.08.16l-4.6,13.23A.13.13,0,0,1,245.47,414.47Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "247.811px 407.734px 0px",
              }}
              id="elu0ab3dcuph"
              className="animable"
            ></path>
            <path
              d="M244.44,415.22a.11.11,0,0,1-.08,0L240,411.32a.12.12,0,0,1,0-.18.12.12,0,0,1,.17,0l4.35,3.87a.14.14,0,0,1,0,.18A.13.13,0,0,1,244.44,415.22Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "242.256px 413.166px 0px",
              }}
              id="elqlfj2n3po7g"
              className="animable"
            ></path>
            <path
              d="M238.88,410.71h0l-4-1a.12.12,0,0,1-.09-.15.12.12,0,0,1,.15-.09l4,1a.12.12,0,0,1,.09.15A.13.13,0,0,1,238.88,410.71Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "236.91px 410.089px 0px",
              }}
              id="elpcaz4lfz9v"
              className="animable"
            ></path>
            <path
              d="M229.2,421.13h0a.12.12,0,0,1-.07-.17l4.45-10.46a.12.12,0,0,1,.16-.06.11.11,0,0,1,.07.16l-4.45,10.46A.12.12,0,0,1,229.2,421.13Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "231.47px 415.784px 0px",
              }}
              id="elmuguvlijv3c"
              className="animable"
            ></path>
            <path
              d="M224,423a.13.13,0,0,1-.12-.11.13.13,0,0,1,.11-.15l3.9-.52a.12.12,0,0,1,.14.1.13.13,0,0,1-.11.15l-3.9.52Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "225.955px 422.609px 0px",
              }}
              id="elr805k4n1gml"
              className="animable"
            ></path>
            <path
              d="M217.8,433.45h-.06a.13.13,0,0,1-.05-.17l4.88-9.31a.12.12,0,0,1,.17-.06.13.13,0,0,1,0,.17l-4.88,9.32A.11.11,0,0,1,217.8,433.45Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "220.224px 428.672px 0px",
              }}
              id="eldecyvak60is"
              className="animable"
            ></path>
            <path
              d="M222.93,424.22a.5.5,0,0,1-.27-.07.83.83,0,0,1-.35-.76,2,2,0,0,1,.88-1.65.64.64,0,0,1,.65-.05.85.85,0,0,1,.34.77,2,2,0,0,1-.87,1.65A.72.72,0,0,1,222.93,424.22Zm.64-2.35a.57.57,0,0,0-.26.08,1.82,1.82,0,0,0-.74,1.44.61.61,0,0,0,.21.54.42.42,0,0,0,.41,0,1.8,1.8,0,0,0,.74-1.43.61.61,0,0,0-.22-.55A.23.23,0,0,0,223.57,421.87Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "223.245px 422.922px 0px",
              }}
              id="el3i6ufw6igh"
              className="animable"
            ></path>
            <path
              d="M233.82,410.71a.5.5,0,0,1-.27-.07.84.84,0,0,1-.35-.76,2.07,2.07,0,0,1,.88-1.66.64.64,0,0,1,.65,0,.83.83,0,0,1,.34.76,2.06,2.06,0,0,1-.87,1.66A.82.82,0,0,1,233.82,410.71Zm.64-2.35a.57.57,0,0,0-.26.08,1.8,1.8,0,0,0-.74,1.44.62.62,0,0,0,.21.54.42.42,0,0,0,.41,0,1.8,1.8,0,0,0,.74-1.44.6.6,0,0,0-.22-.54A.23.23,0,0,0,234.46,408.36Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "234.136px 409.421px 0px",
              }}
              id="elnsoipwz0v9"
              className="animable"
            ></path>
            <path
              d="M228.37,423.43a.64.64,0,0,1-.27-.07.85.85,0,0,1-.34-.77,2,2,0,0,1,.87-1.65.66.66,0,0,1,.66,0,.84.84,0,0,1,.34.76,2,2,0,0,1-.87,1.65A.77.77,0,0,1,228.37,423.43Zm.64-2.35a.53.53,0,0,0-.25.08,1.81,1.81,0,0,0-.75,1.43.61.61,0,0,0,.22.55.41.41,0,0,0,.4,0,1.86,1.86,0,0,0,.75-1.44.59.59,0,0,0-.22-.54A.28.28,0,0,0,229,421.08Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "228.695px 422.141px 0px",
              }}
              id="elg3spbpkv6mu"
              className="animable"
            ></path>
            <path
              d="M239.26,412a.54.54,0,0,1-.27-.07.85.85,0,0,1-.34-.77,2,2,0,0,1,.87-1.65.66.66,0,0,1,.66,0,.84.84,0,0,1,.34.76,2,2,0,0,1-.87,1.65A.74.74,0,0,1,239.26,412Zm.64-2.35a.53.53,0,0,0-.25.08,1.81,1.81,0,0,0-.75,1.43.61.61,0,0,0,.22.55.41.41,0,0,0,.4,0,1.81,1.81,0,0,0,.75-1.44.59.59,0,0,0-.22-.54A.28.28,0,0,0,239.9,409.65Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "239.585px 410.712px 0px",
              }}
              id="elgmuohgrkjni"
              className="animable"
            ></path>
            <path
              d="M244.71,416.8a.6.6,0,0,1-.27-.07.85.85,0,0,1-.34-.77,2,2,0,0,1,.87-1.65.64.64,0,0,1,.65,0,.82.82,0,0,1,.34.76,2,2,0,0,1-.87,1.65A.73.73,0,0,1,244.71,416.8Zm.64-2.35a.57.57,0,0,0-.26.08,1.83,1.83,0,0,0-.74,1.43.63.63,0,0,0,.21.55.42.42,0,0,0,.41,0,1.8,1.8,0,0,0,.74-1.44.61.61,0,0,0-.21-.54A.28.28,0,0,0,245.35,414.45Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "245.03px 415.511px 0px",
              }}
              id="elulnuhv1dyg9"
              className="animable"
            ></path>
            <path
              d="M250.15,401.24a.54.54,0,0,1-.27-.07.84.84,0,0,1-.34-.76,2,2,0,0,1,.87-1.65.66.66,0,0,1,.66-.05.87.87,0,0,1,.34.77,2,2,0,0,1-.87,1.65A.72.72,0,0,1,250.15,401.24Zm.65-2.35a.45.45,0,0,0-.26.09,1.81,1.81,0,0,0-.75,1.43c0,.27.08.47.22.54a.4.4,0,0,0,.4,0,1.81,1.81,0,0,0,.75-1.43.61.61,0,0,0-.22-.55A.43.43,0,0,0,250.8,398.89Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "250.475px 399.942px 0px",
              }}
              id="el05mbs7fnqm73"
              className="animable"
            ></path>
            <path
              d="M255.6,402.63a.5.5,0,0,1-.27-.07.83.83,0,0,1-.34-.76,2.06,2.06,0,0,1,.87-1.66.64.64,0,0,1,.65,0,.83.83,0,0,1,.34.76,2,2,0,0,1-.87,1.66A.82.82,0,0,1,255.6,402.63Zm.64-2.35a.57.57,0,0,0-.26.08,1.8,1.8,0,0,0-.74,1.44.62.62,0,0,0,.21.54.42.42,0,0,0,.41,0,1.8,1.8,0,0,0,.74-1.44.62.62,0,0,0-.21-.54A.28.28,0,0,0,256.24,400.28Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "255.92px 401.341px 0px",
              }}
              id="elcyj0hxgmwq"
              className="animable"
            ></path>
            <path
              d="M261,387.7a.56.56,0,0,1-.27-.08.84.84,0,0,1-.34-.76,2,2,0,0,1,.87-1.65.63.63,0,0,1,.66,0,.84.84,0,0,1,.34.76,2,2,0,0,1-.87,1.65A.74.74,0,0,1,261,387.7Zm.65-2.35a.53.53,0,0,0-.26.08,1.81,1.81,0,0,0-.75,1.43.61.61,0,0,0,.22.55.38.38,0,0,0,.4-.05,1.81,1.81,0,0,0,.75-1.43.61.61,0,0,0-.22-.55Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "261.325px 386.409px 0px",
              }}
              id="el2mgw7sp196g"
              className="animable"
            ></path>
            <path
              d="M266.49,391.81a.5.5,0,0,1-.27-.07.82.82,0,0,1-.34-.76,2,2,0,0,1,.87-1.65.62.62,0,0,1,.65-.05.85.85,0,0,1,.34.77,2,2,0,0,1-.87,1.65A.82.82,0,0,1,266.49,391.81Zm.64-2.35a.57.57,0,0,0-.26.08,1.8,1.8,0,0,0-.74,1.44.61.61,0,0,0,.21.54.42.42,0,0,0,.41,0,1.8,1.8,0,0,0,.74-1.43.63.63,0,0,0-.21-.55A.28.28,0,0,0,267.13,389.46Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "266.81px 390.511px 0px",
              }}
              id="el1h9uzfxi5pc"
              className="animable"
            ></path>
            <path
              d="M271.93,374.15a.68.68,0,0,1-.27-.07.87.87,0,0,1-.34-.77,2,2,0,0,1,.87-1.65.63.63,0,0,1,.66,0,.82.82,0,0,1,.34.76,2,2,0,0,1-.87,1.65A.74.74,0,0,1,271.93,374.15Zm.65-2.35a.53.53,0,0,0-.26.08,1.81,1.81,0,0,0-.75,1.43.61.61,0,0,0,.22.55.4.4,0,0,0,.4,0,1.83,1.83,0,0,0,.75-1.44.59.59,0,0,0-.22-.54A.25.25,0,0,0,272.58,371.8Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "272.256px 372.859px 0px",
              }}
              id="el9zvwl85bsle"
              className="animable"
            ></path>
            <path
              d="M277.38,363.74a.5.5,0,0,1-.27-.07.82.82,0,0,1-.34-.76,2,2,0,0,1,.87-1.65.64.64,0,0,1,.65-.05.85.85,0,0,1,.35.77,2,2,0,0,1-.88,1.65A.72.72,0,0,1,277.38,363.74Zm.64-2.35a.61.61,0,0,0-.26.08,1.82,1.82,0,0,0-.74,1.44c0,.27.08.47.22.54a.41.41,0,0,0,.4,0,1.8,1.8,0,0,0,.74-1.43.63.63,0,0,0-.21-.55A.42.42,0,0,0,278,361.39Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "277.704px 362.442px 0px",
              }}
              id="elo6snx07a2md"
              className="animable"
            ></path>
            <g id="elsz15vu6uy5f">
              <polygon
                points="277.7 368.16 272.26 378.56 266.87 396.05 262.59 392.82 261.37 392.11 255.92 407.04 250.47 405.66 245.13 421.04 240.81 417.18 239.58 416.48 234.14 415.09 228.69 427.9 223.25 428.64 217.8 439.04 217.8 446.3 219.03 447.01 278.93 412.43 278.93 368.86 277.7 368.16"
                style={{
                  fill: "rgb(143, 18, 35)",
                  opacity: "0.4",
                  transformOrigin: "248.365px 407.585px 0px",
                }}
                className="animable"
              ></polygon>
            </g>
            <g id="elwohrwh6t4og">
              <polygon
                points="219.03 439.75 224.47 429.34 229.92 428.61 235.37 415.8 240.81 417.18 246.26 422.04 251.7 406.36 257.15 407.75 262.59 392.82 268.04 396.93 273.48 379.27 278.93 368.86 278.93 412.43 219.03 447.01 219.03 439.75"
                style={{
                  fill: "rgb(143, 18, 35)",
                  opacity: "0.3",
                  transformOrigin: "248.98px 407.935px 0px",
                }}
                className="animable"
              ></polygon>
            </g>
            <polygon
              points="217.8 439.04 219.03 439.75 219.03 447.01 217.8 446.3 217.8 439.04"
              style={{
                fill: "rgb(143, 18, 35)",
                transformOrigin: "218.415px 443.025px 0px",
              }}
              id="elrmajohitnfm"
              className="animable"
            ></polygon>
            <g id="elf8kflludtcr">
              <polygon
                points="217.8 439.04 219.03 439.75 219.03 447.01 217.8 446.3 217.8 439.04"
                style={{
                  opacity: "0.05",
                  transformOrigin: "218.415px 443.025px 0px",
                }}
                className="animable"
              ></polygon>
            </g>
            <g id="eldede3tef4h5">
              <polygon
                points="228.69 427.9 229.92 428.61 235.37 415.8 234.14 415.09 228.69 427.9"
                style={{
                  fill: "rgb(143, 18, 35)",
                  opacity: "0.3",
                  transformOrigin: "232.03px 421.85px 0px",
                }}
                className="animable"
              ></polygon>
            </g>
            <g id="elhbg91zf9xqc">
              <polygon
                points="228.69 427.9 229.92 428.61 235.37 415.8 234.14 415.09 228.69 427.9"
                style={{
                  fill: "rgb(143, 18, 35)",
                  opacity: "0.15",
                  transformOrigin: "232.03px 421.85px 0px",
                }}
                className="animable"
              ></polygon>
            </g>
            <g id="el3c01m65lnpy">
              <polygon
                points="223.25 428.64 224.47 429.34 219.03 439.75 217.8 439.04 223.25 428.64"
                style={{
                  fill: "rgb(143, 18, 35)",
                  opacity: "0.3",
                  transformOrigin: "221.135px 434.195px 0px",
                }}
                className="animable"
              ></polygon>
            </g>
            <g id="elwx4jm4d8f3">
              <polygon
                points="223.25 428.64 224.47 429.34 219.03 439.75 217.8 439.04 223.25 428.64"
                style={{
                  fill: "rgb(143, 18, 35)",
                  opacity: "0.15",
                  transformOrigin: "221.135px 434.195px 0px",
                }}
                className="animable"
              ></polygon>
            </g>
            <g id="eluw25xv5e3e">
              <polygon
                points="251.7 406.36 250.47 405.66 245.13 421.04 246.26 422.04 251.7 406.36"
                style={{
                  fill: "rgb(143, 18, 35)",
                  opacity: "0.3",
                  transformOrigin: "248.415px 413.85px 0px",
                }}
                className="animable"
              ></polygon>
            </g>
            <g id="elh0r621xgreb">
              <polygon
                points="251.7 406.36 250.47 405.66 245.13 421.04 246.26 422.04 251.7 406.36"
                style={{
                  fill: "rgb(143, 18, 35)",
                  opacity: "0.15",
                  transformOrigin: "248.415px 413.85px 0px",
                }}
                className="animable"
              ></polygon>
            </g>
            <g id="elk5sfvu76ona">
              <polygon
                points="255.92 407.04 257.15 407.75 262.59 392.82 261.37 392.11 255.92 407.04"
                style={{
                  fill: "rgb(143, 18, 35)",
                  opacity: "0.3",
                  transformOrigin: "259.255px 399.93px 0px",
                }}
                className="animable"
              ></polygon>
            </g>
            <g id="el7xqemp6z79n">
              <polygon
                points="255.92 407.04 257.15 407.75 262.59 392.82 261.37 392.11 255.92 407.04"
                style={{
                  fill: "rgb(143, 18, 35)",
                  opacity: "0.15",
                  transformOrigin: "259.255px 399.93px 0px",
                }}
                className="animable"
              ></polygon>
            </g>
            <g id="eljde9lzrtmrh">
              <polygon
                points="273.48 379.27 272.26 378.56 266.87 396.05 268.04 396.93 273.48 379.27"
                style={{
                  fill: "rgb(143, 18, 35)",
                  opacity: "0.3",
                  transformOrigin: "270.175px 387.745px 0px",
                }}
                className="animable"
              ></polygon>
            </g>
            <g id="eljrkfvivn5v">
              <polygon
                points="273.48 379.27 272.26 378.56 266.87 396.05 268.04 396.93 273.48 379.27"
                style={{
                  fill: "rgb(143, 18, 35)",
                  opacity: "0.15",
                  transformOrigin: "270.175px 387.745px 0px",
                }}
                className="animable"
              ></polygon>
            </g>
          </g>
        </g>
      </g>
      <g
        id="freepik--connection-3--inject-9"
        style={{ transformOrigin: "322.061px 377.261px 0px" }}
        className="animable"
      >
        <g
          id="freepik--Lines--inject-9"
          style={{ transformOrigin: "322.061px 377.261px 0px" }}
          className="animable"
        >
          <g id="elxtje5usv81o">
            <rect
              x="279.43"
              y="380.37"
              width="89.19"
              height="0.74"
              style={{
                fill: "rgb(143, 18, 35)",
                transformOrigin:
                  "324.025px 380.74px 0px; transform: rotate(-30.02deg)",
              }}
              className="animable"
            ></rect>
          </g>
          <g id="el82eda3xs4xx">
            <rect
              x="275.44"
              y="378.06"
              width="89.19"
              height="0.74"
              style={{
                fill: "rgb(143, 18, 35)",
                transformOrigin:
                  "320.035px 378.43px 0px; transform: rotate(-30.02deg)",
              }}
              className="animable"
            ></rect>
          </g>
          <g id="elky948b0rnl">
            <rect
              x="271.44"
              y="375.76"
              width="89.19"
              height="0.74"
              style={{
                fill: "rgb(143, 18, 35)",
                transformOrigin:
                  "316.035px 376.13px 0px; transform: rotate(-30.03deg)",
              }}
              className="animable"
            ></rect>
          </g>
          <polygon
            points="342.92 384.07 342.55 383.44 350.35 378.93 350.35 369.7 366.51 360.37 366.88 361.01 351.09 370.13 351.09 379.36 342.92 384.07"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "354.715px 372.22px 0px",
            }}
            id="elc6vaaazsxa"
            className="animable"
          ></polygon>
          <polygon
            points="294.99 374.85 294.62 374.21 306.69 367.24 322.66 367.24 350.54 351.15 350.9 351.79 322.86 367.98 306.88 367.98 294.99 374.85"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "322.76px 363px 0px",
            }}
            id="elul8bie5xie"
            className="animable"
          ></polygon>
          <path
            d="M340.66,387a4.63,4.63,0,0,1-2.25-.55,1.62,1.62,0,0,1,0-3,4.92,4.92,0,0,1,4.51,0h0a1.62,1.62,0,0,1,0,3A4.64,4.64,0,0,1,340.66,387Zm0-3.39a3.82,3.82,0,0,0-1.88.45c-.44.25-.68.56-.68.87s.24.63.68.88a4.24,4.24,0,0,0,3.77,0,.91.91,0,0,0,0-1.75h0A3.83,3.83,0,0,0,340.66,383.63Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "340.665px 384.952px 0px",
            }}
            id="elcj4oddowb"
            className="animable"
          ></path>
          <path
            d="M292.73,377.79a4.66,4.66,0,0,1-2.26-.54,1.63,1.63,0,0,1,0-3,5,5,0,0,1,4.51,0h0a1.63,1.63,0,0,1,0,3A4.62,4.62,0,0,1,292.73,377.79Zm0-3.38a3.94,3.94,0,0,0-1.89.44.91.91,0,0,0,0,1.76,4.24,4.24,0,0,0,3.77,0,.91.91,0,0,0,0-1.76h0A3.9,3.9,0,0,0,292.73,374.41Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "292.725px 375.752px 0px",
            }}
            id="elfrz4129owp5"
            className="animable"
          ></path>
        </g>
      </g>
      <g
        id="freepik--device-1--inject-9"
        style={{ transformOrigin: "384.94px 291.822px 0px" }}
        className="animable"
      >
        <g
          id="freepik--Laptop--inject-9"
          style={{ transformOrigin: "384.94px 291.822px 0px" }}
          className="animable"
        >
          <path
            d="M464.72,342a5.47,5.47,0,0,1-2.56,4.24L402.4,380.74a5.68,5.68,0,0,1-5.11,0l-93.23-53.83a4.8,4.8,0,0,1,0-8.48l59.77-34.51a5.66,5.66,0,0,1,5.1,0l93.23,53.83A5.49,5.49,0,0,1,464.72,342Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "383.115px 332.33px 0px",
            }}
            id="elhoq3hlnyrsq"
            className="animable"
          ></path>
          <g id="el28o1c7b86mrj">
            <path
              d="M464.72,342a5.47,5.47,0,0,1-2.56,4.24L402.4,380.74a5.68,5.68,0,0,1-5.11,0l-93.23-53.83a4.8,4.8,0,0,1,0-8.48l59.77-34.51a5.66,5.66,0,0,1,5.1,0l93.23,53.83A5.49,5.49,0,0,1,464.72,342Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.6",
                transformOrigin: "383.115px 332.33px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M462.16,340.7,402.4,375.21a5.68,5.68,0,0,1-5.11,0l-93.23-53.83c-1.41-.81-1.41-2.13,0-2.95l59.77-34.51a5.66,5.66,0,0,1,5.1,0l93.23,53.83C463.57,338.57,463.57,339.89,462.16,340.7Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "383.11px 329.565px 0px",
            }}
            id="elm39xrskku8m"
            className="animable"
          ></path>
          <g id="el62h3qfs9to2">
            <path
              d="M462.16,340.7,402.4,375.21a5.68,5.68,0,0,1-5.11,0l-93.23-53.83c-1.41-.81-1.41-2.13,0-2.95l59.77-34.51a5.66,5.66,0,0,1,5.1,0l93.23,53.83C463.57,338.57,463.57,339.89,462.16,340.7Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.8",
                transformOrigin: "383.11px 329.565px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M399.84,375.82v5.53a5.21,5.21,0,0,0,2.56-.61l59.76-34.51a4.77,4.77,0,0,0,.26-8.31c1.15.82,1.06,2-.26,2.78L402.4,375.21A5.21,5.21,0,0,1,399.84,375.82Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "432.281px 359.636px 0px",
            }}
            id="el3233dfd4ao2"
            className="animable"
          ></path>
          <g id="eltt3px15j56l">
            <path
              d="M399.84,375.82v5.53a5.21,5.21,0,0,0,2.56-.61l59.76-34.51a4.77,4.77,0,0,0,.26-8.31c1.15.82,1.06,2-.26,2.78L402.4,375.21A5.21,5.21,0,0,1,399.84,375.82Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.3",
                transformOrigin: "432.281px 359.636px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M366.38,206.49v73a5.63,5.63,0,0,0,2.55,4.42l93.23,53.83h0a3.7,3.7,0,0,0,3.77.39,4.39,4.39,0,0,0,2.44-4h0v-73a5.63,5.63,0,0,0-2.55-4.42L372.58,202.9a4.41,4.41,0,0,0-4.66.13A3.68,3.68,0,0,0,366.38,206.49Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "417.362px 270.386px 0px",
            }}
            id="el31smyuss6b5"
            className="animable"
          ></path>
          <g id="elys4jn5zqm3">
            <path
              d="M366.38,206.49v73a5.63,5.63,0,0,0,2.55,4.42l93.23,53.83h0a3.7,3.7,0,0,0,3.77.39,4.39,4.39,0,0,0,2.44-4h0v-73a5.63,5.63,0,0,0-2.55-4.42L372.58,202.9a4.41,4.41,0,0,0-4.66.13A3.68,3.68,0,0,0,366.38,206.49Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.6",
                transformOrigin: "417.362px 270.386px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M366.38,206.49c0-1.63,1.14-2.29,2.55-1.48l93.23,53.83a5.21,5.21,0,0,1,1.81,1.91l3.64-2.12h0a5.38,5.38,0,0,0-1.81-1.91L372.58,202.9a4.39,4.39,0,0,0-4.66.13A3.69,3.69,0,0,0,366.38,206.49Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "416.982px 231.522px 0px",
            }}
            id="elicpe5ne2pns"
            className="animable"
          ></path>
          <g id="elog2htnv1bus">
            <path
              d="M366.38,206.49c0-1.63,1.14-2.29,2.55-1.48l93.23,53.83a5.21,5.21,0,0,1,1.81,1.91l3.64-2.12h0a5.38,5.38,0,0,0-1.81-1.91L372.58,202.9a4.39,4.39,0,0,0-4.66.13A3.69,3.69,0,0,0,366.38,206.49Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.8",
                transformOrigin: "416.982px 231.522px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M462.15,337.75a3.7,3.7,0,0,0,3.77.39,4.39,4.39,0,0,0,2.44-4v-73a5.13,5.13,0,0,0-.75-2.52L464,260.74h0a5.23,5.23,0,0,1,.75,2.51v73C464.7,337.9,463.56,338.56,462.15,337.75Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "465.255px 298.552px 0px",
            }}
            id="el3g6j9famaqm"
            className="animable"
          ></path>
          <g id="elec935mfntbr">
            <path
              d="M462.15,337.75a3.7,3.7,0,0,0,3.77.39,4.39,4.39,0,0,0,2.44-4v-73a5.13,5.13,0,0,0-.75-2.52L464,260.74h0a5.23,5.23,0,0,1,.75,2.51v73C464.7,337.9,463.56,338.56,462.15,337.75Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.3",
                transformOrigin: "465.255px 298.552px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M460.79,261.79,371.07,210c-.85-.49-1.53-.09-1.53.89v67.9a3.38,3.38,0,0,0,1.53,2.65l89.72,51.79c.85.48,1.53.09,1.53-.89v-67.9A3.35,3.35,0,0,0,460.79,261.79Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "415.93px 271.613px 0px",
            }}
            id="elj3m8cv54qv"
            className="animable"
          ></path>
          <g id="elb51n5m79i8">
            <g
              style={{
                opacity: "0.3",
                transformOrigin: "415.93px 271.613px 0px",
              }}
              className="animable"
            >
              <path
                d="M460.79,261.79,371.07,210c-.85-.49-1.53-.09-1.53.89v67.9a3.38,3.38,0,0,0,1.53,2.65l89.72,51.79c.85.48,1.53.09,1.53-.89v-67.9A3.35,3.35,0,0,0,460.79,261.79Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  transformOrigin: "415.93px 271.613px 0px",
                }}
                id="elwtm53yqp2fj"
                className="animable"
              ></path>
            </g>
          </g>
          <path
            d="M460.79,261.79a3.35,3.35,0,0,1,1.53,2.65v66.72L373.63,280a3.35,3.35,0,0,1-1.53-2.65V210.59Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "417.21px 270.875px 0px",
            }}
            id="elylcbnf5lv5g"
            className="animable"
          ></path>
          <path
            d="M454.28,338.18,368.6,288.72a2.69,2.69,0,0,0-2.41,0l-3.12,1.75a.74.74,0,0,0,0,1.39l85.69,49.46a2.69,2.69,0,0,0,2.41,0l3.11-1.75A.74.74,0,0,0,454.28,338.18Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "408.675px 315.02px 0px",
            }}
            id="elk8eywdg6mr"
            className="animable"
          ></path>
          <g id="elzr5adm6xbdf">
            <path
              d="M454.28,338.18,368.6,288.72a2.69,2.69,0,0,0-2.41,0l-3.12,1.75a.74.74,0,0,0,0,1.39l85.69,49.46a2.69,2.69,0,0,0,2.41,0l3.11-1.75A.74.74,0,0,0,454.28,338.18Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.5",
                transformOrigin: "408.675px 315.02px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M445.86,343.15l-85.67-49.47a2.49,2.49,0,0,0-2.2-.12l-22.3,12.88c-.55.32-.46.88.21,1.27l85.57,49.4a2.49,2.49,0,0,0,2.2.12l22.4-12.82C446.62,344.1,446.53,343.53,445.86,343.15Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "390.88px 325.395px 0px",
            }}
            id="eloz7yeol3id8"
            className="animable"
          ></path>
          <g id="el3pv6jxyfa64">
            <path
              d="M445.86,343.15l-85.67-49.47a2.49,2.49,0,0,0-2.2-.12l-22.3,12.88c-.55.32-.46.88.21,1.27l85.57,49.4a2.49,2.49,0,0,0,2.2.12l22.4-12.82C446.62,344.1,446.53,343.53,445.86,343.15Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.5",
                transformOrigin: "390.88px 325.395px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M410.18,336.49l2.69,1.55a.45.45,0,0,0,.39,0l2.56-1.48c.1-.06.09-.16,0-.23l-2.68-1.54a.42.42,0,0,0-.39,0l-2.57,1.48C410.06,336.32,410.07,336.42,410.18,336.49Zm9.29-2.26-2.69-1.55a.42.42,0,0,0-.39,0l-2.56,1.48c-.1.06-.09.16,0,.22l2.68,1.55a.42.42,0,0,0,.39,0l2.57-1.48C419.59,334.39,419.58,334.29,419.47,334.23Zm-8.67-5-4.54-2.62a.45.45,0,0,0-.39,0l-2.57,1.48c-.1.06-.09.16,0,.23l4.54,2.62a.45.45,0,0,0,.39,0l2.56-1.48C410.92,329.39,410.91,329.29,410.8,329.22Zm4.75,2.74-2.69-1.54a.42.42,0,0,0-.39,0l-2.56,1.48c-.1.06-.09.16,0,.23l2.68,1.55a.45.45,0,0,0,.39,0l2.57-1.48C415.67,332.13,415.66,332,415.55,332ZM405,325.89l-2.68-1.55a.42.42,0,0,0-.39,0l-2.57,1.48c-.1.06-.09.16,0,.22l2.68,1.55a.42.42,0,0,0,.39,0l2.56-1.48C405.15,326.05,405.14,326,405,325.89Zm-3.92-2.27-2.68-1.54a.42.42,0,0,0-.39,0l-2.57,1.48c-.1.06-.09.16,0,.23l2.68,1.55a.45.45,0,0,0,.39,0l2.56-1.48C401.22,323.79,401.21,323.69,401.1,323.62Zm-10.47,5.81,2.68,1.55a.42.42,0,0,0,.39,0l2.57-1.48c.1-.06.09-.16,0-.22l-2.68-1.55a.42.42,0,0,0-.39,0l-2.56,1.48C390.5,329.27,390.52,329.37,390.63,329.43Zm-3.92-2.26,2.68,1.55a.45.45,0,0,0,.39,0l2.57-1.48c.1-.06.09-.16,0-.23l-2.68-1.54a.42.42,0,0,0-.39,0l-2.56,1.48C386.58,327,386.59,327.1,386.71,327.17Zm-3.92-2.26,2.68,1.54a.42.42,0,0,0,.39,0l2.57-1.48c.1-.06.09-.16,0-.23l-2.68-1.55a.45.45,0,0,0-.39,0l-2.57,1.48C382.66,324.74,382.67,324.84,382.79,324.91Zm-3.92-2.27,2.68,1.55a.42.42,0,0,0,.39,0l2.57-1.48c.1-.06.09-.16,0-.22L381.8,321a.42.42,0,0,0-.39,0l-2.57,1.48C378.74,322.48,378.75,322.58,378.87,322.64Zm27.39,11.59,2.69,1.54a.42.42,0,0,0,.39,0l2.56-1.48c.1-.06.09-.16,0-.23l-2.68-1.55a.45.45,0,0,0-.39,0L406.24,334C406.14,334.06,406.15,334.16,406.26,334.23Zm-11.71-2.53,6,3.45a.42.42,0,0,0,.39,0l6.24-3.59c.1-.06.09-.16,0-.23L404,329.55a.45.45,0,0,0-.39,0l-3.3,1.91a.45.45,0,0,1-.39,0L397.48,330a.45.45,0,0,0-.39,0l-2.56,1.48C394.43,331.53,394.44,331.63,394.55,331.7Zm2.63-10.34-2.68-1.55a.45.45,0,0,0-.39,0l-2.57,1.48c-.1.06-.09.16,0,.23l2.69,1.54a.42.42,0,0,0,.39,0l2.56-1.48C397.3,321.53,397.29,321.43,397.18,321.36Zm-3.92-2.26-2.68-1.55a.42.42,0,0,0-.39,0L387.62,319c-.1.06-.09.16,0,.22l2.69,1.55a.42.42,0,0,0,.39,0l2.56-1.48C393.38,319.26,393.37,319.16,393.26,319.1ZM351.4,306.57c-.1.06-.09.16,0,.23l2.69,1.55a.45.45,0,0,0,.39,0l2.56-1.48c.1-.06.09-.16,0-.23l-2.68-1.55a.45.45,0,0,0-.39,0ZM361.9,301l-2.69-1.55a.42.42,0,0,0-.39,0l-2.56,1.48c-.1.06-.09.16,0,.22l2.68,1.55a.45.45,0,0,0,.39,0l2.57-1.49C362,301.16,362,301.06,361.9,301ZM354,303.86c-.1.06-.09.16,0,.22l2.68,1.55a.45.45,0,0,0,.39,0l2.57-1.49c.1-.05.09-.15,0-.22L357,302.39a.45.45,0,0,0-.39,0Zm-4.21,6.24,2.68,1.55a.42.42,0,0,0,.39,0l2.57-1.48c.1-.06.09-.16,0-.23l-2.69-1.55a.45.45,0,0,0-.39,0l-2.56,1.48C349.7,309.94,349.71,310,349.82,310.1Zm-3.94-2.48c-.1.05-.09.16,0,.22l2.68,1.55a.42.42,0,0,0,.39,0l2.57-1.48c.1-.06.09-.16,0-.22l-2.69-1.55a.45.45,0,0,0-.39,0Zm19.94-4.37-2.69-1.55a.45.45,0,0,0-.39,0l-2.56,1.48c-.1.06-.09.16,0,.23l2.68,1.55a.45.45,0,0,0,.39,0l2.57-1.48C365.94,303.42,365.93,303.32,365.82,303.25Zm19.6,11.32L382.74,313a.45.45,0,0,0-.39,0l-2.57,1.48c-.1.06-.09.16,0,.23l2.69,1.54a.4.4,0,0,0,.38,0l2.57-1.48C385.54,314.74,385.53,314.64,385.42,314.57Zm-15.68-9.05L367.05,304a.45.45,0,0,0-.39,0l-2.56,1.49c-.1.05-.09.16,0,.22l2.68,1.55a.42.42,0,0,0,.39,0l2.57-1.48C369.86,305.68,369.85,305.58,369.74,305.52Zm19.6,11.31-2.68-1.54a.42.42,0,0,0-.39,0l-2.57,1.48c-.1.06-.09.16,0,.23l2.69,1.55a.45.45,0,0,0,.39,0l2.56-1.48C389.46,317,389.45,316.9,389.34,316.83Zm-7.84-4.52-2.68-1.55a.45.45,0,0,0-.39,0l-2.57,1.49c-.1,0-.09.16,0,.22l2.69,1.55a.4.4,0,0,0,.38,0l2.57-1.48C381.62,312.47,381.61,312.37,381.5,312.31ZM377.58,310l-2.69-1.55a.42.42,0,0,0-.38,0L371.94,310c-.1.06-.09.16,0,.23l2.68,1.55a.45.45,0,0,0,.39,0l2.57-1.48C377.7,310.21,377.69,310.11,377.58,310Zm-3.92-2.26L371,306.23a.45.45,0,0,0-.39,0L368,307.7c-.1.06-.09.16,0,.22l2.68,1.55a.42.42,0,0,0,.39,0l2.57-1.48C373.78,308,373.77,307.85,373.66,307.78ZM371,318.11l2.68,1.55a.45.45,0,0,0,.39,0l2.56-1.49c.11-.05.1-.15,0-.22L374,316.42a.45.45,0,0,0-.39,0L371,317.89C370.9,318,370.91,318.05,371,318.11Zm57.1,21.12-2.68-1.55a.45.45,0,0,0-.39,0l-2.57,1.48c-.1.06-.09.16,0,.23l2.68,1.54a.42.42,0,0,0,.39,0l2.56-1.48C428.26,339.4,428.25,339.3,428.13,339.23Zm-4.74-2.74-2.69-1.55a.45.45,0,0,0-.39,0l-2.56,1.48c-.1.06-.09.16,0,.23l2.68,1.54a.42.42,0,0,0,.39,0l2.57-1.48C423.51,336.66,423.5,336.56,423.39,336.49Zm8.66,5L429.37,340a.42.42,0,0,0-.39,0l-2.57,1.48c-.1.06-.09.16,0,.23l2.68,1.55a.45.45,0,0,0,.39,0l2.57-1.48C432.18,341.66,432.17,341.56,432.05,341.49ZM397.18,329l2.69,1.55a.45.45,0,0,0,.39,0l2.56-1.49c.1-.05.09-.16,0-.22l-2.68-1.55a.42.42,0,0,0-.39,0l-2.57,1.48C397.06,328.82,397.07,328.92,397.18,329ZM436,344c.1-.06.09-.16,0-.22l-2.68-1.55a.42.42,0,0,0-.39,0l-2.57,1.48c-.1.06-.09.16,0,.22l2.68,1.55a.42.42,0,0,0,.39,0ZM375,320.38l2.68,1.55a.45.45,0,0,0,.39,0l2.57-1.48c.1-.06.09-.16,0-.23l-2.68-1.55a.45.45,0,0,0-.39,0l-2.57,1.48C374.82,320.21,374.83,320.31,375,320.38ZM423,348.14l2.68,1.54a.42.42,0,0,0,.39,0l2.56-1.48c.1-.06.09-.16,0-.23L426,346.44a.45.45,0,0,0-.39,0L423,347.91C422.9,348,422.91,348.07,423,348.14Zm-.26-4.38,2.68,1.54a.42.42,0,0,0,.39,0l2.57-1.48c.1-.06.09-.16,0-.23l-2.69-1.55a.45.45,0,0,0-.39,0l-2.56,1.48C422.65,343.59,422.66,343.69,422.77,343.76Zm9.56,2.34c.1-.06.09-.16,0-.23l-2.69-1.54a.42.42,0,0,0-.39,0l-2.56,1.48c-.1.06-.09.16,0,.23l2.68,1.55a.45.45,0,0,0,.39,0Zm.83.48-6.24,3.59c-.1.06-.09.16,0,.23l2.68,1.55a.45.45,0,0,0,.39,0l6.23-3.6c.1-.06.09-.16,0-.22l-2.69-1.55A.4.4,0,0,0,433.16,346.58Zm-8.69-5.23-2.69-1.55a.42.42,0,0,0-.39,0l-2.56,1.48c-.1.06-.09.16,0,.22l2.68,1.55a.42.42,0,0,0,.39,0l2.57-1.48C424.59,341.51,424.58,341.41,424.47,341.35Zm-29.51-17-2.68-1.55a.45.45,0,0,0-.39,0l-2.57,1.48c-.1.06-.09.16,0,.23L392,326a.42.42,0,0,0,.38,0l2.57-1.48C395.08,324.48,395.07,324.38,395,324.31Zm24.12,21.34c-.1.06-.09.16,0,.22l2.69,1.55a.42.42,0,0,0,.39,0l2.56-1.48c.1-.06.09-.16,0-.22L422,344.18a.42.42,0,0,0-.39,0Zm-20.2-19.07L396.2,325a.42.42,0,0,0-.39,0l-2.57,1.48c-.1.06-.09.16,0,.23l2.69,1.55a.45.45,0,0,0,.39,0l2.56-1.48C399,326.74,399,326.64,398.88,326.58Zm-43.56-17.74c-.1.05-.09.15,0,.22l2.69,1.55a.45.45,0,0,0,.39,0l2.56-1.48c.1-.06.09-.16,0-.22l-2.68-1.55a.45.45,0,0,0-.39,0Zm8.27-2.64-2.68-1.55a.45.45,0,0,0-.39,0L358,306.12c-.11.06-.1.16,0,.23l2.68,1.55a.45.45,0,0,0,.39,0l2.57-1.48C363.72,306.37,363.71,306.27,363.59,306.2Zm-4.33,5.12,2.69,1.55a.45.45,0,0,0,.39,0l2.56-1.49c.1,0,.09-.16,0-.22l-2.68-1.55a.42.42,0,0,0-.39,0l-2.57,1.48C359.14,311.16,359.15,311.26,359.26,311.32Zm3.92,2.27,2.69,1.55a.45.45,0,0,0,.39,0l2.56-1.48c.1-.06.09-.16,0-.23l-2.68-1.55a.45.45,0,0,0-.39,0l-2.57,1.48C363.06,313.42,363.07,313.52,363.18,313.59Zm3.93,2.26,2.68,1.55a.42.42,0,0,0,.39,0l2.56-1.48c.11-.06.1-.16,0-.22L370,314.16a.45.45,0,0,0-.39,0l-2.57,1.49C367,315.68,367,315.79,367.11,315.85Zm.4-7.38-2.68-1.55a.45.45,0,0,0-.39,0l-2.56,1.49c-.11.06-.09.16,0,.22l2.68,1.55a.42.42,0,0,0,.39,0l2.57-1.48C367.64,308.63,367.63,308.53,367.51,308.47Zm3.93,2.26-2.69-1.55a.45.45,0,0,0-.39,0l-2.56,1.48c-.1.06-.09.16,0,.23l2.68,1.54a.42.42,0,0,0,.39,0l2.57-1.48C371.56,310.9,371.55,310.8,371.44,310.73Zm15.68,9-2.69-1.54a.42.42,0,0,0-.39,0l-2.56,1.48c-.1.06-.09.16,0,.23l2.68,1.55a.45.45,0,0,0,.39,0l2.57-1.48C387.24,320,387.23,319.85,387.12,319.78Zm-3.92-2.26L380.51,316a.45.45,0,0,0-.39,0l-2.56,1.48c-.1.06-.09.16,0,.23l2.68,1.54a.42.42,0,0,0,.39,0l2.57-1.48C383.32,317.69,383.31,317.59,383.2,317.52Zm7.84,4.53-2.68-1.55a.42.42,0,0,0-.39,0L385.4,322c-.1.06-.09.16,0,.22l2.69,1.55a.4.4,0,0,0,.38,0l2.57-1.48C391.16,322.21,391.15,322.11,391,322.05ZM375.36,313l-2.69-1.54a.42.42,0,0,0-.39,0l-2.56,1.48c-.1.06-.09.16,0,.23l2.68,1.55a.45.45,0,0,0,.39,0l2.57-1.48C375.48,313.16,375.47,313.06,375.36,313Zm3.92,2.27-2.69-1.55a.41.41,0,0,0-.39,0l-2.56,1.48c-.1.06-.09.16,0,.22l2.68,1.55a.42.42,0,0,0,.39,0l2.57-1.48C379.4,315.42,379.39,315.32,379.28,315.26Zm-25.54-2.89,2.68,1.55a.45.45,0,0,0,.39,0l2.57-1.48c.1-.06.09-.16,0-.23l-2.69-1.54a.42.42,0,0,0-.39,0l-2.56,1.48C353.62,312.2,353.63,312.3,353.74,312.37Zm1.69-11.94L358,299c.1-.06.09-.16,0-.22l-2.68-1.55a.45.45,0,0,0-.39,0l-2.56,1.49c-.11.05-.09.15,0,.22l2.68,1.55A.45.45,0,0,0,355.43,300.43Zm-2.22,2.95,2.57-1.48c.1-.06.09-.16,0-.22l-4.12-2.39a.45.45,0,0,0-.39,0l-2.57,1.48c-.1.06-.09.16,0,.23l4.13,2.38A.42.42,0,0,0,353.21,303.38Zm7.29-5.16,2.57-1.48c.1-.06.09-.16,0-.23l-3.3-1.9a.45.45,0,0,0-.39,0l-2.56,1.49c-.11.05-.1.16,0,.22l3.3,1.91A.45.45,0,0,0,360.5,298.22Zm2.53,1.46c-.1.06-.09.16,0,.23l2.69,1.55a.45.45,0,0,0,.39,0l2.56-1.48c.1-.06.09-.16,0-.23L366,298.21a.45.45,0,0,0-.39,0Zm-12.45,6.42,2.56-1.49c.1-.05.09-.16,0-.22l-5.16-3a.42.42,0,0,0-.39,0L345,302.88c-.1.06-.09.16,0,.22l5.16,3A.45.45,0,0,0,350.58,306.1Zm-5.53,1,2.57-1.48c.1-.06.09-.16,0-.23l-3.31-1.9a.45.45,0,0,0-.39,0L341.34,305c-.1.05-.09.15,0,.22l3.3,1.91A.45.45,0,0,0,345.05,307.14Zm47.13,9.37c-.1.06-.09.16,0,.23l2.69,1.55a.45.45,0,0,0,.39,0l2.56-1.48c.1-.06.09-.16,0-.23L395.14,315a.45.45,0,0,0-.39,0ZM384.34,312c-.1.06-.09.16,0,.23l2.69,1.55a.42.42,0,0,0,.38,0l2.57-1.48c.1-.06.09-.16,0-.22l-2.68-1.55a.42.42,0,0,0-.39,0ZM367,302c-.1.05-.09.15,0,.22l2.69,1.55a.42.42,0,0,0,.39,0l2.56-1.48c.1-.06.09-.16,0-.22l-2.68-1.55a.45.45,0,0,0-.39,0Zm21.31,12.3c-.1.06-.09.16,0,.22L391,316a.45.45,0,0,0,.39,0l2.56-1.49c.1-.05.09-.16,0-.22l-2.68-1.55a.42.42,0,0,0-.39,0Zm-7.84-4.53c-.1.06-.09.16,0,.23l2.68,1.54a.42.42,0,0,0,.39,0l2.57-1.48c.1-.06.09-.16,0-.23l-2.68-1.55a.45.45,0,0,0-.39,0Zm-35.64-1.47c.1-.06.09-.16,0-.22l-4.12-2.39a.45.45,0,0,0-.39,0l-2.57,1.48c-.1.06-.09.16,0,.23l4.13,2.38a.42.42,0,0,0,.39,0Zm30-1.78c-.1.06-.09.16,0,.23l2.68,1.55a.45.45,0,0,0,.39,0l2.56-1.48c.11-.06.1-.16,0-.23L377.75,305a.45.45,0,0,0-.39,0Zm-3.92-2.26c-.1.06-.09.16,0,.22l2.69,1.55a.45.45,0,0,0,.39,0l2.56-1.49c.1-.05.09-.15,0-.22l-2.68-1.55a.45.45,0,0,0-.39,0Zm46.54,46c.1-.06.09-.16,0-.23l-6.61-3.81a.41.41,0,0,0-.39,0l-2.56,1.48c-.1.06-.09.16,0,.22l6.6,3.81a.42.42,0,0,0,.39,0Zm-8.67-5c.11-.06.1-.16,0-.22L406,343.41a.42.42,0,0,0-.39,0l-2.57,1.48c-.1.06-.09.16,0,.22l2.68,1.55a.42.42,0,0,0,.39,0Zm-51.08-30.55,2.68,1.55a.42.42,0,0,0,.39,0l2.57-1.48c.1-.06.09-.16,0-.22l-2.69-1.55a.4.4,0,0,0-.38,0l-2.57,1.48C357.54,314.47,357.55,314.57,357.66,314.63Zm43.24,26c.1-.06.09-.16,0-.23l-2.68-1.55a.45.45,0,0,0-.39,0l-2.57,1.48c-.1.06-.09.16,0,.23l2.69,1.54a.42.42,0,0,0,.39,0Zm20.43,11.79c.1-.06.09-.16,0-.23l-2.68-1.54a.42.42,0,0,0-.39,0l-2.57,1.48c-.1.06-.09.16,0,.23l2.69,1.55a.42.42,0,0,0,.38,0Zm1.36,3.74,6.23-3.59c.1-.06.09-.16,0-.23l-2.69-1.55a.45.45,0,0,0-.39,0l-6.23,3.6c-.1.06-.09.16,0,.22l2.69,1.55A.41.41,0,0,0,422.69,356.19Zm-36.44-24c.1-.06.09-.16,0-.23l-3.3-1.9a.42.42,0,0,0-.39,0L380,331.53c-.1.06-.09.16,0,.23l3.3,1.91a.45.45,0,0,0,.39,0Zm9.91,5.72c.1-.06.09-.16,0-.23L392,335.31a.45.45,0,0,0-.39,0l-2.57,1.49c-.1.05-.09.16,0,.22l4.13,2.38a.42.42,0,0,0,.39,0Zm-19-11c.1-.06.09-.16,0-.23L355.07,314a.45.45,0,0,0-.39,0l-2.56,1.48c-.11.06-.1.16,0,.23l22.08,12.74a.42.42,0,0,0,.39,0Zm-23.31-13.47c.1-.06.09-.16,0-.22l-3.3-1.91a.45.45,0,0,0-.39,0l-2.56,1.48c-.11.06-.09.16,0,.23l3.3,1.9a.42.42,0,0,0,.39,0Zm27.85,16.09c.1-.06.09-.16,0-.23l-3.3-1.9a.42.42,0,0,0-.39,0l-2.57,1.48c-.1.06-.09.16,0,.23l3.3,1.9a.42.42,0,0,0,.39,0Zm-32.39-18.71c.1-.06.09-.16,0-.22l-3.3-1.91a.45.45,0,0,0-.39,0L343,310.21c-.11.06-.09.16,0,.22l3.3,1.91a.42.42,0,0,0,.39,0Zm41.47,23.95c.1-.06.09-.16,0-.23l-3.3-1.9a.45.45,0,0,0-.39,0l-2.57,1.49c-.1,0-.09.15,0,.22l3.31,1.91a.45.45,0,0,0,.39,0Zm14,8.1c.11-.06.09-.16,0-.23l-2.68-1.54a.42.42,0,0,0-.39,0l-2.57,1.48c-.1.06-.09.16,0,.23l2.68,1.55a.45.45,0,0,0,.39,0ZM415.44,348l2.68,1.55a.45.45,0,0,0,.39,0l2.57-1.48c.1-.06.09-.16,0-.23l-2.68-1.54a.42.42,0,0,0-.39,0l-2.56,1.48C415.31,347.82,415.32,347.92,415.44,348Zm-1.34-9.24,2.69,1.55a.42.42,0,0,0,.39,0l2.56-1.48c.1-.06.09-.16,0-.22L417,337.06a.42.42,0,0,0-.39,0l-2.57,1.48C414,338.59,414,338.69,414.1,338.75Zm-25.07-6,7.84,4.53a.45.45,0,0,0,.39,0l2.56-1.48c.1-.06.09-.16,0-.23L392,331.05a.45.45,0,0,0-.39,0L389,332.52C388.9,332.57,388.91,332.67,389,332.74Zm22.46,12.76c-.1.06-.09.16,0,.23l2.68,1.54a.42.42,0,0,0,.39,0l2.57-1.48c.1-.06.09-.16,0-.23L414.45,344a.45.45,0,0,0-.39,0Zm3.69-1.89,2.69,1.55a.45.45,0,0,0,.39,0l2.56-1.48c.1-.06.09-.16,0-.23l-2.68-1.54a.42.42,0,0,0-.39,0l-2.57,1.48C415.06,343.44,415.07,343.54,415.18,343.61Zm-30.07-13.13,2.68,1.55a.45.45,0,0,0,.39,0l2.56-1.48c.11-.06.09-.16,0-.23L388,328.78a.45.45,0,0,0-.39,0l-2.57,1.48C385,330.31,385,330.41,385.11,330.48Zm17.72,10c-.1.06-.09.16,0,.22l2.68,1.55a.42.42,0,0,0,.39,0l2.57-1.48c.1-.06.09-.16,0-.22L405.78,339a.41.41,0,0,0-.39,0ZM365.5,319.16l2.69,1.55a.45.45,0,0,0,.39,0l2.56-1.48c.1-.06.09-.16,0-.23l-2.68-1.54a.42.42,0,0,0-.39,0l-2.57,1.48C365.38,319,365.39,319.09,365.5,319.16Zm3.92,2.26,2.69,1.55a.41.41,0,0,0,.39,0l2.56-1.48c.1-.06.09-.16,0-.22l-2.68-1.55a.42.42,0,0,0-.39,0l-2.57,1.48C369.3,321.26,369.31,321.36,369.42,321.42Zm-7.84-4.52,2.69,1.54a.4.4,0,0,0,.38,0l2.57-1.48c.1-.06.09-.16,0-.23l-2.68-1.55a.45.45,0,0,0-.39,0l-2.57,1.48C361.46,316.73,361.47,316.83,361.58,316.9ZM377.26,326,380,327.5a.45.45,0,0,0,.39,0L382.9,326c.1-.06.09-.16,0-.23l-2.68-1.54a.42.42,0,0,0-.39,0l-2.57,1.48C377.14,325.78,377.15,325.88,377.26,326Zm-3.92-2.26,2.69,1.54a.42.42,0,0,0,.39,0l2.56-1.48c.1-.06.09-.16,0-.23L376.28,322a.45.45,0,0,0-.39,0l-2.57,1.48C373.22,323.52,373.23,323.62,373.34,323.69Zm7.85,4.52,2.68,1.55a.45.45,0,0,0,.39,0l2.56-1.49c.1-.06.09-.16,0-.22l-2.68-1.55a.42.42,0,0,0-.39,0L381.16,328C381.06,328.05,381.07,328.15,381.19,328.21Zm54.54,12.36c-.11.05-.1.15,0,.22l2.68,1.55a.45.45,0,0,0,.39,0l.68-.39c.11-.06.09-.16,0-.23l-2.68-1.55a.45.45,0,0,0-.39,0Zm-21.37-11.26c-.11.06-.1.16,0,.23l2.68,1.55a.45.45,0,0,0,.39,0l2.57-1.48c.1-.06.09-.16,0-.22l-2.68-1.55a.42.42,0,0,0-.39,0Zm7.84,4.53c-.1.06-.09.16,0,.23l2.68,1.55a.45.45,0,0,0,.39,0l2.57-1.48c.1-.06.09-.16,0-.23l-2.69-1.55a.45.45,0,0,0-.39,0Zm-12.63-7.29c-.1.06-.09.16,0,.23l2.68,1.54a.42.42,0,0,0,.39,0l2.57-1.48c.1-.06.09-.16,0-.23l-2.69-1.55a.45.45,0,0,0-.39,0Zm8.71,5c-.11.06-.09.16,0,.22l2.68,1.55a.45.45,0,0,0,.39,0l2.57-1.49c.1-.05.09-.16,0-.22l-2.68-1.55a.42.42,0,0,0-.39,0ZM401.73,322c-.1.06-.09.16,0,.23l2.68,1.55a.45.45,0,0,0,.39,0l2.57-1.48c.1-.06.09-.16,0-.23l-2.69-1.54a.42.42,0,0,0-.39,0Zm3.92,2.27c-.1.06-.09.16,0,.22l2.68,1.55a.42.42,0,0,0,.39,0l2.57-1.48c.1-.06.09-.16,0-.22l-2.69-1.55a.41.41,0,0,0-.39,0ZM427.88,336c-.1.06-.09.16,0,.22l2.68,1.55a.45.45,0,0,0,.39,0l.68-.4c.1-.06.09-.16,0-.22L429,335.66a.45.45,0,0,0-.39,0Zm11.77,6.79c-.11.06-.1.16,0,.22l2.68,1.55a.45.45,0,0,0,.39,0l.68-.4c.11-.06.1-.16,0-.22l-2.68-1.55a.45.45,0,0,0-.39,0Zm-5.39,3.11c-.11.06-.1.16,0,.23l2.68,1.55a.45.45,0,0,0,.39,0l2.57-1.48c.1-.06.09-.16,0-.23l-2.68-1.55a.45.45,0,0,0-.39,0Zm-14.9,4.31L422,351.8a.42.42,0,0,0,.39,0l2.57-1.48c.1-.06.09-.16,0-.22l-2.68-1.55a.42.42,0,0,0-.39,0L419.34,350C419.23,350.09,419.25,350.19,419.36,350.25Zm12.45-11.95c-.11.06-.1.16,0,.23l2.68,1.55a.45.45,0,0,0,.39,0l.68-.4c.1-.05.09-.15,0-.22l-2.68-1.55a.42.42,0,0,0-.39,0Zm-34-18.54c-.1.06-.09.16,0,.23l2.68,1.54a.42.42,0,0,0,.39,0l2.57-1.48c.1-.06.09-.16,0-.23l-2.69-1.55a.45.45,0,0,0-.39,0Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "390.579px 325.417px 0px",
            }}
            id="eldvys0ssdszg"
            className="animable"
          ></path>
          <polygon
            points="389.37 343.92 388.79 344.25 373.3 353.19 345.75 337.29 345.17 336.96 361.25 327.68 389.37 343.92"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "367.27px 340.435px 0px",
            }}
            id="eln30nr9f1gq"
            className="animable"
          ></polygon>
          <polygon
            points="346.1 337.49 361.25 328.75 388.43 344.46 373.3 353.19 346.1 337.49"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "367.265px 340.97px 0px",
            }}
            id="el8jjictib58g"
            className="animable"
          ></polygon>
          <g id="eliytqsvd7bn">
            <polygon
              points="346.1 337.49 361.25 328.75 388.43 344.46 373.3 353.19 346.1 337.49"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.5",
                transformOrigin: "367.265px 340.97px 0px",
              }}
              className="animable"
            ></polygon>
          </g>
        </g>
      </g>
      <g
        id="freepik--Tab--inject-9"
        style={{ transformOrigin: "410.92px 277.001px 0px" }}
        className="animable"
      >
        <g
          id="freepik--Window--inject-9"
          style={{ transformOrigin: "410.92px 277.001px 0px" }}
          className="animable"
        >
          <g id="el86wtotcd24d">
            <g
              style={{
                opacity: "0.2",
                transformOrigin: "412.24px 275.335px 0px",
              }}
              className="animable"
            >
              <path
                d="M452.3,264.72l-80.12-46.25c-1.56-.9-2.82-.17-2.82,1.63v61a6.24,6.24,0,0,0,2.82,4.9L452.3,332.2c1.56.9,2.82.17,2.82-1.63V269.62A6.27,6.27,0,0,0,452.3,264.72Z"
                id="elas8r9tftbqa"
                style={{ transformOrigin: "412.24px 275.335px 0px" }}
                className="animable"
              ></path>
            </g>
          </g>
          <g
            id="freepik--window--inject-9"
            style={{ transformOrigin: "409.825px 278.573px 0px" }}
            className="animable"
          >
            <path
              d="M366.76,224.63a1,1,0,0,1,0-.24,0,0,0,0,1,0,0,.84.84,0,0,1,.06-.24,1.17,1.17,0,0,1,.16-.34.5.5,0,0,1,.08-.14l.08-.09a.91.91,0,0,1,.17-.17l0,0a1,1,0,0,1,.23-.13,1.91,1.91,0,0,1,1.78.22L447,268.1c1.46.84,2.65,2.9,2.65,5.85v60.13a1.8,1.8,0,0,1-1,1.6l-.11.07-.14.08a1,1,0,0,1-.22.08,2.09,2.09,0,0,1-.34,0,1.72,1.72,0,0,1-.88-.25l-.07,0h0l-2.52-1.46-75-43.21a5.84,5.84,0,0,1-2.65-4.59V225C366.74,224.85,366.75,224.74,366.76,224.63Z"
              style={{
                fill: "rgb(69, 90, 100)",
                transformOrigin: "408.185px 279.535px 0px",
              }}
              id="el1ha2shm1ehu"
              className="animable"
            ></path>
            <path
              d="M367.61,223.21a1.91,1.91,0,0,1,1.78.22L447,268.1a5.86,5.86,0,0,1,2.65,4.59v5.14l3.28-1.92v-5.08a5.84,5.84,0,0,0-2.65-4.58l-77.6-44.67a1.84,1.84,0,0,0-1.92-.15C370.27,221.71,368.17,222.91,367.61,223.21Z"
              style={{
                fill: "rgb(143, 18, 35)",
                transformOrigin: "410.27px 249.529px 0px",
              }}
              id="el0b8ztbdijcj5"
              className="animable"
            ></path>
            <path
              d="M366.75,225c0-1.68,1.19-2.35,2.64-1.51L447,268.1a5.87,5.87,0,0,1,2.65,4.59v5.14l-82.89-47.71Z"
              style={{
                fill: "rgb(143, 18, 35)",
                transformOrigin: "408.2px 250.479px 0px",
              }}
              id="elj1zcsd46anf"
              className="animable"
            ></path>
            <g id="elu4sodr0cb1l">
              <g
                style={{
                  opacity: "0.2",
                  transformOrigin: "409.875px 245.678px 0px",
                }}
                className="animable"
              >
                <path
                  d="M369.39,223.44,447,268.1a5.44,5.44,0,0,1,1.86,2l3.26-1.89a5.12,5.12,0,0,0-1.84-1.93l-77.6-44.67a1.85,1.85,0,0,0-1.93-.15c-.47.29-2.56,1.47-3.12,1.77A1.9,1.9,0,0,1,369.39,223.44Z"
                  style={{
                    fill: "rgb(255, 255, 255)",
                    transformOrigin: "409.875px 245.678px 0px",
                  }}
                  id="eln6vra95zrr"
                  className="animable"
                ></path>
              </g>
            </g>
            <g id="elco59tpqx5ur">
              <path
                d="M452.92,275.92v-5.09a5.48,5.48,0,0,0-.81-2.65l-3.27,1.88a5.26,5.26,0,0,1,.8,2.63v5.14Z"
                style={{
                  opacity: "0.15",
                  transformOrigin: "450.88px 273.005px 0px",
                }}
                className="animable"
              ></path>
            </g>
            <path
              d="M446.75,270.61a2.67,2.67,0,0,1,1,2.13c0,.86-.45,1.29-1,1a2.64,2.64,0,0,1-1-2.13C445.74,270.73,446.19,270.29,446.75,270.61Z"
              style={{
                fill: "rgb(255, 255, 255)",
                transformOrigin: "446.75px 272.168px 0px",
              }}
              id="ele4hbizq2abk"
              className="animable"
            ></path>
            <path
              d="M443.12,268.52a2.64,2.64,0,0,1,1,2.13c0,.85-.45,1.29-1,1a2.69,2.69,0,0,1-1-2.13C442.12,268.63,442.57,268.2,443.12,268.52Z"
              style={{
                fill: "rgb(255, 255, 255)",
                transformOrigin: "443.12px 270.077px 0px",
              }}
              id="elh2x9uxbcr8w"
              className="animable"
            ></path>
            <path
              d="M439.5,266.42a2.65,2.65,0,0,1,1,2.13c0,.86-.45,1.29-1,1a2.67,2.67,0,0,1-1-2.13C438.49,266.53,439,266.1,439.5,266.42Z"
              style={{
                fill: "rgb(255, 255, 255)",
                transformOrigin: "439.5px 267.977px 0px",
              }}
              id="elg1dbr4taods"
              className="animable"
            ></path>
            <path
              d="M448.69,335.69l.13-.08,2.69-1.55a2.8,2.8,0,0,0,1.38-2.05,2.56,2.56,0,0,0,0-.39V275.91l-3.28,1.92v56.25a1.73,1.73,0,0,1-.82,1.5.24.24,0,0,1-.09.06s0,0,0,0Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "450.794px 305.8px 0px",
              }}
              id="el2omcgz2bcw1"
              className="animable"
            ></path>
          </g>
          <g id="eln2duotnore">
            <g
              style={{
                opacity: "0.6",
                transformOrigin: "374.713px 274.294px 0px",
              }}
              className="animable"
            >
              <path
                d="M373,260.62l3.43,2a1.38,1.38,0,0,1,.62,1.08v1.26c0,.39-.28.55-.62.36l-3.43-2a1.38,1.38,0,0,1-.62-1.08V261C372.34,260.58,372.62,260.42,373,260.62Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  transformOrigin: "374.713px 262.967px 0px",
                }}
                id="elw9tm2u3frh"
                className="animable"
              ></path>
              <path
                d="M373,265.63l3.43,2a1.38,1.38,0,0,1,.62,1.08V270c0,.4-.28.56-.62.36l-3.43-2a1.38,1.38,0,0,1-.62-1.08V266C372.34,265.6,372.62,265.43,373,265.63Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  transformOrigin: "374.713px 267.996px 0px",
                }}
                id="elv23szbs8nx"
                className="animable"
              ></path>
              <path
                d="M373,270.65l3.43,2a1.38,1.38,0,0,1,.62,1.07V275c0,.39-.28.55-.62.35l-3.43-2a1.4,1.4,0,0,1-.62-1.08V271C372.34,270.61,372.62,270.45,373,270.65Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  transformOrigin: "374.713px 273px 0px",
                }}
                id="elrb8iu3yu3kf"
                className="animable"
              ></path>
              <path
                d="M373,275.66l3.43,2a1.38,1.38,0,0,1,.62,1.08V280c0,.4-.28.56-.62.36l-3.43-2a1.38,1.38,0,0,1-.62-1.08V276C372.34,275.62,372.62,275.46,373,275.66Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  transformOrigin: "374.713px 278.01px 0px",
                }}
                id="eltmrkh9rryj"
                className="animable"
              ></path>
              <path
                d="M373,283.27l3.43,2a1.38,1.38,0,0,1,.62,1.08v1.26c0,.39-.28.56-.62.36L373,286a1.38,1.38,0,0,1-.62-1.08v-1.26C372.34,283.23,372.62,283.07,373,283.27Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  transformOrigin: "374.713px 285.619px 0px",
                }}
                id="el4b5dulqby6m"
                className="animable"
              ></path>
            </g>
          </g>
          <g id="el0edqhm9loa6">
            <g
              style={{
                opacity: "0.6",
                transformOrigin: "374.713px 248.13px 0px",
              }}
              className="animable"
            >
              <path
                d="M373,238.26l3.43,2a1.38,1.38,0,0,1,.62,1.08v1.26c0,.39-.28.56-.62.36L373,241a1.38,1.38,0,0,1-.62-1.08v-1.26C372.34,238.22,372.62,238.06,373,238.26Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  transformOrigin: "374.713px 240.61px 0px",
                }}
                id="elkn1oyccdyic"
                className="animable"
              ></path>
              <path
                d="M373,243.27l3.43,2a1.38,1.38,0,0,1,.62,1.08v1.26c0,.4-.28.56-.62.36L373,246a1.38,1.38,0,0,1-.62-1.08v-1.26C372.34,243.24,372.62,243.08,373,243.27Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  transformOrigin: "374.713px 245.623px 0px",
                }}
                id="el85z08fysvmv"
                className="animable"
              ></path>
              <path
                d="M373,248.29l3.43,2a1.38,1.38,0,0,1,.62,1.08v1.26c0,.39-.28.55-.62.35L373,251a1.4,1.4,0,0,1-.62-1.08v-1.26C372.34,248.25,372.62,248.09,373,248.29Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  transformOrigin: "374.713px 250.635px 0px",
                }}
                id="elsfq32lsc82b"
                className="animable"
              ></path>
              <path
                d="M373,253.3l3.43,2a1.38,1.38,0,0,1,.62,1.08v1.26c0,.4-.28.56-.62.36L373,256a1.38,1.38,0,0,1-.62-1.08v-1.26C372.34,253.26,372.62,253.1,373,253.3Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  transformOrigin: "374.713px 255.65px 0px",
                }}
                id="elxloc098zhbj"
                className="animable"
              ></path>
            </g>
          </g>
          <path
            d="M381.84,244.35l19.17,11a1.35,1.35,0,0,1,.63,1.05c0,.37-.28.52-.63.32l-19.17-11a1.35,1.35,0,0,1-.63-1.05C381.21,244.29,381.49,244.14,381.84,244.35Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "391.425px 250.532px 0px",
            }}
            id="elyssqzyf5tac"
            className="animable"
          ></path>
          <path
            d="M381.81,260.81l29.41,16.94a1.34,1.34,0,0,1,.63,1c0,.38-.28.52-.63.32l-29.41-16.93a1.35,1.35,0,0,1-.63-1.05C381.18,260.75,381.46,260.61,381.81,260.81Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "396.515px 269.939px 0px",
            }}
            id="el3a80g8zjvs"
            className="animable"
          ></path>
          <path
            d="M403.45,256.8l8.16,4.71a1.35,1.35,0,0,1,.63,1.05c0,.38-.28.52-.63.32l-8.16-4.72a1.33,1.33,0,0,1-.63-1C402.82,256.74,403.1,256.6,403.45,256.8Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "407.53px 259.841px 0px",
            }}
            id="elbg21v90ub28"
            className="animable"
          ></path>
          <path
            d="M381.84,248.27l6.89,3.94a1.35,1.35,0,0,1,.63,1c0,.38-.28.52-.63.32l-6.89-4a1.35,1.35,0,0,1-.63-1C381.21,248.21,381.49,248.07,381.84,248.27Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "385.285px 250.899px 0px",
            }}
            id="elgeiejuy233o"
            className="animable"
          ></path>
          <g id="el9jdatm3c82o">
            <path
              d="M381.84,248.27l6.89,3.94a1.35,1.35,0,0,1,.63,1c0,.38-.28.52-.63.32l-6.89-4a1.35,1.35,0,0,1-.63-1C381.21,248.21,381.49,248.07,381.84,248.27Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.6",
                transformOrigin: "385.285px 250.899px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M381.84,252.16l7.56,4.38a1.35,1.35,0,0,1,.63,1c0,.38-.28.52-.63.32l-7.56-4.38a1.35,1.35,0,0,1-.63-1.05C381.21,252.11,381.49,252,381.84,252.16Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "385.62px 255.019px 0px",
            }}
            id="el83gu82imcao"
            className="animable"
          ></path>
          <g id="eldtcxdik6q0m">
            <path
              d="M381.84,252.16l7.56,4.38a1.35,1.35,0,0,1,.63,1c0,.38-.28.52-.63.32l-7.56-4.38a1.35,1.35,0,0,1-.63-1.05C381.21,252.11,381.49,252,381.84,252.16Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.6",
                transformOrigin: "385.62px 255.019px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M391.17,253.62l5.73,3.28a1.35,1.35,0,0,1,.63,1.05c0,.38-.28.52-.63.32L391.17,255a1.35,1.35,0,0,1-.63-1.05C390.54,253.56,390.82,253.42,391.17,253.62Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "394.035px 255.945px 0px",
            }}
            id="el17g7lkfcst5"
            className="animable"
          ></path>
          <g id="elux17dljir5q">
            <path
              d="M391.17,253.62l5.73,3.28a1.35,1.35,0,0,1,.63,1.05c0,.38-.28.52-.63.32L391.17,255a1.35,1.35,0,0,1-.63-1.05C390.54,253.56,390.82,253.42,391.17,253.62Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.6",
                transformOrigin: "394.035px 255.945px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M388.4,274.44l23.21,13.27a1.34,1.34,0,0,1,.63,1c0,.38-.28.52-.63.32L388.4,275.81a1.35,1.35,0,0,1-.63-1.05C387.77,274.39,388.05,274.24,388.4,274.44Z"
            style={{
              fill: "rgb(255, 168, 167)",
              transformOrigin: "400.005px 281.736px 0px",
            }}
            id="el8mpeu9zcplo"
            className="animable"
          ></path>
          <path
            d="M388.4,270.55l23.21,13.24a1.35,1.35,0,0,1,.63,1c0,.37-.28.52-.63.32L388.4,271.91a1.34,1.34,0,0,1-.63-1C387.77,270.49,388.05,270.35,388.4,270.55Z"
            style={{
              fill: "rgb(255, 168, 167)",
              transformOrigin: "400.005px 277.83px 0px",
            }}
            id="el9hbsq5m8scb"
            className="animable"
          ></path>
          <path
            d="M391.42,257.73l6.76,3.84a1.35,1.35,0,0,1,.63,1.05c0,.37-.28.52-.63.31l-6.76-3.84a1.37,1.37,0,0,1-.63-1C390.79,257.67,391.08,257.52,391.42,257.73Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "394.8px 260.331px 0px",
            }}
            id="elw5q9tpc5gm9"
            className="animable"
          ></path>
          <g id="elmt0td2ca13">
            <path
              d="M391.42,257.73l6.76,3.84a1.35,1.35,0,0,1,.63,1.05c0,.37-.28.52-.63.31l-6.76-3.84a1.37,1.37,0,0,1-.63-1C390.79,257.67,391.08,257.52,391.42,257.73Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.6",
                transformOrigin: "394.8px 260.331px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M400.63,263l10.61,6.26a1.37,1.37,0,0,1,.63,1.05c0,.37-.29.52-.63.32l-10.61-6.27a1.33,1.33,0,0,1-.63-1C400,262.92,400.28,262.78,400.63,263Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "405.935px 266.808px 0px",
            }}
            id="els4cirbehy3e"
            className="animable"
          ></path>
          <g id="eldw47yysqu7b">
            <path
              d="M400.63,263l10.61,6.26a1.37,1.37,0,0,1,.63,1.05c0,.37-.29.52-.63.32l-10.61-6.27a1.33,1.33,0,0,1-.63-1C400,262.92,400.28,262.78,400.63,263Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.6",
                transformOrigin: "405.935px 266.808px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M381.81,256.25l16.37,9.5a1.35,1.35,0,0,1,.63,1.05c0,.38-.28.52-.63.32l-16.37-9.5a1.35,1.35,0,0,1-.63-1.05C381.18,256.19,381.46,256.05,381.81,256.25Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "389.995px 261.685px 0px",
            }}
            id="el0h7bvdfid0n"
            className="animable"
          ></path>
          <g id="elwyy481syek">
            <path
              d="M381.81,256.25l16.37,9.5a1.35,1.35,0,0,1,.63,1.05c0,.38-.28.52-.63.32l-16.37-9.5a1.35,1.35,0,0,1-.63-1.05C381.18,256.19,381.46,256.05,381.81,256.25Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.6",
                transformOrigin: "389.995px 261.685px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M400.63,267.16l10.61,6.27a1.37,1.37,0,0,1,.63,1c0,.38-.29.52-.63.32l-10.61-6.26a1.35,1.35,0,0,1-.63-1C400,267.11,400.28,267,400.63,267.16Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "405.935px 270.965px 0px",
            }}
            id="ela2u20ns9pb5"
            className="animable"
          ></path>
          <g id="elgtzd8fdcir4">
            <path
              d="M400.63,267.16l10.61,6.27a1.37,1.37,0,0,1,.63,1c0,.38-.29.52-.63.32l-10.61-6.26a1.35,1.35,0,0,1-.63-1C400,267.11,400.28,267,400.63,267.16Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.6",
                transformOrigin: "405.935px 270.965px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M381.84,287.15l7.56,4.38a1.34,1.34,0,0,1,.63,1c0,.38-.28.52-.63.32l-7.56-4.38a1.35,1.35,0,0,1-.63-1.05C381.21,287.09,381.49,287,381.84,287.15Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "385.62px 290.01px 0px",
            }}
            id="elxx2n34il8f9"
            className="animable"
          ></path>
          <g id="elpzdctb4sw3c">
            <path
              d="M381.84,287.15l7.56,4.38a1.34,1.34,0,0,1,.63,1c0,.38-.28.52-.63.32l-7.56-4.38a1.35,1.35,0,0,1-.63-1.05C381.21,287.09,381.49,287,381.84,287.15Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.6",
                transformOrigin: "385.62px 290.01px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M391.42,292.71l6.76,3.84a1.35,1.35,0,0,1,.63,1.05c0,.38-.28.52-.63.32l-6.76-3.85a1.37,1.37,0,0,1-.63-1C390.79,292.65,391.08,292.51,391.42,292.71Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "394.8px 295.316px 0px",
            }}
            id="elstravqbaou"
            className="animable"
          ></path>
          <g id="elxogtn7526mi">
            <path
              d="M391.42,292.71l6.76,3.84a1.35,1.35,0,0,1,.63,1.05c0,.38-.28.52-.63.32l-6.76-3.85a1.37,1.37,0,0,1-.63-1C390.79,292.65,391.08,292.51,391.42,292.71Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.6",
                transformOrigin: "394.8px 295.316px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M400.63,298l10.61,6.26a1.39,1.39,0,0,1,.63,1c0,.38-.29.52-.63.32l-10.61-6.26a1.35,1.35,0,0,1-.63-1.05C400,297.9,400.28,297.76,400.63,298Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "405.935px 301.776px 0px",
            }}
            id="elf6al5cvnrs"
            className="animable"
          ></path>
          <g id="elq1c1caj3q19">
            <path
              d="M400.63,298l10.61,6.26a1.39,1.39,0,0,1,.63,1c0,.38-.29.52-.63.32l-10.61-6.26a1.35,1.35,0,0,1-.63-1.05C400,297.9,400.28,297.76,400.63,298Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.6",
                transformOrigin: "405.935px 301.776px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M381.81,291.23l16.37,9.51a1.34,1.34,0,0,1,.63,1c0,.38-.28.52-.63.32l-16.37-9.5a1.35,1.35,0,0,1-.63-1.05C381.18,291.18,381.46,291,381.81,291.23Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "389.995px 296.639px 0px",
            }}
            id="el6zsazvfg115"
            className="animable"
          ></path>
          <g id="elj7vdu50b9e9">
            <path
              d="M381.81,291.23l16.37,9.51a1.34,1.34,0,0,1,.63,1c0,.38-.28.52-.63.32l-16.37-9.5a1.35,1.35,0,0,1-.63-1.05C381.18,291.18,381.46,291,381.81,291.23Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.6",
                transformOrigin: "389.995px 296.639px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M400.63,302.15l10.61,6.26a1.37,1.37,0,0,1,.63,1c0,.38-.29.52-.63.32l-10.61-6.26a1.35,1.35,0,0,1-.63-1.05C400,302.09,400.28,301.94,400.63,302.15Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "405.935px 305.937px 0px",
            }}
            id="elkhv5l1am6ih"
            className="animable"
          ></path>
          <g id="elcwpk69gbxqs">
            <path
              d="M400.63,302.15l10.61,6.26a1.37,1.37,0,0,1,.63,1c0,.38-.29.52-.63.32l-10.61-6.26a1.35,1.35,0,0,1-.63-1.05C400,302.09,400.28,301.94,400.63,302.15Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.6",
                transformOrigin: "405.935px 305.937px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M388.4,278.39l23.21,13.36a1.34,1.34,0,0,1,.63,1c0,.38-.28.52-.63.32L388.4,279.76a1.35,1.35,0,0,1-.63-1.05C387.77,278.33,388.05,278.19,388.4,278.39Z"
            style={{
              fill: "rgb(242, 143, 143)",
              transformOrigin: "400.005px 285.73px 0px",
            }}
            id="elx4abups4ws"
            className="animable"
          ></path>
          <path
            d="M388.4,282.3l23.21,13.35a1.36,1.36,0,0,1,.63,1.05c0,.38-.28.52-.63.32L388.4,283.66a1.34,1.34,0,0,1-.63-1C387.77,282.24,388.05,282.1,388.4,282.3Z"
            style={{
              fill: "rgb(242, 143, 143)",
              transformOrigin: "400.005px 289.661px 0px",
            }}
            id="el7q8y4aavug5"
            className="animable"
          ></path>
          <path
            d="M388.4,286.2l23.21,13.36a1.35,1.35,0,0,1,.63,1.05c0,.37-.28.52-.63.32L388.4,287.57a1.35,1.35,0,0,1-.63-1.05C387.77,286.14,388.05,286,388.4,286.2Z"
            style={{
              fill: "rgb(242, 143, 143)",
              transformOrigin: "400.005px 293.564px 0px",
            }}
            id="elj9spfz8g3r"
            className="animable"
          ></path>
          <path
            d="M382,266.28l2.91,1.7a1.34,1.34,0,0,1,.63,1c0,.38-.28.52-.63.32L382,267.65a1.35,1.35,0,0,1-.63-1C381.34,266.23,381.62,266.08,382,266.28Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "383.454px 267.792px 0px",
            }}
            id="elacitqigxgjp"
            className="animable"
          ></path>
          <g id="el96008pzf2iq">
            <path
              d="M382,266.28l2.91,1.7a1.34,1.34,0,0,1,.63,1c0,.38-.28.52-.63.32L382,267.65a1.35,1.35,0,0,1-.63-1C381.34,266.23,381.62,266.08,382,266.28Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.6",
                transformOrigin: "383.454px 267.792px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M382,274.68l2.91,1.69a1.36,1.36,0,0,1,.63,1.05c0,.38-.28.52-.63.32L382,276.05a1.35,1.35,0,0,1-.63-1.05C381.34,274.62,381.62,274.48,382,274.68Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "383.454px 276.21px 0px",
            }}
            id="elx6s2pwvx3hj"
            className="animable"
          ></path>
          <g id="elgqcnfvoogyp">
            <path
              d="M382,274.68l2.91,1.69a1.36,1.36,0,0,1,.63,1.05c0,.38-.28.52-.63.32L382,276.05a1.35,1.35,0,0,1-.63-1.05C381.34,274.62,381.62,274.48,382,274.68Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.6",
                transformOrigin: "383.454px 276.21px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M382,278.59l2.91,1.69a1.35,1.35,0,0,1,.63,1.05c0,.37-.28.52-.63.32L382,280a1.34,1.34,0,0,1-.63-1C381.34,278.53,381.62,278.39,382,278.59Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "383.454px 280.12px 0px",
            }}
            id="el69x3q6wu2ph"
            className="animable"
          ></path>
          <g id="elj8k7dusqt3q">
            <path
              d="M382,278.59l2.91,1.69a1.35,1.35,0,0,1,.63,1.05c0,.37-.28.52-.63.32L382,280a1.34,1.34,0,0,1-.63-1C381.34,278.53,381.62,278.39,382,278.59Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.6",
                transformOrigin: "383.454px 280.12px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M382,282.49l2.91,1.7a1.34,1.34,0,0,1,.63,1c0,.38-.28.52-.63.32L382,283.86a1.35,1.35,0,0,1-.63-1.05C381.34,282.44,381.62,282.29,382,282.49Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "383.454px 284.001px 0px",
            }}
            id="eltyfx8fex8oo"
            className="animable"
          ></path>
          <g id="el14qx4pxtahh">
            <path
              d="M382,282.49l2.91,1.7a1.34,1.34,0,0,1,.63,1c0,.38-.28.52-.63.32L382,283.86a1.35,1.35,0,0,1-.63-1.05C381.34,282.44,381.62,282.29,382,282.49Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.6",
                transformOrigin: "383.454px 284.001px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M444,279.42l-24.58-14.19c-.92-.53-1.66-.1-1.66.95v46.36a3.65,3.65,0,0,0,1.66,2.86L444,329.6c.92.52,1.65.09,1.65-1V282.28A3.64,3.64,0,0,0,444,279.42Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "431.705px 297.411px 0px",
            }}
            id="elf350haorlj8"
            className="animable"
          ></path>
          <path
            d="M441.75,304.93l-2.26-1.31c-.46-.26-.84-.07-.84.43a1.78,1.78,0,0,0,.84,1.38l2.26,1.31c.46.27.84.08.84-.42A1.81,1.81,0,0,0,441.75,304.93Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "440.62px 305.183px 0px",
            }}
            id="elh5wzkri5v2l"
            className="animable"
          ></path>
          <g id="el7jgvmx610l5">
            <path
              d="M441.75,304.93l-2.26-1.31c-.46-.26-.84-.07-.84.43a1.78,1.78,0,0,0,.84,1.38l2.26,1.31c.46.27.84.08.84-.42A1.81,1.81,0,0,0,441.75,304.93Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.6",
                transformOrigin: "440.62px 305.183px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M441.75,281.68l-2.26-1.31c-.46-.26-.84-.07-.84.43a1.78,1.78,0,0,0,.84,1.38l2.26,1.31c.46.27.84.08.84-.42A1.81,1.81,0,0,0,441.75,281.68Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "440.62px 281.933px 0px",
            }}
            id="elhd57lhrshav"
            className="animable"
          ></path>
          <g id="el51lqztxq04s">
            <path
              d="M441.75,281.68l-2.26-1.31c-.46-.26-.84-.07-.84.43a1.78,1.78,0,0,0,.84,1.38l2.26,1.31c.46.27.84.08.84-.42A1.81,1.81,0,0,0,441.75,281.68Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.6",
                transformOrigin: "440.62px 281.933px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M438.57,284.48l-2.26-1.3c-.47-.27-.84-.08-.84.42a1.78,1.78,0,0,0,.84,1.39l2.26,1.3c.46.27.84.08.84-.42A1.81,1.81,0,0,0,438.57,284.48Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "437.44px 284.735px 0px",
            }}
            id="elkhk1vqmas5n"
            className="animable"
          ></path>
          <g id="el49bfk9bnvil">
            <path
              d="M438.57,284.48l-2.26-1.3c-.47-.27-.84-.08-.84.42a1.78,1.78,0,0,0,.84,1.39l2.26,1.3c.46.27.84.08.84-.42A1.81,1.81,0,0,0,438.57,284.48Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.6",
                transformOrigin: "437.44px 284.735px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M438.57,289.12l-2.26-1.3c-.47-.27-.84-.08-.84.42a1.78,1.78,0,0,0,.84,1.39l2.26,1.3c.46.27.84.08.84-.42A1.81,1.81,0,0,0,438.57,289.12Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "437.44px 289.375px 0px",
            }}
            id="eleo4lwcuyylb"
            className="animable"
          ></path>
          <g id="ellawofjijqk">
            <path
              d="M438.57,289.12l-2.26-1.3c-.47-.27-.84-.08-.84.42a1.78,1.78,0,0,0,.84,1.39l2.26,1.3c.46.27.84.08.84-.42A1.81,1.81,0,0,0,438.57,289.12Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.6",
                transformOrigin: "437.44px 289.375px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M441.75,295.63l-2.26-1.31c-.46-.27-.84-.08-.84.42a1.79,1.79,0,0,0,.84,1.39l2.26,1.31c.46.26.84.07.84-.43A1.78,1.78,0,0,0,441.75,295.63Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "440.62px 295.877px 0px",
            }}
            id="els1ez7h8013e"
            className="animable"
          ></path>
          <g id="elrnghqkmgal">
            <path
              d="M441.75,295.63l-2.26-1.31c-.46-.27-.84-.08-.84.42a1.79,1.79,0,0,0,.84,1.39l2.26,1.31c.46.26.84.07.84-.43A1.78,1.78,0,0,0,441.75,295.63Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.6",
                transformOrigin: "440.62px 295.877px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M438.57,298.43l-2.26-1.3c-.47-.27-.84-.08-.84.42a1.78,1.78,0,0,0,.84,1.39l2.26,1.3c.46.27.84.08.84-.42A1.81,1.81,0,0,0,438.57,298.43Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "437.44px 298.685px 0px",
            }}
            id="el2fp4je1hehc"
            className="animable"
          ></path>
          <g id="elfmy0va3lju">
            <path
              d="M438.57,298.43l-2.26-1.3c-.47-.27-.84-.08-.84.42a1.78,1.78,0,0,0,.84,1.39l2.26,1.3c.46.27.84.08.84-.42A1.81,1.81,0,0,0,438.57,298.43Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.6",
                transformOrigin: "437.44px 298.685px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M435.55,278.1l-13.82-8c-.46-.26-.84-.07-.84.43a1.78,1.78,0,0,0,.84,1.38l13.82,8c.46.27.84.08.84-.42A1.81,1.81,0,0,0,435.55,278.1Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "428.64px 275.008px 0px",
            }}
            id="elifegqszvmrj"
            className="animable"
          ></path>
          <g id="el2819oycpdg5">
            <path
              d="M435.55,278.1l-13.82-8c-.46-.26-.84-.07-.84.43a1.78,1.78,0,0,0,.84,1.38l13.82,8c.46.27.84.08.84-.42A1.81,1.81,0,0,0,435.55,278.1Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.8",
                transformOrigin: "428.64px 275.008px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M435.55,301.35l-13.82-8c-.46-.26-.84-.08-.84.42a1.79,1.79,0,0,0,.84,1.39l13.82,8c.46.27.84.08.84-.42A1.81,1.81,0,0,0,435.55,301.35Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "428.64px 298.257px 0px",
            }}
            id="elmxhb1rxkia"
            className="animable"
          ></path>
          <g id="el0vhnuo4d3vcr">
            <path
              d="M435.55,301.35l-13.82-8c-.46-.26-.84-.08-.84.42a1.79,1.79,0,0,0,.84,1.39l13.82,8c.46.27.84.08.84-.42A1.81,1.81,0,0,0,435.55,301.35Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.8",
                transformOrigin: "428.64px 298.257px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M432.37,280.9l-10.64-6.13c-.46-.26-.84-.07-.84.43a1.78,1.78,0,0,0,.84,1.38l10.64,6.14c.46.26.84.07.84-.43A1.81,1.81,0,0,0,432.37,280.9Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "427.05px 278.745px 0px",
            }}
            id="ela1sd2eoie9"
            className="animable"
          ></path>
          <g id="eln64c9gt0sdc">
            <path
              d="M432.37,280.9l-10.64-6.13c-.46-.26-.84-.07-.84.43a1.78,1.78,0,0,0,.84,1.38l10.64,6.14c.46.26.84.07.84-.43A1.81,1.81,0,0,0,432.37,280.9Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.8",
                transformOrigin: "427.05px 278.745px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M432.37,285.55l-10.64-6.13c-.46-.26-.84-.07-.84.43a1.79,1.79,0,0,0,.84,1.38l10.64,6.13c.46.27.84.08.84-.42A1.81,1.81,0,0,0,432.37,285.55Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "427.05px 283.393px 0px",
            }}
            id="ely2xio8h6yw"
            className="animable"
          ></path>
          <g id="el9xo00nqr58i">
            <path
              d="M432.37,285.55l-10.64-6.13c-.46-.26-.84-.07-.84.43a1.79,1.79,0,0,0,.84,1.38l10.64,6.13c.46.27.84.08.84-.42A1.81,1.81,0,0,0,432.37,285.55Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.8",
                transformOrigin: "427.05px 283.393px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M435.55,292.05l-13.82-8c-.46-.26-.84-.08-.84.42a1.79,1.79,0,0,0,.84,1.39l13.82,8c.46.27.84.08.84-.42A1.81,1.81,0,0,0,435.55,292.05Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "428.64px 288.957px 0px",
            }}
            id="el0yf6ccroyv1"
            className="animable"
          ></path>
          <g id="elryvc2wexda">
            <path
              d="M435.55,292.05l-13.82-8c-.46-.26-.84-.08-.84.42a1.79,1.79,0,0,0,.84,1.39l13.82,8c.46.27.84.08.84-.42A1.81,1.81,0,0,0,435.55,292.05Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.8",
                transformOrigin: "428.64px 288.957px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M432.37,294.86l-10.64-6.14c-.46-.26-.84-.08-.84.42a1.79,1.79,0,0,0,.84,1.39l10.64,6.14c.46.26.84.07.84-.43A1.78,1.78,0,0,0,432.37,294.86Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "427.05px 292.694px 0px",
            }}
            id="eld449ojibnlm"
            className="animable"
          ></path>
          <g id="el29izvis3yxk">
            <path
              d="M432.37,294.86l-10.64-6.14c-.46-.26-.84-.08-.84.42a1.79,1.79,0,0,0,.84,1.39l10.64,6.14c.46.26.84.07.84-.43A1.78,1.78,0,0,0,432.37,294.86Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.8",
                transformOrigin: "427.05px 292.694px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M441.75,314.28,439.49,313c-.46-.26-.84-.07-.84.43a1.81,1.81,0,0,0,.84,1.39l2.26,1.3c.46.27.84.08.84-.42A1.81,1.81,0,0,0,441.75,314.28Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "440.62px 314.563px 0px",
            }}
            id="elpiqjiways"
            className="animable"
          ></path>
          <g id="el4tc2e543w85">
            <path
              d="M441.75,314.28,439.49,313c-.46-.26-.84-.07-.84.43a1.81,1.81,0,0,0,.84,1.39l2.26,1.3c.46.27.84.08.84-.42A1.81,1.81,0,0,0,441.75,314.28Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.6",
                transformOrigin: "440.62px 314.563px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M438.57,307.78l-2.26-1.3c-.47-.27-.84-.08-.84.42a1.78,1.78,0,0,0,.84,1.39l2.26,1.3c.46.27.84.08.84-.42A1.81,1.81,0,0,0,438.57,307.78Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "437.44px 308.035px 0px",
            }}
            id="elk5a1m7t1q6j"
            className="animable"
          ></path>
          <g id="elxqxuc61iuzq">
            <path
              d="M438.57,307.78l-2.26-1.3c-.47-.27-.84-.08-.84.42a1.78,1.78,0,0,0,.84,1.39l2.26,1.3c.46.27.84.08.84-.42A1.81,1.81,0,0,0,438.57,307.78Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.6",
                transformOrigin: "437.44px 308.035px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M435.55,310.7l-13.82-8c-.46-.26-.84-.07-.84.43a1.78,1.78,0,0,0,.84,1.38l13.82,8c.46.27.84.08.84-.42A1.81,1.81,0,0,0,435.55,310.7Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "428.64px 307.608px 0px",
            }}
            id="el3qonswxfuj"
            className="animable"
          ></path>
          <g id="elalo2hcmvgvn">
            <path
              d="M435.55,310.7l-13.82-8c-.46-.26-.84-.07-.84.43a1.78,1.78,0,0,0,.84,1.38l13.82,8c.46.27.84.08.84-.42A1.81,1.81,0,0,0,435.55,310.7Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.8",
                transformOrigin: "428.64px 307.608px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M432.37,304.21l-10.64-6.14c-.46-.26-.84-.07-.84.43a1.78,1.78,0,0,0,.84,1.38L432.37,306c.46.26.84.07.84-.43A1.78,1.78,0,0,0,432.37,304.21Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "427.05px 302.035px 0px",
            }}
            id="elk0gmws5ob3j"
            className="animable"
          ></path>
          <g id="eldv5lcwwyzeu">
            <path
              d="M432.37,304.21l-10.64-6.14c-.46-.26-.84-.07-.84.43a1.78,1.78,0,0,0,.84,1.38L432.37,306c.46.26.84.07.84-.43A1.78,1.78,0,0,0,432.37,304.21Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.8",
                transformOrigin: "427.05px 302.035px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M441.75,323.54l-2.26-1.3c-.46-.27-.84-.08-.84.42a1.81,1.81,0,0,0,.84,1.39l2.26,1.3c.46.27.84.08.84-.42A1.81,1.81,0,0,0,441.75,323.54Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "440.62px 323.795px 0px",
            }}
            id="elvrhi0icaa2a"
            className="animable"
          ></path>
          <g id="elui4066r1s6">
            <path
              d="M441.75,323.54l-2.26-1.3c-.46-.27-.84-.08-.84.42a1.81,1.81,0,0,0,.84,1.39l2.26,1.3c.46.27.84.08.84-.42A1.81,1.81,0,0,0,441.75,323.54Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.6",
                transformOrigin: "440.62px 323.795px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M438.57,317l-2.26-1.3c-.47-.27-.84-.08-.84.42a1.78,1.78,0,0,0,.84,1.39l2.26,1.3c.46.27.84.08.84-.42A1.81,1.81,0,0,0,438.57,317Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "437.44px 317.255px 0px",
            }}
            id="elq8avbqzniv"
            className="animable"
          ></path>
          <g id="eljgz910sjr6p">
            <path
              d="M438.57,317l-2.26-1.3c-.47-.27-.84-.08-.84.42a1.78,1.78,0,0,0,.84,1.39l2.26,1.3c.46.27.84.08.84-.42A1.81,1.81,0,0,0,438.57,317Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.6",
                transformOrigin: "437.44px 317.255px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M435.55,320l-13.82-8c-.46-.26-.84-.07-.84.43a1.78,1.78,0,0,0,.84,1.38l13.82,8c.46.27.84.08.84-.42A1.81,1.81,0,0,0,435.55,320Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "428.64px 316.908px 0px",
            }}
            id="elr39yvsrx6nj"
            className="animable"
          ></path>
          <g id="el9xlawh0p1z9">
            <path
              d="M435.55,320l-13.82-8c-.46-.26-.84-.07-.84.43a1.78,1.78,0,0,0,.84,1.38l13.82,8c.46.27.84.08.84-.42A1.81,1.81,0,0,0,435.55,320Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.8",
                transformOrigin: "428.64px 316.908px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M432.37,313.47l-10.64-6.14c-.46-.26-.84-.07-.84.43a1.78,1.78,0,0,0,.84,1.38l10.64,6.14c.46.26.84.08.84-.42A1.79,1.79,0,0,0,432.37,313.47Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "427.05px 311.306px 0px",
            }}
            id="elzk4z55zt0o"
            className="animable"
          ></path>
          <g id="elpgeselpl2bg">
            <path
              d="M432.37,313.47l-10.64-6.14c-.46-.26-.84-.07-.84.43a1.78,1.78,0,0,0,.84,1.38l10.64,6.14c.46.26.84.08.84-.42A1.79,1.79,0,0,0,432.37,313.47Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.8",
                transformOrigin: "427.05px 311.306px 0px",
              }}
              className="animable"
            ></path>
          </g>
        </g>
      </g>
      <g
        id="freepik--speech-bubble-2--inject-9"
        style={{ transformOrigin: "423.17px 179.672px 0px" }}
        className="animable"
      >
        <g
          id="freepik--speech-bubble--inject-9"
          style={{ transformOrigin: "423.17px 179.672px 0px" }}
          className="animable"
        >
          <g
            id="freepik--speech-bubble--inject-9"
            style={{ transformOrigin: "423.17px 179.672px 0px" }}
            className="animable"
          >
            <path
              d="M427.24,221.08l4-7.61-3.25-9.4v-5.75l10,5.75v5.76l-4.28,7.41a.6.6,0,0,1-.29.26h0Z"
              style={{
                fill: "rgb(143, 18, 35)",
                transformOrigin: "432.615px 209.7px 0px",
              }}
              id="el4yd5kw49z2"
              className="animable"
            ></path>
            <g id="elm9p68qjuv8o">
              <path
                d="M427.24,221.08l4-7.61-3.25-9.4v-5.75l10,5.75v5.76l-4.28,7.41a.6.6,0,0,1-.29.26h0Z"
                style={{
                  opacity: "0.2",
                  transformOrigin: "432.615px 209.7px 0px",
                }}
                className="animable"
              ></path>
            </g>
            <path
              d="M391.17,145.5a6.59,6.59,0,0,1,3-5.17l2.43-1.41a6.61,6.61,0,0,1,6,0l49.58,28.67a6.59,6.59,0,0,1,3,5.18v41a6.61,6.61,0,0,1-3,5.18l-2.44,1.4a6.61,6.61,0,0,1-6,0l-12-6.93-4.28,7.4a.63.63,0,0,1-1.15-.11l-4.52-13-27.63-16a6.6,6.6,0,0,1-3-5.17Z"
              style={{
                fill: "rgb(143, 18, 35)",
                transformOrigin: "423.17px 179.672px 0px",
              }}
              id="els1cifumt697"
              className="animable"
            ></path>
            <g id="elsjvm2mzfkd">
              <path
                d="M455.12,213.8a6.61,6.61,0,0,1-3,5.18l-2.44,1.4a6.65,6.65,0,0,1-5.46.24c1.41.53,2.48-.26,2.48-2v-41a6.16,6.16,0,0,0-.88-3l8.41-4.85a6.11,6.11,0,0,1,.87,3Z"
                style={{
                  opacity: "0.2",
                  transformOrigin: "449.67px 195.432px 0px",
                }}
                className="animable"
              ></path>
            </g>
            <g id="elab7u6ysnifi">
              <path
                d="M391.27,144.65c.35-1.27,1.5-1.67,2.88-.88l49.58,28.68a5.91,5.91,0,0,1,2.11,2.23l8.4-4.85a5.91,5.91,0,0,0-2.11-2.23l-49.56-28.68a6.69,6.69,0,0,0-6,0l-2.44,1.41A6.6,6.6,0,0,0,391.27,144.65Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: "0.3",
                  transformOrigin: "422.755px 156.445px 0px",
                }}
                className="animable"
              ></path>
            </g>
          </g>
          <g
            id="freepik----inject-9"
            style={{ transformOrigin: "419.441px 182.235px 0px" }}
            className="animable"
          >
            <path
              d="M398.5,169.3a1.38,1.38,0,0,1,.2-.87,1.42,1.42,0,0,1,.56-.38l10.42-4.81a.52.52,0,0,1,.17,0l.12.05a1.11,1.11,0,0,1,.39.47,1.66,1.66,0,0,1,.16.69v6.5c0,.54-.1.87-.3,1a2,2,0,0,1-.54.28L405.12,174l4.56,7q.24.35.54.87a2.74,2.74,0,0,1,.3,1.34v6.5a.71.71,0,0,1-.16.51.3.3,0,0,1-.39,0,.47.47,0,0,1-.12-.09l-.17-.2-10.42-16.85a6.34,6.34,0,0,1-.56-1,2.75,2.75,0,0,1-.2-1.09Z"
              style={{
                fill: "rgb(255, 255, 255)",
                transformOrigin: "404.508px 176.763px 0px",
              }}
              id="ellcwwrhllo3n"
              className="animable"
            ></path>
            <path
              d="M421.23,167a1.28,1.28,0,0,1,.39-.59c.17-.16.42-.14.75.05l3.5,2a1.07,1.07,0,0,1,.4.49,1.72,1.72,0,0,1,.17.72,1.26,1.26,0,0,1-.05.33l-8.81,27.38a1.32,1.32,0,0,1-.37.59c-.17.17-.43.15-.78-.05l-3.41-2a1.14,1.14,0,0,1-.41-.49,1.77,1.77,0,0,1-.17-.73,1,1,0,0,1,.06-.32Z"
              style={{
                fill: "rgb(255, 255, 255)",
                transformOrigin: "419.44px 182.194px 0px",
              }}
              id="elfj0uqyi3lt7"
              className="animable"
            ></path>
            <path
              d="M440.38,195.17a1.39,1.39,0,0,1-.19.87,1.49,1.49,0,0,1-.56.38l-10.43,4.81a.48.48,0,0,1-.17,0l-.12,0a1.17,1.17,0,0,1-.39-.47,1.65,1.65,0,0,1-.15-.69v-6.5q0-.81.3-1a2.32,2.32,0,0,1,.53-.26l4.56-1.78-4.56-7c-.15-.23-.33-.52-.53-.89a2.85,2.85,0,0,1-.3-1.36v-6.5a.71.71,0,0,1,.15-.51.3.3,0,0,1,.39,0,.47.47,0,0,1,.12.09l.17.2,10.43,16.85a7.22,7.22,0,0,1,.56,1,2.73,2.73,0,0,1,.19,1.09Z"
              style={{
                fill: "rgb(255, 255, 255)",
                transformOrigin: "434.378px 187.718px 0px",
              }}
              id="elzec5vsdpta"
              className="animable"
            ></path>
          </g>
        </g>
      </g>
      <g
        id="freepik--connection-2--inject-9"
        style={{ transformOrigin: "284.716px 262.99px 0px" }}
        className="animable"
      >
        <polygon
          points="325.59 317.99 253.58 276.42 253.58 217.66 254.31 217.66 254.31 275.99 325.96 317.36 325.59 317.99"
          style={{
            fill: "rgb(143, 18, 35)",
            transformOrigin: "289.77px 267.825px 0px",
          }}
          id="elgwdohm3iess"
          className="animable"
        ></polygon>
        <polygon
          points="329.57 315.69 257.56 274.11 257.56 227.66 258.3 227.66 258.3 273.69 329.94 315.05 329.57 315.69"
          style={{
            fill: "rgb(143, 18, 35)",
            transformOrigin: "293.75px 271.675px 0px",
          }}
          id="elqyrq3zibrma"
          className="animable"
        ></polygon>
        <polygon
          points="333.58 313.38 261.56 271.81 261.56 228.96 262.3 228.96 262.3 271.38 333.95 312.74 333.58 313.38"
          style={{
            fill: "rgb(143, 18, 35)",
            transformOrigin: "297.755px 271.17px 0px",
          }}
          id="el9mzilssdaxh"
          className="animable"
        ></polygon>
        <polygon
          points="289.64 311.12 281.47 306.4 281.47 297.18 249.52 278.69 249.52 207.99 250.26 207.99 250.26 278.26 282.21 296.75 282.21 305.97 290.01 310.48 289.64 311.12"
          style={{
            fill: "rgb(143, 18, 35)",
            transformOrigin: "269.765px 259.555px 0px",
          }}
          id="elxw6r2g3y39g"
          className="animable"
        ></polygon>
        <polygon
          points="305.62 283.41 293.72 276.54 277.75 276.54 265.5 269.46 265.5 229.53 266.23 229.53 266.23 269.04 277.94 275.81 293.92 275.81 305.99 282.77 305.62 283.41"
          style={{
            fill: "rgb(143, 18, 35)",
            transformOrigin: "285.745px 256.47px 0px",
          }}
          id="elrya1ax2ijnn"
          className="animable"
        ></polygon>
        <path
          d="M291.9,314.06a4.53,4.53,0,0,1-2.26-.55,1.79,1.79,0,0,1-1-1.51,1.81,1.81,0,0,1,1-1.52h0a4.92,4.92,0,0,1,4.51,0,1.81,1.81,0,0,1,1,1.52,1.79,1.79,0,0,1-1,1.51A4.52,4.52,0,0,1,291.9,314.06ZM290,311.12c-.44.25-.68.56-.68.88s.24.62.68.88a4.24,4.24,0,0,0,3.77,0c.44-.26.68-.57.68-.88s-.24-.63-.68-.88a4.24,4.24,0,0,0-3.77,0Z"
          style={{
            fill: "rgb(143, 18, 35)",
            transformOrigin: "291.895px 311.997px 0px",
          }}
          id="eldsttjdfdb8j"
          className="animable"
        ></path>
        <path
          d="M307.88,286.36a4.69,4.69,0,0,1-2.26-.55,1.62,1.62,0,0,1,0-3h0a4.94,4.94,0,0,1,4.52,0,1.62,1.62,0,0,1,0,3A4.69,4.69,0,0,1,307.88,286.36ZM306,283.42h0a.91.91,0,0,0,0,1.75,4.26,4.26,0,0,0,3.78,0,.91.91,0,0,0,0-1.75A4.26,4.26,0,0,0,306,283.42Z"
          style={{
            fill: "rgb(143, 18, 35)",
            transformOrigin: "307.88px 284.312px 0px",
          }}
          id="elmjhnkxe6leh"
          className="animable"
        ></path>
        <polygon
          points="238.27 266.94 237.54 266.94 237.54 262.23 245.53 248.4 245.53 218 246.26 218 246.26 248.59 238.27 262.43 238.27 266.94"
          style={{
            fill: "rgb(143, 18, 35)",
            transformOrigin: "241.9px 242.47px 0px",
          }}
          id="elorzkszignk"
          className="animable"
        ></polygon>
        <path
          d="M237,272.39a1.36,1.36,0,0,1-.72-.19,1.79,1.79,0,0,1-.79-1.66,4.91,4.91,0,0,1,2.25-3.9,1.62,1.62,0,0,1,2.63,1.51,4.94,4.94,0,0,1-2.26,3.91A2.24,2.24,0,0,1,237,272.39Zm1.85-5.35a1.57,1.57,0,0,0-.74.23,4.27,4.27,0,0,0-1.89,3.27.91.91,0,0,0,1.52.88,4.26,4.26,0,0,0,1.89-3.27,1.12,1.12,0,0,0-.42-1A.74.74,0,0,0,238.83,267Z"
          style={{
            fill: "rgb(143, 18, 35)",
            transformOrigin: "237.937px 269.33px 0px",
          }}
          id="el1w9iumgpt4a"
          className="animable"
        ></path>
      </g>
      <g
        id="freepik--Gears--inject-9"
        style={{ transformOrigin: "257.735px 178.077px 0px" }}
        className="animable"
      >
        <g
          id="freepik--gears--inject-9"
          style={{ transformOrigin: "257.735px 178.077px 0px" }}
          className="animable"
        >
          <g
            id="freepik--Gear--inject-9"
            style={{ transformOrigin: "271.787px 203.492px 0px" }}
            className="animable"
          >
            <path
              d="M276.67,214.82a1,1,0,0,1,1.29-.08l1.47,1.1a.82.82,0,0,0,1.17-.18l2.82-3.89a1.31,1.31,0,0,0,0-1.4l-1.13-1.75a1.69,1.69,0,0,1-.08-1.47,24.34,24.34,0,0,0,1-2.3,2.44,2.44,0,0,1,1-1.18L287,202.3a1.83,1.83,0,0,0,.89-1.22l.58-4.07a.55.55,0,0,0-.23-.59h0l0,0h0l-3.38-1.95h0a.62.62,0,0,0-.47-.06l-.32.08a2,2,0,0,1,.25-1.08l2.33-3.69a1.16,1.16,0,0,0-.12-1.34l-1.5-1.63a.62.62,0,0,0-.21-.15h0l-3.41-2h0a.71.71,0,0,0-.9.19l-2.19,2.64.08-1.47a.54.54,0,0,0-.24-.54h0l-3.42-2h0a.61.61,0,0,0-.5,0l-3,1.09a1.75,1.75,0,0,0-1,1.13l-.85,3.8a2.58,2.58,0,0,1-.88,1.32,20.09,20.09,0,0,0-1.63,1.35,1,1,0,0,1-.54.25l-2.31-1.33h0a.83.83,0,0,0-1.08.23l-2.82,3.89a1.35,1.35,0,0,0,0,1.4l1.13,1.75a1.64,1.64,0,0,1,.08,1.48,24.17,24.17,0,0,0-1,2.29,2.44,2.44,0,0,1-1,1.18l-2.76,1.37a1.8,1.8,0,0,0-.88,1.22L255.1,210a.54.54,0,0,0,.25.59h0l3.41,2h0a.63.63,0,0,0,.46.05l.32-.07a2.06,2.06,0,0,1-.24,1.07L257,217.25a1.18,1.18,0,0,0,.12,1.35l1.5,1.62a.66.66,0,0,0,.19.15h0l3.4,2v0a.7.7,0,0,0,.93-.16l2.2-2.64L265.2,221a.54.54,0,0,0,.25.55h0l3.4,2h0a.59.59,0,0,0,.51,0l3-1.1a1.74,1.74,0,0,0,1-1.12l.85-3.8a2.58,2.58,0,0,1,.88-1.32A18.64,18.64,0,0,0,276.67,214.82ZM276,196.15a7,7,0,0,1,.41,4c-.63,4.42-4,9-7.49,10.34a5.71,5.71,0,0,1-1.38.33,7.15,7.15,0,0,1-.42-4c.63-4.42,4-9,7.5-10.34A5.66,5.66,0,0,1,276,196.15Z"
              style={{
                fill: "rgb(143, 18, 35)",
                transformOrigin: "271.786px 203.487px 0px",
              }}
              id="el5iq8dd2z2js"
              className="animable"
            ></path>
            <g id="el7tcwstm7n0t">
              <path
                d="M276.67,214.82a1,1,0,0,1,1.29-.08l1.47,1.1a.82.82,0,0,0,1.17-.18l2.82-3.89a1.31,1.31,0,0,0,0-1.4l-1.13-1.75a1.69,1.69,0,0,1-.08-1.47,24.34,24.34,0,0,0,1-2.3,2.44,2.44,0,0,1,1-1.18L287,202.3a1.83,1.83,0,0,0,.89-1.22l.58-4.07a.55.55,0,0,0-.23-.59h0l0,0h0l-3.38-1.95h0a.62.62,0,0,0-.47-.06l-.32.08a2,2,0,0,1,.25-1.08l2.33-3.69a1.16,1.16,0,0,0-.12-1.34l-1.5-1.63a.62.62,0,0,0-.21-.15h0l-3.41-2h0a.71.71,0,0,0-.9.19l-2.19,2.64.08-1.47a.54.54,0,0,0-.24-.54h0l-3.42-2h0a.61.61,0,0,0-.5,0l-3,1.09a1.75,1.75,0,0,0-1,1.13l-.85,3.8a2.58,2.58,0,0,1-.88,1.32,20.09,20.09,0,0,0-1.63,1.35,1,1,0,0,1-.54.25l-2.31-1.33h0a.83.83,0,0,0-1.08.23l-2.82,3.89a1.35,1.35,0,0,0,0,1.4l1.13,1.75a1.64,1.64,0,0,1,.08,1.48,24.17,24.17,0,0,0-1,2.29,2.44,2.44,0,0,1-1,1.18l-2.76,1.37a1.8,1.8,0,0,0-.88,1.22L255.1,210a.54.54,0,0,0,.25.59h0l3.41,2h0a.63.63,0,0,0,.46.05l.32-.07a2.06,2.06,0,0,1-.24,1.07L257,217.25a1.18,1.18,0,0,0,.12,1.35l1.5,1.62a.66.66,0,0,0,.19.15h0l3.4,2v0a.7.7,0,0,0,.93-.16l2.2-2.64L265.2,221a.54.54,0,0,0,.25.55h0l3.4,2h0a.59.59,0,0,0,.51,0l3-1.1a1.74,1.74,0,0,0,1-1.12l.85-3.8a2.58,2.58,0,0,1,.88-1.32A18.64,18.64,0,0,0,276.67,214.82ZM276,196.15a7,7,0,0,1,.41,4c-.63,4.42-4,9-7.49,10.34a5.71,5.71,0,0,1-1.38.33,7.15,7.15,0,0,1-.42-4c.63-4.42,4-9,7.5-10.34A5.66,5.66,0,0,1,276,196.15Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: "0.2",
                  transformOrigin: "271.786px 203.487px 0px",
                }}
                className="animable"
              ></path>
            </g>
            <g id="el53uv1ho2ahs">
              <path
                d="M279.87,190.39a1.4,1.4,0,0,0,1.34-.39l2.7-3.24a.7.7,0,0,1,.86-.21l-3.37-2a.71.71,0,0,0-.9.19l-2.19,2.64-.12,1.95a.84.84,0,0,0,.81.87A4.94,4.94,0,0,1,279.87,190.39Zm5,4.05h0a.57.57,0,0,0-.46-.06l-.32.08a1.63,1.63,0,0,0,.06.45,8.3,8.3,0,0,1,.28,1.37.75.75,0,0,0,.92.65l2.46-.58a.61.61,0,0,1,.47,0Z"
                style={{
                  opacity: "0.1",
                  transformOrigin: "283.235px 190.707px 0px",
                }}
                className="animable"
              ></path>
            </g>
            <g id="elipxucziq6l">
              <path
                d="M279.85,202.12c.55-3.81-1.11-6.22-3.83-6a7,7,0,0,1,.42,4c-.63,4.42-4,9-7.5,10.34a5.08,5.08,0,0,1-1.37.32c.82,1.75,2.57,2.46,4.78,1.65C275.86,211.16,279.21,206.54,279.85,202.12Z"
                style={{
                  opacity: "0.1",
                  transformOrigin: "273.763px 204.435px 0px",
                }}
                className="animable"
              ></path>
            </g>
            <path
              d="M264.87,200.87a1.67,1.67,0,0,0-.2-.57l-1.13-1.75a1.34,1.34,0,0,1-.16-.91l-3.41-2a1.34,1.34,0,0,0,.16.91l1.13,1.75a1.37,1.37,0,0,1,.19.58Zm-6.12,11.64h0a.56.56,0,0,1-.24-.6l.58-4.07a1.76,1.76,0,0,1,.47-.89l-3.41-2a1.82,1.82,0,0,0-.46.89L255.1,210a.54.54,0,0,0,.24.59Zm14.1-21.13.84-3.75a1.7,1.7,0,0,1,.47-.8l-3.39-2a1.72,1.72,0,0,0-.49.79l-.84,3.75Zm-10.69,31a.65.65,0,0,1-.18-.15l-1.51-1.63a1.18,1.18,0,0,1-.12-1.34l2.34-3.69a1.9,1.9,0,0,0,.22-.66l-3.4-2a1.67,1.67,0,0,1-.23.66L257,217.25a1.19,1.19,0,0,0,.12,1.35l1.5,1.62a.53.53,0,0,0,.19.15Zm6.68,1.16a.22.22,0,0,1-.1-.09.38.38,0,0,1-.11-.22.55.55,0,0,1,0-.23l.2-3.43a.92.92,0,0,0-.2-.56.75.75,0,0,0-.24-.19l-.15-.07-.22,0a5.93,5.93,0,0,1-.86-.14,1.44,1.44,0,0,0-1.36.39l-.49.6L265.2,221a.57.57,0,0,0,.25.55h0Z"
              style={{
                fill: "rgb(143, 18, 35)",
                transformOrigin: "264.622px 204.185px 0px",
              }}
              id="elylm9n6ehpm"
              className="animable"
            ></path>
            <g id="elpwvb8caebqs">
              <path
                d="M264.87,200.87a1.67,1.67,0,0,0-.2-.57l-1.13-1.75a1.34,1.34,0,0,1-.16-.91l-3.41-2a1.34,1.34,0,0,0,.16.91l1.13,1.75a1.37,1.37,0,0,1,.19.58Zm-6.12,11.64h0a.56.56,0,0,1-.24-.6l.58-4.07a1.76,1.76,0,0,1,.47-.89l-3.41-2a1.82,1.82,0,0,0-.46.89L255.1,210a.54.54,0,0,0,.24.59Zm14.1-21.13.84-3.75a1.7,1.7,0,0,1,.47-.8l-3.39-2a1.72,1.72,0,0,0-.49.79l-.84,3.75Zm-10.69,31a.65.65,0,0,1-.18-.15l-1.51-1.63a1.18,1.18,0,0,1-.12-1.34l2.34-3.69a1.9,1.9,0,0,0,.22-.66l-3.4-2a1.67,1.67,0,0,1-.23.66L257,217.25a1.19,1.19,0,0,0,.12,1.35l1.5,1.62a.53.53,0,0,0,.19.15Zm6.68,1.16a.22.22,0,0,1-.1-.09.38.38,0,0,1-.11-.22.55.55,0,0,1,0-.23l.2-3.43a.92.92,0,0,0-.2-.56.75.75,0,0,0-.24-.19l-.15-.07-.22,0a5.93,5.93,0,0,1-.86-.14,1.44,1.44,0,0,0-1.36.39l-.49.6L265.2,221a.57.57,0,0,0,.25.55h0Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: "0.7",
                  transformOrigin: "264.622px 204.185px 0px",
                }}
                className="animable"
              ></path>
            </g>
            <path
              d="M273.31,221.3l.85-3.8a2.58,2.58,0,0,1,.88-1.32,18.64,18.64,0,0,0,1.63-1.36,1,1,0,0,1,1.29-.08l1.47,1.1a.82.82,0,0,0,1.17-.18l2.82-3.89a1.31,1.31,0,0,0,0-1.4l-1.13-1.75a1.69,1.69,0,0,1-.08-1.47,24.34,24.34,0,0,0,1-2.3,2.44,2.44,0,0,1,1-1.18L287,202.3a1.83,1.83,0,0,0,.89-1.22l.58-4.07a.54.54,0,0,0-.71-.65l-2.46.58a.73.73,0,0,1-.91-.65,11,11,0,0,0-.29-1.37,2.19,2.19,0,0,1,.19-1.53l2.33-3.69a1.16,1.16,0,0,0-.12-1.34l-1.5-1.63a.71.71,0,0,0-1.11,0l-2.7,3.24a1.4,1.4,0,0,1-1.34.39,5.2,5.2,0,0,0-.88-.14.84.84,0,0,1-.8-.87l.2-3.42a.51.51,0,0,0-.74-.56l-3,1.1a1.74,1.74,0,0,0-1,1.12l-.85,3.81a2.66,2.66,0,0,1-.88,1.31,18.64,18.64,0,0,0-1.63,1.36,1.05,1.05,0,0,1-1.3.08l-1.46-1.1a.82.82,0,0,0-1.17.18l-2.82,3.89a1.31,1.31,0,0,0,0,1.4l1.13,1.75a1.69,1.69,0,0,1,.08,1.47,24.34,24.34,0,0,0-1,2.3,2.44,2.44,0,0,1-1,1.18L260,206.62a1.82,1.82,0,0,0-.89,1.22l-.58,4.07a.54.54,0,0,0,.7.65l2.47-.58a.73.73,0,0,1,.91.65,11,11,0,0,0,.29,1.37,2.19,2.19,0,0,1-.19,1.53l-2.33,3.69a1.16,1.16,0,0,0,.12,1.34l1.49,1.63a.72.72,0,0,0,1.12,0l2.69-3.24a1.43,1.43,0,0,1,1.35-.39,5,5,0,0,0,.88.14.84.84,0,0,1,.8.87L268.6,223a.52.52,0,0,0,.75.56l3-1.1A1.74,1.74,0,0,0,273.31,221.3Zm-1-8.84c-3.51,1.29-5.83-1.24-5.2-5.66s4-9,7.5-10.34,5.83,1.24,5.2,5.66S275.86,211.16,272.35,212.46Z"
              style={{
                fill: "rgb(143, 18, 35)",
                transformOrigin: "273.501px 204.464px 0px",
              }}
              id="el93njt7h220u"
              className="animable"
            ></path>
            <g id="elvl1ct1ymw3i">
              <path
                d="M273.31,221.3l.85-3.8a2.58,2.58,0,0,1,.88-1.32,18.64,18.64,0,0,0,1.63-1.36,1,1,0,0,1,1.29-.08l1.47,1.1a.82.82,0,0,0,1.17-.18l2.82-3.89a1.31,1.31,0,0,0,0-1.4l-1.13-1.75a1.69,1.69,0,0,1-.08-1.47,24.34,24.34,0,0,0,1-2.3,2.44,2.44,0,0,1,1-1.18L287,202.3a1.83,1.83,0,0,0,.89-1.22l.58-4.07a.54.54,0,0,0-.71-.65l-2.46.58a.73.73,0,0,1-.91-.65,11,11,0,0,0-.29-1.37,2.19,2.19,0,0,1,.19-1.53l2.33-3.69a1.16,1.16,0,0,0-.12-1.34l-1.5-1.63a.71.71,0,0,0-1.11,0l-2.7,3.24a1.4,1.4,0,0,1-1.34.39,5.2,5.2,0,0,0-.88-.14.84.84,0,0,1-.8-.87l.2-3.42a.51.51,0,0,0-.74-.56l-3,1.1a1.74,1.74,0,0,0-1,1.12l-.85,3.81a2.66,2.66,0,0,1-.88,1.31,18.64,18.64,0,0,0-1.63,1.36,1.05,1.05,0,0,1-1.3.08l-1.46-1.1a.82.82,0,0,0-1.17.18l-2.82,3.89a1.31,1.31,0,0,0,0,1.4l1.13,1.75a1.69,1.69,0,0,1,.08,1.47,24.34,24.34,0,0,0-1,2.3,2.44,2.44,0,0,1-1,1.18L260,206.62a1.82,1.82,0,0,0-.89,1.22l-.58,4.07a.54.54,0,0,0,.7.65l2.47-.58a.73.73,0,0,1,.91.65,11,11,0,0,0,.29,1.37,2.19,2.19,0,0,1-.19,1.53l-2.33,3.69a1.16,1.16,0,0,0,.12,1.34l1.49,1.63a.72.72,0,0,0,1.12,0l2.69-3.24a1.43,1.43,0,0,1,1.35-.39,5,5,0,0,0,.88.14.84.84,0,0,1,.8.87L268.6,223a.52.52,0,0,0,.75.56l3-1.1A1.74,1.74,0,0,0,273.31,221.3Zm-1-8.84c-3.51,1.29-5.83-1.24-5.2-5.66s4-9,7.5-10.34,5.83,1.24,5.2,5.66S275.86,211.16,272.35,212.46Z"
                style={{
                  fill: "rgb(255, 255, 255); stroke: rgb(255, 255, 255); stroke-miterlimit: 10; stroke-width: 0.474802px",
                  opacity: "0.55",
                  transformOrigin: "273.501px 204.464px 0px",
                }}
                className="animable"
              ></path>
            </g>
          </g>
          <g
            id="freepik--gear--inject-9"
            style={{ transformOrigin: "282.541px 156.879px 0px" }}
            className="animable"
          >
            <path
              d="M288.45,170.56a1.25,1.25,0,0,1,1.56-.09l1.77,1.32a1,1,0,0,0,1.43-.21l3.42-4.71a1.63,1.63,0,0,0,0-1.7l-1.37-2.12a2,2,0,0,1-.09-1.78,29.23,29.23,0,0,0,1.17-2.78,2.93,2.93,0,0,1,1.26-1.43L301,155.4a2.22,2.22,0,0,0,1.07-1.48l.7-4.94a.66.66,0,0,0-.27-.7h0l-.05,0h0l-4.09-2.36h0a.82.82,0,0,0-.57-.06l-.38.09a2.41,2.41,0,0,1,.3-1.3l2.83-4.47a1.43,1.43,0,0,0-.15-1.63l-1.81-2a.91.91,0,0,0-.26-.19h0L294.18,134h0a.85.85,0,0,0-1.09.23l-2.66,3.2.11-1.79a.67.67,0,0,0-.3-.65h0l-4.14-2.39h0a.75.75,0,0,0-.61,0l-3.6,1.33a2.07,2.07,0,0,0-1.19,1.36l-1,4.6a3.13,3.13,0,0,1-1.07,1.6,24.8,24.8,0,0,0-2,1.64,1.26,1.26,0,0,1-.66.31l-2.79-1.62h0a1,1,0,0,0-1.3.28l-3.42,4.71a1.63,1.63,0,0,0,0,1.7l1.36,2.12a2,2,0,0,1,.1,1.78c-.44.91-.83,1.84-1.18,2.78a3,3,0,0,1-1.25,1.44l-3.35,1.66a2.18,2.18,0,0,0-1.07,1.47l-.71,4.94a.67.67,0,0,0,.3.72h0l4.13,2.39h0a.75.75,0,0,0,.56,0l.38-.09a2.38,2.38,0,0,1-.29,1.3l-2.83,4.48a1.4,1.4,0,0,0,.15,1.62l1.81,2a1.3,1.3,0,0,0,.23.18h0l4.12,2.38v0a.86.86,0,0,0,1.13-.19l2.66-3.2-.11,1.78a.66.66,0,0,0,.3.66h0l4.11,2.37h0a.67.67,0,0,0,.62,0l3.61-1.32a2.12,2.12,0,0,0,1.19-1.36l1-4.61a3.14,3.14,0,0,1,1.06-1.59A21.63,21.63,0,0,0,288.45,170.56ZM287.67,148a8.51,8.51,0,0,1,.5,4.85c-.76,5.34-4.83,10.95-9.08,12.51a6.39,6.39,0,0,1-1.67.4,8.55,8.55,0,0,1-.5-4.86c.76-5.35,4.83-11,9.08-12.52A6,6,0,0,1,287.67,148Z"
              style={{
                fill: "rgb(143, 18, 35)",
                transformOrigin: "282.566px 156.856px 0px",
              }}
              id="elihskuhvdjf"
              className="animable"
            ></path>
            <g id="elqkygtdcro6">
              <g
                style={{
                  opacity: "0.2",
                  transformOrigin: "282.566px 156.856px 0px",
                }}
                className="animable"
              >
                <path
                  d="M288.45,170.56a1.25,1.25,0,0,1,1.56-.09l1.77,1.32a1,1,0,0,0,1.43-.21l3.42-4.71a1.63,1.63,0,0,0,0-1.7l-1.37-2.12a2,2,0,0,1-.09-1.78,29.23,29.23,0,0,0,1.17-2.78,2.93,2.93,0,0,1,1.26-1.43L301,155.4a2.22,2.22,0,0,0,1.07-1.48l.7-4.94a.66.66,0,0,0-.27-.7h0l-.05,0h0l-4.09-2.36h0a.82.82,0,0,0-.57-.06l-.38.09a2.41,2.41,0,0,1,.3-1.3l2.83-4.47a1.43,1.43,0,0,0-.15-1.63l-1.81-2a.91.91,0,0,0-.26-.19h0L294.18,134h0a.85.85,0,0,0-1.09.23l-2.66,3.2.11-1.79a.67.67,0,0,0-.3-.65h0l-4.14-2.39h0a.75.75,0,0,0-.61,0l-3.6,1.33a2.07,2.07,0,0,0-1.19,1.36l-1,4.6a3.13,3.13,0,0,1-1.07,1.6,24.8,24.8,0,0,0-2,1.64,1.26,1.26,0,0,1-.66.31l-2.79-1.62h0a1,1,0,0,0-1.3.28l-3.42,4.71a1.63,1.63,0,0,0,0,1.7l1.36,2.12a2,2,0,0,1,.1,1.78c-.44.91-.83,1.84-1.18,2.78a3,3,0,0,1-1.25,1.44l-3.35,1.66a2.18,2.18,0,0,0-1.07,1.47l-.71,4.94a.67.67,0,0,0,.3.72h0l4.13,2.39h0a.75.75,0,0,0,.56,0l.38-.09a2.38,2.38,0,0,1-.29,1.3l-2.83,4.48a1.4,1.4,0,0,0,.15,1.62l1.81,2a1.3,1.3,0,0,0,.23.18h0l4.12,2.38v0a.86.86,0,0,0,1.13-.19l2.66-3.2-.11,1.78a.66.66,0,0,0,.3.66h0l4.11,2.37h0a.67.67,0,0,0,.62,0l3.61-1.32a2.12,2.12,0,0,0,1.19-1.36l1-4.61a3.14,3.14,0,0,1,1.06-1.59A21.63,21.63,0,0,0,288.45,170.56ZM287.67,148a8.51,8.51,0,0,1,.5,4.85c-.76,5.34-4.83,10.95-9.08,12.51a6.39,6.39,0,0,1-1.67.4,8.55,8.55,0,0,1-.5-4.86c.76-5.35,4.83-11,9.08-12.52A6,6,0,0,1,287.67,148Z"
                  id="eljc4qp50wcm"
                  style={{ transformOrigin: "282.566px 156.856px 0px" }}
                  className="animable"
                ></path>
              </g>
            </g>
            <g id="els60pd9pbcy">
              <path
                d="M292.32,141a1.73,1.73,0,0,0,1.63-.47l3.26-3.93a.87.87,0,0,1,1.05-.25L294.18,134a.86.86,0,0,0-1.09.22l-2.66,3.2-.14,2.37a1,1,0,0,0,1,1.05A7.11,7.11,0,0,1,292.32,141Zm6,4.91h0a.85.85,0,0,0-.56-.07l-.39.1a2.28,2.28,0,0,0,.07.54,10.6,10.6,0,0,1,.34,1.66.9.9,0,0,0,1.11.79l3-.7a.74.74,0,0,1,.56.06Z"
                style={{
                  opacity: "0.1",
                  transformOrigin: "296.369px 141.424px 0px",
                }}
                className="animable"
              ></path>
            </g>
            <g id="elo1fq1igkv5">
              <path
                d="M292.3,155.18c.66-4.62-1.34-7.53-4.64-7.23a8.48,8.48,0,0,1,.51,4.84c-.77,5.35-4.83,11-9.08,12.53a6.7,6.7,0,0,1-1.66.39c1,2.12,3.1,3,5.78,2C287.47,166.13,291.53,160.53,292.3,155.18Z"
                style={{
                  opacity: "0.1",
                  transformOrigin: "284.928px 158.025px 0px",
                }}
                className="animable"
              ></path>
            </g>
            <g id="elk3yxx0cj3ub">
              <g
                style={{
                  opacity: "0.3",
                  transformOrigin: "273.845px 157.66px 0px",
                }}
                className="animable"
              >
                <path
                  d="M274.15,153.67a1.76,1.76,0,0,0-.24-.69l-1.37-2.13a1.62,1.62,0,0,1-.19-1.09l-4.13-2.39a1.58,1.58,0,0,0,.2,1.1l1.36,2.12a1.7,1.7,0,0,1,.23.7Zm-7.41,14.1h0a.65.65,0,0,1-.3-.72l.7-4.93a2.11,2.11,0,0,1,.57-1.08l-4.12-2.38a2.12,2.12,0,0,0-.57,1.07l-.71,4.94a.65.65,0,0,0,.3.72Zm17.08-25.6,1-4.55a2.11,2.11,0,0,1,.58-1l-4.11-2.38a2,2,0,0,0-.59,1l-1,4.55Zm-12.95,37.5a1.24,1.24,0,0,1-.22-.18l-1.82-2a1.44,1.44,0,0,1-.15-1.63l2.83-4.47a2,2,0,0,0,.27-.8l-4.12-2.38a2.44,2.44,0,0,1-.27.8l-2.83,4.47a1.44,1.44,0,0,0,.15,1.63l1.81,2a.8.8,0,0,0,.23.19Zm8.09,1.41a.34.34,0,0,1-.12-.12.5.5,0,0,1-.14-.26,1.23,1.23,0,0,1,0-.28l.24-4.15a.59.59,0,0,0,0-.27.77.77,0,0,0-.21-.41,1,1,0,0,0-.29-.24l-.17-.07-.27-.06a7.18,7.18,0,0,1-1.05-.16,1.7,1.7,0,0,0-1.64.47l-.6.73-.11,1.78a.71.71,0,0,0,.3.66h0Z"
                  style={{
                    fill: "rgb(143, 18, 35)",
                    transformOrigin: "273.845px 157.66px 0px",
                  }}
                  id="elu8znygiz7hh"
                  className="animable"
                ></path>
              </g>
            </g>
            <path
              d="M284.38,178.41l1-4.61a3.14,3.14,0,0,1,1.06-1.59,21.63,21.63,0,0,0,2-1.65,1.25,1.25,0,0,1,1.56-.09l1.77,1.32a1,1,0,0,0,1.43-.21l3.42-4.71a1.63,1.63,0,0,0,0-1.7l-1.37-2.12a2,2,0,0,1-.09-1.78,29.23,29.23,0,0,0,1.17-2.78,2.93,2.93,0,0,1,1.26-1.43L301,155.4a2.22,2.22,0,0,0,1.07-1.48l.7-4.94a.65.65,0,0,0-.85-.78l-3,.7a.89.89,0,0,1-1.11-.79,12.19,12.19,0,0,0-.35-1.66,2.56,2.56,0,0,1,.23-1.84l2.83-4.47a1.43,1.43,0,0,0-.15-1.63l-1.81-2a.88.88,0,0,0-1.36,0L294,140.5a1.73,1.73,0,0,1-1.63.47,7.11,7.11,0,0,0-1.06-.17,1,1,0,0,1-1-1.05l.25-4.15a.63.63,0,0,0-.91-.67L286,136.26a2.15,2.15,0,0,0-1.19,1.36l-1,4.6a3.11,3.11,0,0,1-1.06,1.6c-.67.5-1.33,1.05-2,1.64a1.25,1.25,0,0,1-1.56.1l-1.77-1.33a1,1,0,0,0-1.43.22l-3.41,4.7a1.6,1.6,0,0,0,0,1.7l1.37,2.12a2,2,0,0,1,.1,1.79,29.32,29.32,0,0,0-1.18,2.78,3,3,0,0,1-1.26,1.43l-3.35,1.66a2.19,2.19,0,0,0-1.06,1.48l-.71,4.93a.65.65,0,0,0,.85.78l3-.7a.9.9,0,0,1,1.11.79,11.88,11.88,0,0,0,.34,1.66,2.63,2.63,0,0,1-.22,1.85l-2.83,4.47a1.42,1.42,0,0,0,.14,1.63l1.82,2a.87.87,0,0,0,1.35,0l3.26-3.93a1.7,1.7,0,0,1,1.64-.47,7.19,7.19,0,0,0,1.05.17,1,1,0,0,1,1,1.05l-.24,4.14a.62.62,0,0,0,.9.67l3.61-1.32A2.12,2.12,0,0,0,284.38,178.41Zm-1.16-10.71c-4.25,1.56-7.07-1.5-6.3-6.85s4.83-11,9.08-12.52,7.07,1.5,6.3,6.85S287.46,166.13,283.22,167.7Z"
              style={{
                fill: "rgb(143, 18, 35)",
                transformOrigin: "284.63px 158.041px 0px",
              }}
              id="elqoqcnh1y87"
              className="animable"
            ></path>
          </g>
          <g
            id="freepik--gear--inject-9"
            style={{ transformOrigin: "237.146px 186.86px 0px" }}
            className="animable"
          >
            <path
              d="M236.43,215.56l5.71-3.3a1.54,1.54,0,0,0,.69-1.06l.57-6.36a2.05,2.05,0,0,1,.59-1.18,35,35,0,0,0,3.17-3.36,1.1,1.1,0,0,1,1.12-.32l3.67,1.28a.9.9,0,0,0,1-.38l4.19-7.27a.88.88,0,0,0-.18-1.08L254.05,190a1.1,1.1,0,0,1-.29-1.13,33.75,33.75,0,0,0,1.33-4.42,2,2,0,0,1,.73-1.11l5.21-3.67a1.55,1.55,0,0,0,.58-1.12v-6.6a.45.45,0,0,0-.2-.42h0L257.13,169h0a.49.49,0,0,0-.44,0l-2.95,1.33a1.25,1.25,0,0,1,.09-.7l3.38-6.83a.76.76,0,0,0-.3-1l-2.8-1.62h0l-5.15-3a.76.76,0,0,0-1,.24l-4.22,6.34a1.3,1.3,0,0,1-.58.44l-.32-3.2a.5.5,0,0,0-.21-.39h0l-4.29-2.49h0a.45.45,0,0,0-.47,0l-5.7,3.29a1.59,1.59,0,0,0-.69,1.07l-.57,6.35a2.11,2.11,0,0,1-.59,1.19,34.86,34.86,0,0,0-3.17,3.35,1.08,1.08,0,0,1-1.12.32l-3.67-1.28a.9.9,0,0,0-1,.38l-4.19,7.27a.9.9,0,0,0,.18,1.09l2.94,2.53a1.11,1.11,0,0,1,.29,1.13,33.43,33.43,0,0,0-1.33,4.43,2.07,2.07,0,0,1-.73,1.1l-5.21,3.67a1.56,1.56,0,0,0-.59,1.13v6.59a.48.48,0,0,0,.2.42h0l4.29,2.49h0a.48.48,0,0,0,.44,0l2.95-1.33a1.22,1.22,0,0,1-.09.69l-3.38,6.83a.77.77,0,0,0,.3,1l4.26,2.47h0l3.67,2.12a.77.77,0,0,0,1-.23l4.22-6.35a1.22,1.22,0,0,1,.58-.43l.32,3.2a.48.48,0,0,0,.21.38h0L236,215.6h0A.45.45,0,0,0,236.43,215.56Zm8.17-39.79c1,1,1.53,2.76,1.53,5.17,0,6.15-4.32,13.63-9.65,16.71a8.82,8.82,0,0,1-5,1.47,7.69,7.69,0,0,1-1.79-5.42c0-6.15,4.32-13.63,9.65-16.71A7.86,7.86,0,0,1,244.6,175.77Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "237.166px 186.8px 0px",
              }}
              id="elnexm2e6uu9g"
              className="animable"
            ></path>
            <path
              d="M221.58,214.36a.8.8,0,0,1-.22-.94l3.39-6.83a1,1,0,0,0,.1-.38l-4.28-2.49a1.12,1.12,0,0,1-.1.38l-3.38,6.83a.76.76,0,0,0,.29,1ZM236,215.6h0a.35.35,0,0,1-.12-.1.42.42,0,0,1-.08-.15.59.59,0,0,1,0-.14l-.56-5.54a.4.4,0,0,0,0-.15.65.65,0,0,0-.17-.26.54.54,0,0,0-.16-.1l-.1,0a.76.76,0,0,0-.3,0l-.13,0a11,11,0,0,1-2.62.26,1.44,1.44,0,0,0-.53.11l.31,3.21a.52.52,0,0,0,.22.38h0Zm-18.84-10.88a.54.54,0,0,1-.17-.41v-6.59a1.55,1.55,0,0,1,.31-.84L213,194.4a1.49,1.49,0,0,0-.32.84v6.59a.46.46,0,0,0,.19.42ZM235,172a1.59,1.59,0,0,0,.16-.56l.57-6.35a1.28,1.28,0,0,1,.17-.51l-4.28-2.48a1.74,1.74,0,0,0-.17.5l-.57,6.35a1.62,1.62,0,0,1-.17.56Zm-13.64,11.47a.9.9,0,0,1,0-.8l4.2-7.27A.85.85,0,0,1,226,175l-4.29-2.48a.91.91,0,0,0-.41.34l-4.19,7.27a.91.91,0,0,0,0,.85Z"
              style={{
                fill: "rgb(55, 71, 79)",
                transformOrigin: "224.339px 188.85px 0px",
              }}
              id="elj4su9zgdif"
              className="animable"
            ></path>
            <path
              d="M242.83,211.2l.57-6.36a2.05,2.05,0,0,1,.59-1.18,35,35,0,0,0,3.17-3.36,1.1,1.1,0,0,1,1.12-.32l3.67,1.28a.9.9,0,0,0,1-.38l4.19-7.27a.88.88,0,0,0-.18-1.08L254.05,190a1.1,1.1,0,0,1-.29-1.13,33.75,33.75,0,0,0,1.33-4.42,2,2,0,0,1,.73-1.11l5.21-3.67a1.55,1.55,0,0,0,.58-1.12v-6.6a.42.42,0,0,0-.64-.42l-5.09,2.3a.6.6,0,0,1-.84-.4,11.63,11.63,0,0,0-1.14-2.52,1.4,1.4,0,0,1-.07-1.23l3.38-6.83a.76.76,0,0,0-.3-1l-3.67-2.12a.77.77,0,0,0-1,.23L248,166.31a1.42,1.42,0,0,1-1.11.55,11.62,11.62,0,0,0-2.75.28.61.61,0,0,1-.76-.54l-.56-5.54a.43.43,0,0,0-.69-.36l-5.7,3.3a1.54,1.54,0,0,0-.69,1.06l-.57,6.36a2.05,2.05,0,0,1-.59,1.18,35,35,0,0,0-3.17,3.36,1.1,1.1,0,0,1-1.12.32L226.63,175a.9.9,0,0,0-1,.38l-4.2,7.27a.9.9,0,0,0,.19,1.08l2.94,2.54a1.08,1.08,0,0,1,.28,1.13,35.28,35.28,0,0,0-1.32,4.42,2.09,2.09,0,0,1-.73,1.11l-5.21,3.67a1.56,1.56,0,0,0-.59,1.12v6.6a.43.43,0,0,0,.65.42l5.09-2.3a.6.6,0,0,1,.84.4,12.11,12.11,0,0,0,1.13,2.52,1.37,1.37,0,0,1,.08,1.23l-3.39,6.83a.76.76,0,0,0,.31,1l3.67,2.12a.77.77,0,0,0,1-.23l4.22-6.35a1.42,1.42,0,0,1,1.11-.55,11.62,11.62,0,0,0,2.75-.28.61.61,0,0,1,.76.54l.56,5.54a.42.42,0,0,0,.68.36l5.71-3.3A1.54,1.54,0,0,0,242.83,211.2Zm-3.54-11.93c-5.33,3.07-9.65.58-9.65-5.57S234,180.07,239.29,177s9.64-.58,9.64,5.57S244.62,196.19,239.29,199.27Z"
              style={{
                fill: "rgb(69, 90, 100)",
                transformOrigin: "239.301px 188.135px 0px",
              }}
              id="elarxor7atazj"
              className="animable"
            ></path>
          </g>
        </g>
      </g>
      <g
        id="freepik--connection-1--inject-9"
        style={{ transformOrigin: "164.859px 256.8px 0px" }}
        className="animable"
      >
        <polygon
          points="140.51 343.91 140.14 343.27 196 311 196 172.04 196.73 172.04 196.74 311.43 140.51 343.91"
          style={{
            fill: "rgb(143, 18, 35)",
            transformOrigin: "168.44px 257.975px 0px",
          }}
          id="elkwj656wzwzn"
          className="animable"
        ></polygon>
        <polygon
          points="136.45 341.56 136.08 340.93 191.94 308.66 191.94 169.7 192.67 169.7 192.67 309.08 136.45 341.56"
          style={{
            fill: "rgb(143, 18, 35)",
            transformOrigin: "164.375px 255.63px 0px",
          }}
          id="elsdw4fzs8ns9"
          className="animable"
        ></polygon>
        <polygon
          points="132.39 339.22 132.02 338.58 187.87 306.31 187.87 167.35 188.61 167.35 188.61 306.74 132.39 339.22"
          style={{
            fill: "rgb(143, 18, 35)",
            transformOrigin: "160.315px 253.285px 0px",
          }}
          id="elh6qdoz3durg"
          className="animable"
        ></polygon>
        <polygon
          points="144.57 346.25 144.2 345.62 172.36 329.34 188.34 329.34 196.24 324.77 196.61 325.41 188.54 330.07 172.56 330.07 144.57 346.25"
          style={{
            fill: "rgb(143, 18, 35)",
            transformOrigin: "170.405px 335.51px 0px",
          }}
          id="el22cfe4zagdq"
          className="animable"
        ></polygon>
        <path
          d="M198.5,326a4.58,4.58,0,0,1-2.26-.55,1.62,1.62,0,0,1,0-3h0a4.92,4.92,0,0,1,4.51,0,1.62,1.62,0,0,1,0,3A4.52,4.52,0,0,1,198.5,326ZM196.61,323a.91.91,0,0,0,0,1.75,4.26,4.26,0,0,0,3.78,0,.91.91,0,0,0,0-1.75,4.26,4.26,0,0,0-3.78,0Z"
          style={{
            fill: "rgb(143, 18, 35)",
            transformOrigin: "198.495px 323.952px 0px",
          }}
          id="el7fq5dnwj2r9"
          className="animable"
        ></path>
        <polygon
          points="128.32 336.87 127.96 336.24 183.81 303.97 183.81 233.3 175.82 219.46 175.82 205.91 176.56 205.91 176.56 219.26 184.54 233.1 184.54 304.39 128.32 336.87"
          style={{
            fill: "rgb(143, 18, 35)",
            transformOrigin: "156.25px 271.39px 0px",
          }}
          id="elouf689ng75g"
          className="animable"
        ></polygon>
        <path
          d="M177,206.55a2.24,2.24,0,0,1-1.11-.33,4.92,4.92,0,0,1-2.26-3.91,1.62,1.62,0,0,1,2.62-1.52,4.92,4.92,0,0,1,2.26,3.91,1.79,1.79,0,0,1-.79,1.66A1.39,1.39,0,0,1,177,206.55Zm-1.85-5.35a.69.69,0,0,0-.36.09,1.11,1.11,0,0,0-.42,1,4.25,4.25,0,0,0,1.88,3.27.91.91,0,0,0,1.52-.88,4.25,4.25,0,0,0-1.88-3.27A1.6,1.6,0,0,0,175.18,201.2Z"
          style={{
            fill: "rgb(143, 18, 35)",
            transformOrigin: "176.063px 203.489px 0px",
          }}
          id="elp0nnmkxoenm"
          className="animable"
        ></path>
      </g>
      <g
        id="freepik--Server--inject-9"
        style={{ transformOrigin: "93.915px 300.173px 0px" }}
        className="animable animator-active"
      >
        <g
          id="freepik--server--inject-9"
          style={{ transformOrigin: "93.915px 300.173px 0px" }}
          className="animable"
        >
          <polygon
            points="148.18 336.1 93.91 367.43 39.65 336.1 93.91 304.77 148.18 336.1"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "93.915px 336.1px 0px",
            }}
            id="el8d2pk84wh4u"
            className="animable"
          ></polygon>
          <g id="el3pxdaw6wwli">
            <polygon
              points="148.18 336.1 93.91 367.43 39.65 336.1 93.91 304.77 148.18 336.1"
              style={{
                opacity: "0.1",
                transformOrigin: "93.915px 336.1px 0px",
              }}
              className="animable"
            ></polygon>
          </g>
          <g id="elqb8plx45y0d">
            <polygon
              points="93.92 367.43 93.91 363.51 43.04 334.14 39.65 336.1 93.92 367.43"
              style={{
                opacity: "0.1",
                transformOrigin: "66.785px 350.785px 0px",
              }}
              className="animable"
            ></polygon>
          </g>
          <path
            d="M93.92,367.43v21.44a7.47,7.47,0,0,0,3.61-.86h0L121,374.43,146,360a4.78,4.78,0,0,0,2.17-3.75V336.1Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "121.045px 362.486px 0px",
            }}
            id="eltei6xrasdt8"
            className="animable"
          ></path>
          <g id="el37dww88owni">
            <path
              d="M93.92,367.43v21.44a7.47,7.47,0,0,0,3.61-.86h0L121,374.43,146,360a4.78,4.78,0,0,0,2.17-3.75V336.1Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.65",
                transformOrigin: "121.045px 362.486px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M39.65,336.1v20.16A4.78,4.78,0,0,0,41.82,360l21.57,12.46L90.3,388a7.48,7.48,0,0,0,3.62.86V367.43Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "66.785px 362.481px 0px",
            }}
            id="elukduuhxvxjb"
            className="animable"
          ></path>
          <g id="eljxv9snu7xjr">
            <path
              d="M39.65,336.1v20.16A4.78,4.78,0,0,0,41.82,360l21.57,12.46L90.3,388a7.48,7.48,0,0,0,3.62.86V367.43Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.5",
                transformOrigin: "66.785px 362.481px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <polygon
            points="141.4 336.1 141.4 332.18 93.91 359.6 93.91 363.51 141.4 336.1"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "117.655px 347.845px 0px",
            }}
            id="elmuoyzj0ghwl"
            className="animable"
          ></polygon>
          <polygon
            points="148.18 312.55 93.91 343.88 39.65 312.55 93.91 281.22 148.18 312.55"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "93.915px 312.55px 0px",
            }}
            id="elhupuwke2584"
            className="animable"
          ></polygon>
          <g id="elpsjbdoqh2v8">
            <polygon
              points="148.18 312.55 93.91 343.88 39.65 312.55 93.91 281.22 148.18 312.55"
              style={{
                opacity: "0.1",
                transformOrigin: "93.915px 312.55px 0px",
              }}
              className="animable"
            ></polygon>
          </g>
          <g id="ellgr9yn6wt79">
            <polygon
              points="93.91 343.88 93.91 339.97 43.04 310.59 39.65 312.55 93.91 343.88"
              style={{
                opacity: "0.1",
                transformOrigin: "66.78px 327.235px 0px",
              }}
              className="animable"
            ></polygon>
          </g>
          <polygon
            points="148.18 328.22 93.91 359.55 93.91 343.88 148.18 312.55 148.18 328.22"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "121.045px 336.05px 0px",
            }}
            id="el2e3tygsl2u5"
            className="animable"
          ></polygon>
          <g id="elgr3gz89wswk">
            <polygon
              points="148.18 328.22 93.91 359.55 93.91 343.88 148.18 312.55 148.18 328.22"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.65",
                transformOrigin: "121.045px 336.05px 0px",
              }}
              className="animable"
            ></polygon>
          </g>
          <polygon
            points="93.91 359.55 39.65 328.22 39.65 312.55 93.91 343.88 93.91 359.55"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "66.78px 336.05px 0px",
            }}
            id="elvd1orfduny8"
            className="animable"
          ></polygon>
          <g id="el1uhcrykpgpk">
            <polygon
              points="93.91 359.55 39.65 328.22 39.65 312.55 93.91 343.88 93.91 359.55"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.5",
                transformOrigin: "66.78px 336.05px 0px",
              }}
              className="animable"
            ></polygon>
          </g>
          <polygon
            points="43.04 330.18 43.04 334.09 93.91 363.46 93.91 359.55 43.04 330.18"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "68.475px 346.82px 0px",
            }}
            id="el9p4r29roysi"
            className="animable"
          ></polygon>
          <polygon
            points="141.4 312.55 141.4 308.64 93.91 336.05 93.91 339.97 141.4 312.55"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "117.655px 324.305px 0px",
            }}
            id="el7j6scmntzs"
            className="animable"
          ></polygon>
          <polygon
            points="43.04 306.68 43.04 310.59 93.91 339.97 93.91 336.05 43.04 306.68"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "68.475px 323.325px 0px",
            }}
            id="el234eemo6szu"
            className="animable"
          ></polygon>
          <polygon
            points="148.18 289.06 93.91 320.38 39.65 289.06 93.91 257.73 148.18 289.06"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "93.915px 289.055px 0px",
            }}
            id="el41o98yojcy2"
            className="animable"
          ></polygon>
          <g id="el220rpfmq3si">
            <polygon
              points="148.18 289.06 93.91 320.38 39.65 289.06 93.91 257.73 148.18 289.06"
              style={{
                opacity: "0.1",
                transformOrigin: "93.915px 289.055px 0px",
              }}
              className="animable"
            ></polygon>
          </g>
          <g id="elh9l7t5qy8nn">
            <polygon
              points="93.91 316.48 93.91 320.38 39.65 289.06 43.04 287.1 93.91 316.48"
              style={{
                opacity: "0.1",
                transformOrigin: "66.78px 303.74px 0px",
              }}
              className="animable"
            ></polygon>
          </g>
          <polygon
            points="148.18 304.72 93.91 336.05 93.91 320.38 148.18 289.06 148.18 304.72"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "121.045px 312.555px 0px",
            }}
            id="elu28fr4ksbvi"
            className="animable"
          ></polygon>
          <g id="elgigkj1lo4zj">
            <polygon
              points="148.18 304.72 93.91 336.05 93.91 320.38 148.18 289.06 148.18 304.72"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.65",
                transformOrigin: "121.045px 312.555px 0px",
              }}
              className="animable"
            ></polygon>
          </g>
          <polygon
            points="93.91 336.05 39.65 304.72 39.65 289.06 93.91 320.38 93.91 336.05"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "66.78px 312.555px 0px",
            }}
            id="eli5gpilgknna"
            className="animable"
          ></polygon>
          <g id="el1vrdiztilqu">
            <polygon
              points="93.91 336.05 39.65 304.72 39.65 289.06 93.91 320.38 93.91 336.05"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.5",
                transformOrigin: "66.78px 312.555px 0px",
              }}
              className="animable"
            ></polygon>
          </g>
          <polygon
            points="141.4 289.06 141.4 285.14 93.91 312.56 93.91 316.48 141.4 289.06"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "117.655px 300.81px 0px",
            }}
            id="elnhpsacyrbos"
            className="animable"
          ></polygon>
          <polygon
            points="43.04 283.19 43.04 287.1 93.91 316.48 93.91 312.56 43.04 283.19"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "68.475px 299.835px 0px",
            }}
            id="el9gndhik3t0m"
            className="animable"
          ></polygon>
          <polygon
            points="148.18 265.51 93.91 296.84 39.65 265.51 93.91 234.19 148.18 265.51"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "93.915px 265.515px 0px",
            }}
            id="el6ogfalf81xu"
            className="animable"
          ></polygon>
          <g id="el6akoupjrxwy">
            <polygon
              points="148.18 265.51 93.91 296.84 39.65 265.51 93.91 234.19 148.18 265.51"
              style={{
                opacity: "0.1",
                transformOrigin: "93.915px 265.515px 0px",
              }}
              className="animable"
            ></polygon>
          </g>
          <g id="el1wn8behh32k">
            <polygon
              points="93.91 292.93 93.91 296.84 39.65 265.51 43.04 263.56 93.91 292.93"
              style={{ opacity: "0.1", transformOrigin: "66.78px 280.2px 0px" }}
              className="animable"
            ></polygon>
          </g>
          <polygon
            points="148.18 281.18 93.91 312.51 93.91 296.84 148.18 265.51 148.18 281.18"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "121.045px 289.01px 0px",
            }}
            id="elp3itdnbqzve"
            className="animable"
          ></polygon>
          <g id="eli4dnsrzkpyb">
            <polygon
              points="148.18 281.18 93.91 312.51 93.91 296.84 148.18 265.51 148.18 281.18"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.65",
                transformOrigin: "121.045px 289.01px 0px",
              }}
              className="animable"
            ></polygon>
          </g>
          <polygon
            points="93.91 312.51 39.65 281.18 39.65 265.51 93.91 296.84 93.91 312.51"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "66.78px 289.01px 0px",
            }}
            id="elfr62l8ofkke"
            className="animable"
          ></polygon>
          <g id="ely863h0n0kg">
            <polygon
              points="93.91 312.51 39.65 281.18 39.65 265.51 93.91 296.84 93.91 312.51"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.5",
                transformOrigin: "66.78px 289.01px 0px",
              }}
              className="animable"
            ></polygon>
          </g>
          <path
            d="M41.82,240.77,91.77,212a4.81,4.81,0,0,1,4.34,0L146,240.77a4.82,4.82,0,0,1,2.17,3.76v13.16L93.88,289h0L39.65,257.69V244.53A4.8,4.8,0,0,1,41.82,240.77Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "93.91px 250.241px 0px",
            }}
            id="elnzjdnmw49jg"
            className="animable"
          ></path>
          <g id="elcm2jkekkvil">
            <path
              d="M41.82,240.77,91.77,212a4.81,4.81,0,0,1,4.34,0L146,240.77a4.82,4.82,0,0,1,2.17,3.76v13.16L93.88,289h0L39.65,257.69V244.53A4.8,4.8,0,0,1,41.82,240.77Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.5",
                transformOrigin: "93.91px 250.241px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M93.88,272.62V289l54.3-31.33V244.53a4.84,4.84,0,0,0-1.78-3.48c.79.69.66,1.62-.39,2.23l-50,28.82A4.49,4.49,0,0,1,93.88,272.62Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "121.03px 265.025px 0px",
            }}
            id="elo93kpr41gl"
            className="animable"
          ></path>
          <g id="elhw5ynvgi95">
            <path
              d="M93.88,272.62V289l54.3-31.33V244.53a4.84,4.84,0,0,0-1.78-3.48c.79.69.66,1.62-.39,2.23l-50,28.82A4.49,4.49,0,0,1,93.88,272.62Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.65",
                transformOrigin: "121.03px 265.025px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M146,243.28l-50,28.82a4.81,4.81,0,0,1-4.34,0L41.82,243.28a1.33,1.33,0,0,1,0-2.51L91.77,212a4.75,4.75,0,0,1,4.34,0L146,240.77A1.33,1.33,0,0,1,146,243.28Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "93.91px 242.046px 0px",
            }}
            id="eletnmzf4x1mm"
            className="animable"
          ></path>
          <g id="elp5jmmqjl2wr">
            <path
              d="M146,243.28l-50,28.82a4.81,4.81,0,0,1-4.34,0L41.82,243.28a1.33,1.33,0,0,1,0-2.51L91.77,212a4.75,4.75,0,0,1,4.34,0L146,240.77A1.33,1.33,0,0,1,146,243.28Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: "0.85",
                transformOrigin: "93.91px 242.046px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <polygon
            points="141.4 265.52 141.4 261.6 93.91 289.02 93.91 292.93 141.4 265.52"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "117.655px 277.265px 0px",
            }}
            id="el5iz4oltjn7t"
            className="animable"
          ></polygon>
          <polygon
            points="43.04 259.65 43.04 263.56 93.91 292.93 93.91 289.02 43.04 259.65"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "68.475px 276.29px 0px",
            }}
            id="ela3qoxlpv41"
            className="animable"
          ></polygon>
          <path
            d="M51.45,361.07a1.67,1.67,0,0,1,.76,1.31c0,.48-.34.67-.76.43a1.67,1.67,0,0,1-.75-1.3C50.7,361,51,360.83,51.45,361.07Z"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "51.455px 361.938px 0px",
            }}
            id="elk15u9t6pmxa"
            className="animable"
          ></path>
          <path
            d="M57.73,364.7a1.67,1.67,0,0,1,.75,1.3c0,.48-.34.67-.75.44a1.66,1.66,0,0,1-.75-1.3C57,364.66,57.31,364.46,57.73,364.7Z"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "57.73px 365.568px 0px",
            }}
            id="el6i7y2gq23b4"
            className="animable"
          ></path>
          <path
            d="M63.89,368.26a1.64,1.64,0,0,1,.75,1.3c0,.47-.33.67-.75.43a1.66,1.66,0,0,1-.74-1.3C63.15,368.22,63.48,368,63.89,368.26Z"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "63.895px 369.121px 0px",
            }}
            id="elq7te2pgqgqs"
            className="animable"
          ></path>
          <path
            d="M70.11,371.86a1.64,1.64,0,0,1,.75,1.29c0,.47-.34.66-.75.43a1.66,1.66,0,0,1-.74-1.29C69.37,371.81,69.7,371.62,70.11,371.86Z"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "70.115px 372.717px 0px",
            }}
            id="el1ggl2rx52t5"
            className="animable"
          ></path>
          <g id="elnzupx3uas1">
            <g
              style={{
                opacity: "0.75",
                transformOrigin: "47.32px 348.312px 0px",
              }}
              className="animable"
            >
              <path
                d="M44.13,342.58l6.38,3.66a4,4,0,0,1,1.81,3.13V353c0,1.16-.81,1.62-1.81,1.05l-6.38-3.67a4,4,0,0,1-1.81-3.13v-3.66C42.32,342.47,43.13,342,44.13,342.58Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  transformOrigin: "47.32px 348.312px 0px",
                }}
                id="elno4nr5lgw8"
                className="animable"
              ></path>
            </g>
          </g>
          <path
            d="M45.85,346.71l.83-.48h0a1.1,1.1,0,0,1,1.1.12,3.46,3.46,0,0,1,1.57,2.72,1.08,1.08,0,0,1-.46,1h0l-.77.44-.14-.24a1.58,1.58,0,0,1-.45-.17A3.46,3.46,0,0,1,46,347.39,1.62,1.62,0,0,1,46,347Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "47.6029px 348.323px 0px",
            }}
            id="elzivyvo795dk"
            className="animable"
          ></path>
          <g id="el6kr7arbkq0s">
            <path
              d="M45.85,346.71l.83-.48h0a1.1,1.1,0,0,1,1.1.12,3.46,3.46,0,0,1,1.57,2.72,1.08,1.08,0,0,1-.46,1h0l-.77.44-.14-.24a1.58,1.58,0,0,1-.45-.17A3.46,3.46,0,0,1,46,347.39,1.62,1.62,0,0,1,46,347Z"
              style={{
                opacity: "0.2",
                transformOrigin: "47.6029px 348.323px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M47,346.79a3.49,3.49,0,0,1,1.58,2.73c0,1-.71,1.4-1.58.9a3.49,3.49,0,0,1-1.57-2.72C45.42,346.7,46.13,346.29,47,346.79Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "47.005px 348.606px 0px",
            }}
            id="elq4777ezr0fn"
            className="animable"
          ></path>
          <g id="elxi0xelst0rl">
            <g
              style={{
                opacity: "0.75",
                transformOrigin: "47.32px 324.753px 0px",
              }}
              className="animable"
            >
              <path
                d="M44.13,319l6.38,3.66a4,4,0,0,1,1.81,3.14v3.65c0,1.16-.81,1.62-1.81,1.05l-6.38-3.67a4,4,0,0,1-1.81-3.13v-3.65C42.32,318.9,43.13,318.44,44.13,319Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  transformOrigin: "47.32px 324.753px 0px",
                }}
                id="elv4cfvln1en"
                className="animable"
              ></path>
            </g>
          </g>
          <path
            d="M45.85,323.14l.83-.48h0a1.07,1.07,0,0,1,1.1.11,3.46,3.46,0,0,1,1.57,2.72,1.1,1.1,0,0,1-.46,1h0l-.77.44-.14-.23a2,2,0,0,1-.45-.18A3.46,3.46,0,0,1,46,323.82a1.62,1.62,0,0,1,.05-.4Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "47.6024px 324.743px 0px",
            }}
            id="elk31wj3spkl"
            className="animable"
          ></path>
          <g id="eldv8e83bsw8j">
            <path
              d="M45.85,323.14l.83-.48h0a1.07,1.07,0,0,1,1.1.11,3.46,3.46,0,0,1,1.57,2.72,1.1,1.1,0,0,1-.46,1h0l-.77.44-.14-.23a2,2,0,0,1-.45-.18A3.46,3.46,0,0,1,46,323.82a1.62,1.62,0,0,1,.05-.4Z"
              style={{
                opacity: "0.2",
                transformOrigin: "47.6024px 324.743px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M47,323.23A3.48,3.48,0,0,1,48.57,326c0,1-.71,1.41-1.58.9a3.48,3.48,0,0,1-1.57-2.72C45.42,323.13,46.13,322.72,47,323.23Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "46.995px 325.066px 0px",
            }}
            id="elxy040ihsa7"
            className="animable"
          ></path>
          <g id="el5iws0s80imx">
            <g
              style={{
                opacity: "0.75",
                transformOrigin: "47.32px 301.302px 0px",
              }}
              className="animable"
            >
              <path
                d="M44.13,295.54l6.38,3.66a4,4,0,0,1,1.81,3.14V306c0,1.16-.81,1.62-1.81,1.05l-6.38-3.67a4,4,0,0,1-1.81-3.13v-3.66C42.32,295.43,43.13,295,44.13,295.54Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  transformOrigin: "47.32px 301.302px 0px",
                }}
                id="elu23jgf9s86"
                className="animable"
              ></path>
            </g>
          </g>
          <path
            d="M45.85,299.67l.83-.48h0a1.1,1.1,0,0,1,1.1.12A3.46,3.46,0,0,1,49.36,302a1.08,1.08,0,0,1-.46,1h0l-.77.44-.14-.24a1.58,1.58,0,0,1-.45-.17A3.46,3.46,0,0,1,46,300.35,1.62,1.62,0,0,1,46,300Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "47.6079px 301.268px 0px",
            }}
            id="eliznnhfgqvc8"
            className="animable"
          ></path>
          <g id="el2cub06pobbn">
            <path
              d="M45.85,299.67l.83-.48h0a1.1,1.1,0,0,1,1.1.12A3.46,3.46,0,0,1,49.36,302a1.08,1.08,0,0,1-.46,1h0l-.77.44-.14-.24a1.58,1.58,0,0,1-.45-.17A3.46,3.46,0,0,1,46,300.35,1.62,1.62,0,0,1,46,300Z"
              style={{
                opacity: "0.2",
                transformOrigin: "47.6079px 301.268px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M47,299.75a3.49,3.49,0,0,1,1.58,2.73c0,1-.71,1.4-1.58.9a3.49,3.49,0,0,1-1.57-2.72C45.42,299.66,46.13,299.25,47,299.75Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "47.005px 301.566px 0px",
            }}
            id="eltlsmrc50ki"
            className="animable"
          ></path>
          <g id="elwpwdoe66w5">
            <g
              style={{
                opacity: "0.75",
                transformOrigin: "47.32px 277.746px 0px",
              }}
              className="animable"
            >
              <path
                d="M44.13,272l6.38,3.66a4,4,0,0,1,1.81,3.13v3.66c0,1.15-.81,1.62-1.81,1.05l-6.38-3.67a4,4,0,0,1-1.81-3.13V273C42.32,271.89,43.13,271.42,44.13,272Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  transformOrigin: "47.32px 277.746px 0px",
                }}
                id="eld49xfum4v8j"
                className="animable"
              ></path>
            </g>
          </g>
          <path
            d="M45.85,276.12l.83-.47h0a1.1,1.1,0,0,1,1.1.12,3.46,3.46,0,0,1,1.57,2.72,1.08,1.08,0,0,1-.46,1h0l-.77.45L48,279.7a1.58,1.58,0,0,1-.45-.17A3.46,3.46,0,0,1,46,276.81a1.62,1.62,0,0,1,.05-.4Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "47.6029px 277.748px 0px",
            }}
            id="elxwem8xrzmd8"
            className="animable"
          ></path>
          <g id="el2fs1d66i15b">
            <path
              d="M45.85,276.12l.83-.47h0a1.1,1.1,0,0,1,1.1.12,3.46,3.46,0,0,1,1.57,2.72,1.08,1.08,0,0,1-.46,1h0l-.77.45L48,279.7a1.58,1.58,0,0,1-.45-.17A3.46,3.46,0,0,1,46,276.81a1.62,1.62,0,0,1,.05-.4Z"
              style={{
                opacity: "0.2",
                transformOrigin: "47.6029px 277.748px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M47,276.21a3.48,3.48,0,0,1,1.58,2.73c0,1-.71,1.4-1.58.9a3.49,3.49,0,0,1-1.57-2.72C45.42,276.12,46.13,275.71,47,276.21Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "47.005px 278.026px 0px",
            }}
            id="elvra7b4l7wy"
            className="animable"
          ></path>
          <g id="elh0c9pta8jq8">
            <g
              style={{
                opacity: "0.75",
                transformOrigin: "47.32px 254.23px 0px",
              }}
              className="animable"
            >
              <path
                d="M44.13,248.48l6.38,3.67a4,4,0,0,1,1.81,3.13v3.65c0,1.16-.81,1.62-1.81,1.05l-6.38-3.67a4,4,0,0,1-1.81-3.13v-3.65C42.32,248.37,43.13,247.91,44.13,248.48Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  transformOrigin: "47.32px 254.23px 0px",
                }}
                id="elwa6wfn4snb"
                className="animable"
              ></path>
            </g>
          </g>
          <path
            d="M45.85,252.61l.83-.48h0a1.1,1.1,0,0,1,1.1.11A3.46,3.46,0,0,1,49.36,255a1.1,1.1,0,0,1-.46,1h0l-.77.44-.14-.23a2,2,0,0,1-.45-.18A3.46,3.46,0,0,1,46,253.29a1.62,1.62,0,0,1,.05-.4Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "47.6074px 254.236px 0px",
            }}
            id="elc0m5phk44ub"
            className="animable"
          ></path>
          <g id="eljcoc3fm9hme">
            <path
              d="M45.85,252.61l.83-.48h0a1.1,1.1,0,0,1,1.1.11A3.46,3.46,0,0,1,49.36,255a1.1,1.1,0,0,1-.46,1h0l-.77.44-.14-.23a2,2,0,0,1-.45-.18A3.46,3.46,0,0,1,46,253.29a1.62,1.62,0,0,1,.05-.4Z"
              style={{
                opacity: "0.2",
                transformOrigin: "47.6074px 254.236px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M47,252.7a3.48,3.48,0,0,1,1.58,2.72c0,1-.71,1.41-1.58.9a3.48,3.48,0,0,1-1.57-2.72C45.42,252.6,46.13,252.2,47,252.7Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "47.005px 254.512px 0px",
            }}
            id="elcykkyk11mm"
            className="animable"
          ></path>
          <path
            d="M143,343l-26.91,15.54a4,4,0,0,0-1.81,3.13v3.66c0,1.15.81,1.62,1.81,1L143,350.86a4,4,0,0,0,1.81-3.13v-3.66C144.79,342.92,144,342.45,143,343Z"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "129.545px 354.688px 0px",
            }}
            id="ellim2p8vyata"
            className="animable"
          ></path>
          <path
            d="M142.88,346.12v1.78a.78.78,0,0,1-.36.62l-.41.24c-.2.11-.36,0-.36-.21v-1.78a.78.78,0,0,1,.36-.62l.41-.24C142.72,345.8,142.88,345.89,142.88,346.12Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "142.315px 347.333px 0px",
            }}
            id="elid0l6tqpb9"
            className="animable"
          ></path>
          <path
            d="M141.05,347.18V349a.81.81,0,0,1-.36.63l-.41.23c-.2.12-.36,0-.36-.21v-1.77a.81.81,0,0,1,.36-.63l.41-.23C140.89,346.85,141.05,347,141.05,347.18Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "140.485px 348.427px 0px",
            }}
            id="elsisy2har25l"
            className="animable"
          ></path>
          <path
            d="M139.22,348.23V350a.81.81,0,0,1-.36.63l-.4.23c-.2.12-.37,0-.37-.2v-1.78a.79.79,0,0,1,.37-.62l.4-.24C139.06,347.9,139.22,348,139.22,348.23Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "138.655px 349.438px 0px",
            }}
            id="elgyg3phacrop"
            className="animable"
          ></path>
          <path
            d="M137.4,349.28v1.78a.78.78,0,0,1-.36.62l-.41.24c-.2.11-.36,0-.36-.21v-1.78a.78.78,0,0,1,.36-.62l.41-.24C137.24,349,137.4,349.05,137.4,349.28Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "136.835px 350.502px 0px",
            }}
            id="eli5d4q61cxo8"
            className="animable"
          ></path>
          <path
            d="M135.57,350.34v1.77a.81.81,0,0,1-.36.63l-.41.23c-.2.12-.36,0-.36-.21V351a.81.81,0,0,1,.36-.63l.41-.23C135.41,350,135.57,350.1,135.57,350.34Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "135.005px 351.547px 0px",
            }}
            id="el0zslloasf0pg"
            className="animable"
          ></path>
          <path
            d="M133.74,351.39v1.77a.81.81,0,0,1-.36.63L133,354c-.2.12-.36,0-.36-.2V352a.81.81,0,0,1,.36-.63l.41-.23C133.58,351.06,133.74,351.16,133.74,351.39Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "133.19px 352.58px 0px",
            }}
            id="elyisr3c2n008"
            className="animable"
          ></path>
          <path
            d="M131.92,352.44v1.78a.79.79,0,0,1-.37.62l-.4.24c-.2.11-.36,0-.36-.21v-1.78a.78.78,0,0,1,.36-.62l.4-.24C131.75,352.12,131.92,352.21,131.92,352.44Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "131.355px 353.653px 0px",
            }}
            id="elgv2zk3i0v3q"
            className="animable"
          ></path>
          <path
            d="M130.09,353.5v1.77a.81.81,0,0,1-.36.63l-.41.23c-.2.12-.36,0-.36-.21v-1.77a.81.81,0,0,1,.36-.63l.41-.23C129.93,353.17,130.09,353.26,130.09,353.5Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "129.525px 354.707px 0px",
            }}
            id="el5dls4rlef9h"
            className="animable"
          ></path>
          <path
            d="M128.26,354.55v1.77a.81.81,0,0,1-.36.63l-.41.23c-.2.12-.36,0-.36-.2V355.2a.81.81,0,0,1,.36-.63l.41-.23C128.1,354.22,128.26,354.32,128.26,354.55Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "127.695px 355.758px 0px",
            }}
            id="els0kviy7ryce"
            className="animable"
          ></path>
          <path
            d="M126.43,355.6v1.78a.78.78,0,0,1-.36.62l-.4.24c-.2.11-.37,0-.37-.21v-1.78a.79.79,0,0,1,.37-.62l.4-.24C126.27,355.28,126.43,355.37,126.43,355.6Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "125.865px 356.813px 0px",
            }}
            id="elb2okgg7t2f4"
            className="animable"
          ></path>
          <path
            d="M124.61,356.66v1.77a.81.81,0,0,1-.36.63l-.41.23c-.2.12-.36,0-.36-.21v-1.77a.81.81,0,0,1,.36-.63l.41-.23C124.45,356.33,124.61,356.42,124.61,356.66Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "124.045px 357.867px 0px",
            }}
            id="elr2tw4gnz3yf"
            className="animable"
          ></path>
          <path
            d="M122.78,357.71v1.77a.81.81,0,0,1-.36.63l-.41.23c-.2.12-.36,0-.36-.2v-1.78a.81.81,0,0,1,.36-.63l.41-.23C122.62,357.38,122.78,357.48,122.78,357.71Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "122.215px 358.918px 0px",
            }}
            id="elzp1vvctesf9"
            className="animable"
          ></path>
          <path
            d="M121,358.76v1.78a.78.78,0,0,1-.36.62l-.41.24a.22.22,0,0,1-.36-.21v-1.78a.81.81,0,0,1,.36-.62l.41-.24C120.79,358.44,121,358.53,121,358.76Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "120.433px 359.979px 0px",
            }}
            id="elav8ur1x7bt8"
            className="animable"
          ></path>
          <path
            d="M119.13,359.82v1.77a.82.82,0,0,1-.37.63l-.4.23c-.2.12-.36,0-.36-.21v-1.77a.81.81,0,0,1,.36-.63l.4-.23C119,359.49,119.13,359.58,119.13,359.82Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "118.565px 361.027px 0px",
            }}
            id="elog3k3knf6lc"
            className="animable"
          ></path>
          <path
            d="M117.3,360.87v1.77a.81.81,0,0,1-.36.63l-.41.23c-.2.12-.36,0-.36-.2v-1.78a.81.81,0,0,1,.36-.63l.41-.23C117.14,360.54,117.3,360.64,117.3,360.87Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "116.735px 362.078px 0px",
            }}
            id="elysh7okppi5s"
            className="animable"
          ></path>
          <path
            d="M143,319.46,116.07,335a4,4,0,0,0-1.81,3.13v3.65c0,1.16.81,1.62,1.81,1.05L143,327.29a4,4,0,0,0,1.81-3.13V320.5C144.79,319.35,144,318.88,143,319.46Z"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "129.535px 331.143px 0px",
            }}
            id="elzrhq31rae"
            className="animable"
          ></path>
          <path
            d="M142.88,322.56v1.77a.81.81,0,0,1-.36.63l-.41.23c-.2.12-.36,0-.36-.21v-1.77a.81.81,0,0,1,.36-.63l.41-.23C142.72,322.23,142.88,322.33,142.88,322.56Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "142.315px 323.768px 0px",
            }}
            id="elizbnyxakhze"
            className="animable"
          ></path>
          <path
            d="M141.05,323.61v1.77a.78.78,0,0,1-.36.63l-.41.24c-.2.11-.36,0-.36-.21v-1.78a.78.78,0,0,1,.36-.62l.41-.24C140.89,323.29,141.05,323.38,141.05,323.61Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "140.485px 324.823px 0px",
            }}
            id="elxu8odexhgac"
            className="animable"
          ></path>
          <path
            d="M139.22,324.66v1.78a.78.78,0,0,1-.36.62l-.4.24c-.2.11-.37,0-.37-.21v-1.77a.82.82,0,0,1,.37-.63l.4-.24C139.06,324.34,139.22,324.43,139.22,324.66Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "138.655px 325.873px 0px",
            }}
            id="el4irw5gqvsl8"
            className="animable"
          ></path>
          <path
            d="M137.4,325.72v1.77a.81.81,0,0,1-.36.63l-.41.23c-.2.12-.36,0-.36-.21v-1.77a.81.81,0,0,1,.36-.63l.41-.23C137.24,325.39,137.4,325.49,137.4,325.72Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "136.835px 326.928px 0px",
            }}
            id="el0we2yy8rq4g"
            className="animable"
          ></path>
          <path
            d="M135.57,326.77v1.77a.78.78,0,0,1-.36.63l-.41.24c-.2.11-.36,0-.36-.21v-1.78a.78.78,0,0,1,.36-.62l.41-.24C135.41,326.45,135.57,326.54,135.57,326.77Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "135.005px 327.983px 0px",
            }}
            id="elssnab0wylqn"
            className="animable"
          ></path>
          <path
            d="M133.74,327.82v1.78a.78.78,0,0,1-.36.62l-.41.24c-.2.11-.36,0-.36-.21v-1.77a.8.8,0,0,1,.36-.63l.41-.24C133.58,327.5,133.74,327.59,133.74,327.82Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "133.175px 329.033px 0px",
            }}
            id="el5975o0ffjee"
            className="animable"
          ></path>
          <path
            d="M131.92,328.88v1.77a.82.82,0,0,1-.37.63l-.4.23c-.2.12-.36,0-.36-.21v-1.77a.81.81,0,0,1,.36-.63l.4-.23A.23.23,0,0,1,131.92,328.88Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "131.356px 330.089px 0px",
            }}
            id="el1my3fubmz7d"
            className="animable"
          ></path>
          <path
            d="M130.09,329.93v1.77a.78.78,0,0,1-.36.63l-.41.24c-.2.11-.36,0-.36-.21v-1.78a.78.78,0,0,1,.36-.62l.41-.24C129.93,329.61,130.09,329.7,130.09,329.93Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "129.525px 331.143px 0px",
            }}
            id="el9gb6u1qjx0b"
            className="animable"
          ></path>
          <path
            d="M128.26,331v1.78a.78.78,0,0,1-.36.62l-.41.24c-.2.11-.36,0-.36-.21v-1.77a.8.8,0,0,1,.36-.63l.41-.24C128.1,330.66,128.26,330.75,128.26,331Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "127.695px 332.207px 0px",
            }}
            id="elu9o3ppu7w3j"
            className="animable"
          ></path>
          <path
            d="M126.43,332v1.77a.81.81,0,0,1-.36.63l-.4.23a.23.23,0,0,1-.37-.21v-1.77a.82.82,0,0,1,.37-.63l.4-.23C126.27,331.71,126.43,331.81,126.43,332Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "125.864px 333.221px 0px",
            }}
            id="elhv7z6z13gch"
            className="animable"
          ></path>
          <path
            d="M124.61,333.09v1.77a.8.8,0,0,1-.36.63l-.41.24c-.2.11-.36,0-.36-.21v-1.78a.78.78,0,0,1,.36-.62l.41-.24C124.45,332.77,124.61,332.86,124.61,333.09Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "124.045px 334.303px 0px",
            }}
            id="el3u8kpu50tgk"
            className="animable"
          ></path>
          <path
            d="M122.78,334.14v1.78a.78.78,0,0,1-.36.62l-.41.24c-.2.11-.36,0-.36-.21V334.8a.8.8,0,0,1,.36-.63l.41-.24C122.62,333.82,122.78,333.91,122.78,334.14Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "122.215px 335.353px 0px",
            }}
            id="eleyyag4fq0x6"
            className="animable"
          ></path>
          <path
            d="M121,335.2V337a.81.81,0,0,1-.36.63l-.41.23c-.19.12-.36,0-.36-.21v-1.77a.84.84,0,0,1,.36-.63l.41-.23C120.79,334.87,121,335,121,335.2Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "120.435px 336.431px 0px",
            }}
            id="el3rdi52hvgrg"
            className="animable"
          ></path>
          <path
            d="M119.13,336.25V338a.81.81,0,0,1-.37.63l-.4.24c-.2.11-.36,0-.36-.21V336.9a.78.78,0,0,1,.36-.62l.4-.24C119,335.93,119.13,336,119.13,336.25Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "118.565px 337.451px 0px",
            }}
            id="elfmaful26enj"
            className="animable"
          ></path>
          <path
            d="M117.3,337.3v1.78a.78.78,0,0,1-.36.62l-.41.24c-.2.11-.36,0-.36-.21V338a.78.78,0,0,1,.36-.63l.41-.24C117.14,337,117.3,337.07,117.3,337.3Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "116.735px 338.524px 0px",
            }}
            id="elnttz98raf3"
            className="animable"
          ></path>
          <path
            d="M143,296l-26.91,15.54a4,4,0,0,0-1.81,3.13v3.65c0,1.16.81,1.62,1.81,1.05L143,303.81a4,4,0,0,0,1.81-3.13V297C144.79,295.87,144,295.4,143,296Z"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "129.545px 307.676px 0px",
            }}
            id="eljv3rh9y9k6"
            className="animable"
          ></path>
          <path
            d="M142.88,299.08v1.77a.81.81,0,0,1-.36.63l-.41.23c-.2.12-.36,0-.36-.21v-1.77a.81.81,0,0,1,.36-.63l.41-.23C142.72,298.75,142.88,298.85,142.88,299.08Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "142.315px 300.288px 0px",
            }}
            id="el7cpxfwesqor"
            className="animable"
          ></path>
          <path
            d="M141.05,300.13v1.78a.78.78,0,0,1-.36.62l-.41.24c-.2.11-.36,0-.36-.21v-1.78a.78.78,0,0,1,.36-.62l.41-.24C140.89,299.81,141.05,299.9,141.05,300.13Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "140.485px 301.343px 0px",
            }}
            id="elloav0esfxc"
            className="animable"
          ></path>
          <path
            d="M139.22,301.18V303a.81.81,0,0,1-.36.63l-.4.23a.23.23,0,0,1-.37-.21v-1.77a.82.82,0,0,1,.37-.63l.4-.23C139.06,300.86,139.22,301,139.22,301.18Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "138.654px 302.429px 0px",
            }}
            id="elzyfw408qcsi"
            className="animable"
          ></path>
          <path
            d="M137.4,302.24V304a.81.81,0,0,1-.36.63l-.41.23c-.2.12-.36,0-.36-.21v-1.77a.81.81,0,0,1,.36-.63L137,302C137.24,301.91,137.4,302,137.4,302.24Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "136.835px 303.437px 0px",
            }}
            id="el9qtw6g838zd"
            className="animable"
          ></path>
          <path
            d="M135.57,303.29v1.78a.78.78,0,0,1-.36.62l-.41.24c-.2.11-.36,0-.36-.21v-1.78a.78.78,0,0,1,.36-.62l.41-.24C135.41,303,135.57,303.06,135.57,303.29Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "135.005px 304.51px 0px",
            }}
            id="eluh9w8g92g1h"
            className="animable"
          ></path>
          <path
            d="M133.74,304.34v1.78a.78.78,0,0,1-.36.62L133,307c-.2.12-.36,0-.36-.21V305a.81.81,0,0,1,.36-.63l.41-.23C133.58,304,133.74,304.11,133.74,304.34Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "133.19px 305.563px 0px",
            }}
            id="eluaygr3obk7"
            className="animable"
          ></path>
          <path
            d="M131.92,305.4v1.77a.82.82,0,0,1-.37.63l-.4.23c-.2.12-.36,0-.36-.21v-1.77a.81.81,0,0,1,.36-.63l.4-.23A.23.23,0,0,1,131.92,305.4Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "131.356px 306.609px 0px",
            }}
            id="el1fr8vf8v7kj"
            className="animable"
          ></path>
          <path
            d="M130.09,306.45v1.78a.78.78,0,0,1-.36.62l-.41.24c-.2.11-.36,0-.36-.21V307.1a.78.78,0,0,1,.36-.62l.41-.24C129.93,306.13,130.09,306.22,130.09,306.45Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "129.525px 307.663px 0px",
            }}
            id="ellv46ifk9sxo"
            className="animable"
          ></path>
          <path
            d="M128.26,307.5v1.78a.78.78,0,0,1-.36.62l-.41.24c-.2.12-.36,0-.36-.21v-1.77a.81.81,0,0,1,.36-.63l.41-.23C128.1,307.18,128.26,307.27,128.26,307.5Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "127.695px 308.717px 0px",
            }}
            id="elq3jmhgmcle"
            className="animable"
          ></path>
          <path
            d="M126.43,308.56v1.77a.81.81,0,0,1-.36.63l-.4.23a.23.23,0,0,1-.37-.21v-1.77a.82.82,0,0,1,.37-.63l.4-.23C126.27,308.23,126.43,308.33,126.43,308.56Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "125.864px 309.769px 0px",
            }}
            id="elxh3gvij3nqq"
            className="animable"
          ></path>
          <path
            d="M124.61,309.61v1.78a.78.78,0,0,1-.36.62l-.41.24c-.2.11-.36,0-.36-.21v-1.78a.78.78,0,0,1,.36-.62l.41-.24C124.45,309.29,124.61,309.38,124.61,309.61Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "124.045px 310.823px 0px",
            }}
            id="elc2m4fd8d6c4"
            className="animable"
          ></path>
          <path
            d="M122.78,310.66v1.78a.78.78,0,0,1-.36.62l-.41.24c-.2.11-.36,0-.36-.21v-1.77a.81.81,0,0,1,.36-.63l.41-.23C122.62,310.34,122.78,310.43,122.78,310.66Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "122.215px 311.875px 0px",
            }}
            id="eloaywzajk3bp"
            className="animable"
          ></path>
          <path
            d="M121,311.72v1.77a.81.81,0,0,1-.36.63l-.41.23c-.19.12-.36,0-.36-.21v-1.77a.84.84,0,0,1,.36-.63l.41-.23C120.79,311.39,121,311.49,121,311.72Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "120.435px 312.928px 0px",
            }}
            id="el1vniy6chucc"
            className="animable"
          ></path>
          <path
            d="M119.13,312.77v1.78a.79.79,0,0,1-.37.62l-.4.24c-.2.11-.36,0-.36-.21v-1.78a.78.78,0,0,1,.36-.62l.4-.24C119,312.45,119.13,312.54,119.13,312.77Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "118.565px 313.983px 0px",
            }}
            id="elxxuapik34g"
            className="animable"
          ></path>
          <path
            d="M117.3,313.82v1.78a.78.78,0,0,1-.36.62l-.41.24c-.2.11-.36,0-.36-.21v-1.77a.81.81,0,0,1,.36-.63l.41-.23C117.14,313.5,117.3,313.59,117.3,313.82Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "116.735px 315.035px 0px",
            }}
            id="elglf8srid5xh"
            className="animable"
          ></path>
          <path
            d="M143,272.44,116.07,288a4,4,0,0,0-1.81,3.13v3.65c0,1.16.81,1.62,1.81,1.05L143,280.27a4,4,0,0,0,1.81-3.13v-3.66C144.79,272.33,144,271.86,143,272.44Z"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "129.535px 284.133px 0px",
            }}
            id="elulzg2k4b38k"
            className="animable"
          ></path>
          <path
            d="M142.88,275.54v1.77a.81.81,0,0,1-.36.63l-.41.23c-.2.12-.36,0-.36-.21v-1.77a.81.81,0,0,1,.36-.63l.41-.23C142.72,275.21,142.88,275.31,142.88,275.54Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "142.315px 276.748px 0px",
            }}
            id="el17cb3c3pav7"
            className="animable"
          ></path>
          <path
            d="M141.05,276.59v1.77a.78.78,0,0,1-.36.63l-.41.24c-.2.11-.36,0-.36-.21v-1.78a.78.78,0,0,1,.36-.62l.41-.24C140.89,276.27,141.05,276.36,141.05,276.59Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "140.485px 277.803px 0px",
            }}
            id="elwfh2i5msa1"
            className="animable"
          ></path>
          <path
            d="M139.22,277.64v1.78a.78.78,0,0,1-.36.62l-.4.24c-.2.11-.37,0-.37-.21V278.3a.81.81,0,0,1,.37-.63l.4-.24C139.06,277.32,139.22,277.41,139.22,277.64Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "138.655px 278.853px 0px",
            }}
            id="elfczf5upy4st"
            className="animable"
          ></path>
          <path
            d="M137.4,278.7v1.77a.81.81,0,0,1-.36.63l-.41.23c-.2.12-.36,0-.36-.21v-1.77a.81.81,0,0,1,.36-.63l.41-.23C137.24,278.37,137.4,278.47,137.4,278.7Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "136.835px 279.908px 0px",
            }}
            id="elnmpxflsbdy"
            className="animable"
          ></path>
          <path
            d="M135.57,279.75v1.77a.78.78,0,0,1-.36.63l-.41.24c-.2.11-.36,0-.36-.21V280.4a.78.78,0,0,1,.36-.62l.41-.24C135.41,279.43,135.57,279.52,135.57,279.75Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "135.005px 280.963px 0px",
            }}
            id="elgrim6lehjd8"
            className="animable"
          ></path>
          <path
            d="M133.74,280.8v1.78a.78.78,0,0,1-.36.62l-.41.24c-.2.11-.36,0-.36-.21v-1.77a.8.8,0,0,1,.36-.63l.41-.24C133.58,280.48,133.74,280.57,133.74,280.8Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "133.175px 282.013px 0px",
            }}
            id="el8xlxnvqf2aq"
            className="animable"
          ></path>
          <path
            d="M131.92,281.86v1.77a.82.82,0,0,1-.37.63l-.4.23c-.2.12-.36,0-.36-.21v-1.77a.81.81,0,0,1,.36-.63l.4-.23A.23.23,0,0,1,131.92,281.86Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "131.356px 283.069px 0px",
            }}
            id="elqwl2qxj159"
            className="animable"
          ></path>
          <path
            d="M130.09,282.91v1.77a.8.8,0,0,1-.36.63l-.41.24c-.2.11-.36,0-.36-.21v-1.78a.78.78,0,0,1,.36-.62l.41-.24C129.93,282.59,130.09,282.68,130.09,282.91Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "129.525px 284.123px 0px",
            }}
            id="el75mej2wss4f"
            className="animable"
          ></path>
          <path
            d="M128.26,284v1.78a.78.78,0,0,1-.36.62l-.41.24c-.2.11-.36,0-.36-.21v-1.77a.8.8,0,0,1,.36-.63l.41-.24C128.1,283.64,128.26,283.73,128.26,284Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "127.695px 285.201px 0px",
            }}
            id="elryqpmcu5php"
            className="animable"
          ></path>
          <path
            d="M126.43,285v1.77a.81.81,0,0,1-.36.63l-.4.23a.23.23,0,0,1-.37-.21v-1.77a.82.82,0,0,1,.37-.63l.4-.23C126.27,284.69,126.43,284.79,126.43,285Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "125.864px 286.215px 0px",
            }}
            id="elunnfl4tvh6"
            className="animable"
          ></path>
          <path
            d="M124.61,286.07v1.77a.8.8,0,0,1-.36.63l-.41.24c-.2.11-.36,0-.36-.21v-1.78a.78.78,0,0,1,.36-.62l.41-.24C124.45,285.75,124.61,285.84,124.61,286.07Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "124.045px 287.283px 0px",
            }}
            id="elmscn871zbq8"
            className="animable"
          ></path>
          <path
            d="M122.78,287.12v1.78a.78.78,0,0,1-.36.62l-.41.24c-.2.11-.36,0-.36-.21v-1.77a.78.78,0,0,1,.36-.63l.41-.24C122.62,286.8,122.78,286.89,122.78,287.12Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "122.215px 288.333px 0px",
            }}
            id="elird9xpodx6r"
            className="animable"
          ></path>
          <path
            d="M121,288.18V290a.81.81,0,0,1-.36.63l-.41.23c-.19.12-.36,0-.36-.21v-1.77a.84.84,0,0,1,.36-.63l.41-.23C120.79,287.85,121,288,121,288.18Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "120.435px 289.427px 0px",
            }}
            id="elekbsry11wk"
            className="animable"
          ></path>
          <path
            d="M119.13,289.23V291a.81.81,0,0,1-.37.63l-.4.24c-.2.11-.36,0-.36-.21v-1.78a.78.78,0,0,1,.36-.62l.4-.24C119,288.91,119.13,289,119.13,289.23Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "118.565px 290.443px 0px",
            }}
            id="eljc8uud9ep9b"
            className="animable"
          ></path>
          <path
            d="M117.3,290.28v1.78a.78.78,0,0,1-.36.62l-.41.24c-.2.11-.36,0-.36-.21v-1.77a.78.78,0,0,1,.36-.63l.41-.24C117.14,290,117.3,290.05,117.3,290.28Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "116.735px 291.502px 0px",
            }}
            id="eld8otiuvjwfw"
            className="animable"
          ></path>
          <path
            d="M143,248.94l-26.91,15.54a4,4,0,0,0-1.81,3.13v3.65c0,1.16.81,1.62,1.81,1.05L143,256.77a4,4,0,0,0,1.81-3.13V250C144.79,248.83,144,248.36,143,248.94Z"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "129.545px 260.623px 0px",
            }}
            id="elhzv0c88gl6v"
            className="animable"
          ></path>
          <path
            d="M142.88,252v1.77a.81.81,0,0,1-.36.63l-.41.23c-.2.12-.36,0-.36-.21v-1.77a.81.81,0,0,1,.36-.63l.41-.23C142.72,251.71,142.88,251.81,142.88,252Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "142.315px 253.22px 0px",
            }}
            id="elh1a87ln2z4"
            className="animable"
          ></path>
          <path
            d="M141.05,253.09v1.78a.78.78,0,0,1-.36.62l-.41.24c-.2.11-.36,0-.36-.21v-1.78a.78.78,0,0,1,.36-.62l.41-.24C140.89,252.77,141.05,252.86,141.05,253.09Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "140.485px 254.303px 0px",
            }}
            id="elocyn7aikqk"
            className="animable"
          ></path>
          <path
            d="M139.22,254.14v1.78a.78.78,0,0,1-.36.62l-.4.24a.23.23,0,0,1-.37-.21V254.8a.82.82,0,0,1,.37-.63l.4-.23C139.06,253.82,139.22,253.91,139.22,254.14Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "138.654px 255.358px 0px",
            }}
            id="eljdr3r9kww4p"
            className="animable"
          ></path>
          <path
            d="M137.4,255.2V257a.81.81,0,0,1-.36.63l-.41.23c-.2.12-.36,0-.36-.21v-1.77a.81.81,0,0,1,.36-.63L137,255C137.24,254.87,137.4,255,137.4,255.2Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "136.835px 256.428px 0px",
            }}
            id="el9y16kl3iulk"
            className="animable"
          ></path>
          <path
            d="M135.57,256.25V258a.78.78,0,0,1-.36.62l-.41.24c-.2.11-.36,0-.36-.21V256.9a.78.78,0,0,1,.36-.62l.41-.24C135.41,255.93,135.57,256,135.57,256.25Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "135.005px 257.446px 0px",
            }}
            id="el0p6d7f9vkv0q"
            className="animable"
          ></path>
          <path
            d="M133.74,257.3v1.78a.78.78,0,0,1-.36.62l-.41.24c-.2.11-.36,0-.36-.21V258a.81.81,0,0,1,.36-.63l.41-.23C133.58,257,133.74,257.07,133.74,257.3Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "133.175px 258.526px 0px",
            }}
            id="elm3439m6hw9o"
            className="animable"
          ></path>
          <path
            d="M131.92,258.36v1.77a.82.82,0,0,1-.37.63l-.4.23c-.2.12-.36,0-.36-.21V259a.81.81,0,0,1,.36-.63l.4-.23A.23.23,0,0,1,131.92,258.36Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "131.357px 259.564px 0px",
            }}
            id="elmml6z6vuwdb"
            className="animable"
          ></path>
          <path
            d="M130.09,259.41v1.78a.78.78,0,0,1-.36.62l-.41.24c-.2.11-.36,0-.36-.21v-1.78a.78.78,0,0,1,.36-.62l.41-.24C129.93,259.09,130.09,259.18,130.09,259.41Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "129.525px 260.623px 0px",
            }}
            id="el4r42u0n0ior"
            className="animable"
          ></path>
          <path
            d="M128.26,260.46v1.78a.78.78,0,0,1-.36.62l-.41.24c-.2.11-.36,0-.36-.21v-1.77a.81.81,0,0,1,.36-.63l.41-.23C128.1,260.14,128.26,260.23,128.26,260.46Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "127.695px 261.675px 0px",
            }}
            id="elvx8f4kmgfjh"
            className="animable"
          ></path>
          <path
            d="M126.43,261.52v1.77a.81.81,0,0,1-.36.63l-.4.23a.23.23,0,0,1-.37-.21v-1.77a.82.82,0,0,1,.37-.63l.4-.23C126.27,261.19,126.43,261.29,126.43,261.52Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "125.864px 262.729px 0px",
            }}
            id="elwea2czkm55g"
            className="animable"
          ></path>
          <path
            d="M124.61,262.57v1.78a.78.78,0,0,1-.36.62l-.41.24c-.2.11-.36,0-.36-.21v-1.78a.78.78,0,0,1,.36-.62l.41-.24C124.45,262.25,124.61,262.34,124.61,262.57Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "124.045px 263.783px 0px",
            }}
            id="elpuhap19m3zc"
            className="animable"
          ></path>
          <path
            d="M122.78,263.62v1.78a.78.78,0,0,1-.36.62l-.41.24c-.2.11-.36,0-.36-.21v-1.77a.81.81,0,0,1,.36-.63l.41-.23C122.62,263.3,122.78,263.39,122.78,263.62Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "122.215px 264.835px 0px",
            }}
            id="elfnli99mdzpt"
            className="animable"
          ></path>
          <path
            d="M121,264.68v1.77a.81.81,0,0,1-.36.63l-.41.23c-.19.12-.36,0-.36-.21v-1.77a.84.84,0,0,1,.36-.63l.41-.23C120.79,264.35,121,264.45,121,264.68Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "120.435px 265.888px 0px",
            }}
            id="elo4xvy9z1tyo"
            className="animable"
          ></path>
          <path
            d="M119.13,265.73v1.77a.79.79,0,0,1-.37.63l-.4.24c-.2.11-.36,0-.36-.21v-1.78a.78.78,0,0,1,.36-.62l.4-.24C119,265.41,119.13,265.5,119.13,265.73Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "118.565px 266.943px 0px",
            }}
            id="elgag3ssp29o7"
            className="animable"
          ></path>
          <path
            d="M117.3,266.78v1.78a.78.78,0,0,1-.36.62l-.41.24c-.2.11-.36,0-.36-.21v-1.77a.81.81,0,0,1,.36-.63l.41-.23C117.14,266.46,117.3,266.55,117.3,266.78Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "116.735px 267.995px 0px",
            }}
            id="elre46yvpimne"
            className="animable"
          ></path>
          <path
            d="M109.45,365.25l-.83-.47h0a1.1,1.1,0,0,0-1.1.12,3.45,3.45,0,0,0-1.57,2.72,1.08,1.08,0,0,0,.46,1h0l.77.45.14-.24a1.58,1.58,0,0,0,.45-.17,3.46,3.46,0,0,0,1.57-2.72,1.77,1.77,0,0,0,0-.41Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "107.697px 366.878px 0px",
            }}
            id="elewcnl5m9kz"
            className="animable"
          ></path>
          <g id="elbnbbekes0rf">
            <path
              d="M109.45,365.25l-.83-.47h0a1.1,1.1,0,0,0-1.1.12,3.45,3.45,0,0,0-1.57,2.72,1.08,1.08,0,0,0,.46,1h0l.77.45.14-.24a1.58,1.58,0,0,0,.45-.17,3.46,3.46,0,0,0,1.57-2.72,1.77,1.77,0,0,0,0-.41Z"
              style={{
                opacity: "0.4",
                transformOrigin: "107.697px 366.878px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M108.31,365.34a3.46,3.46,0,0,0-1.57,2.72c0,1,.7,1.41,1.57.91a3.49,3.49,0,0,0,1.57-2.72C109.88,365.25,109.17,364.84,108.31,365.34Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "108.31px 367.155px 0px",
            }}
            id="elz73wx2e1fjt"
            className="animable"
          ></path>
          <g id="el6ikcf9tsaj">
            <path
              d="M108.31,365.34a3.46,3.46,0,0,0-1.57,2.72c0,1,.7,1.41,1.57.91a3.49,3.49,0,0,0,1.57-2.72C109.88,365.25,109.17,364.84,108.31,365.34Z"
              style={{
                opacity: "0.2",
                transformOrigin: "108.31px 367.155px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M102.63,369.19l-.83-.48h0a1.1,1.1,0,0,0-1.1.11,3.46,3.46,0,0,0-1.57,2.72,1.1,1.1,0,0,0,.46,1h0l.77.44.14-.23a1.36,1.36,0,0,0,.45-.18,3.46,3.46,0,0,0,1.57-2.72,1.62,1.62,0,0,0-.05-.4Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "100.878px 370.796px 0px",
            }}
            id="elyd51k0gptbq"
            className="animable"
          ></path>
          <g id="el1trvzuz466f">
            <path
              d="M102.63,369.19l-.83-.48h0a1.1,1.1,0,0,0-1.1.11,3.46,3.46,0,0,0-1.57,2.72,1.1,1.1,0,0,0,.46,1h0l.77.44.14-.23a1.36,1.36,0,0,0,.45-.18,3.46,3.46,0,0,0,1.57-2.72,1.62,1.62,0,0,0-.05-.4Z"
              style={{
                opacity: "0.4",
                transformOrigin: "100.878px 370.796px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M101.49,369.28A3.48,3.48,0,0,0,99.91,372c0,1,.71,1.41,1.58.91a3.49,3.49,0,0,0,1.57-2.72C103.06,369.18,102.35,368.78,101.49,369.28Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "101.485px 371.094px 0px",
            }}
            id="el29c5hnw8r4v"
            className="animable"
          ></path>
          <g id="elvksghyul4uq">
            <path
              d="M101.49,369.28A3.48,3.48,0,0,0,99.91,372c0,1,.71,1.41,1.58.91a3.49,3.49,0,0,0,1.57-2.72C103.06,369.18,102.35,368.78,101.49,369.28Z"
              style={{
                opacity: "0.2",
                transformOrigin: "101.485px 371.094px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M109.45,341.71l-.83-.48h0a1.1,1.1,0,0,0-1.1.11,3.46,3.46,0,0,0-1.57,2.72,1.1,1.1,0,0,0,.46,1h0l.77.44.14-.23a2,2,0,0,0,.45-.18,3.46,3.46,0,0,0,1.57-2.72,1.62,1.62,0,0,0,0-.4Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "107.698px 343.316px 0px",
            }}
            id="eltj1uyasg88"
            className="animable"
          ></path>
          <g id="el7lr983nuzxq">
            <path
              d="M109.45,341.71l-.83-.48h0a1.1,1.1,0,0,0-1.1.11,3.46,3.46,0,0,0-1.57,2.72,1.1,1.1,0,0,0,.46,1h0l.77.44.14-.23a2,2,0,0,0,.45-.18,3.46,3.46,0,0,0,1.57-2.72,1.62,1.62,0,0,0,0-.4Z"
              style={{
                opacity: "0.4",
                transformOrigin: "107.698px 343.316px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M108.31,341.8a3.46,3.46,0,0,0-1.57,2.72c0,1,.7,1.41,1.57.9a3.48,3.48,0,0,0,1.57-2.72C109.88,341.7,109.17,341.3,108.31,341.8Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "108.31px 343.612px 0px",
            }}
            id="elp2x4y2v2cn"
            className="animable"
          ></path>
          <g id="elshefpb45kh">
            <path
              d="M108.31,341.8a3.46,3.46,0,0,0-1.57,2.72c0,1,.7,1.41,1.57.9a3.48,3.48,0,0,0,1.57-2.72C109.88,341.7,109.17,341.3,108.31,341.8Z"
              style={{
                opacity: "0.2",
                transformOrigin: "108.31px 343.612px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M102.63,345.64l-.83-.48h0a1.12,1.12,0,0,0-1.1.11A3.48,3.48,0,0,0,99.12,348a1.08,1.08,0,0,0,.46,1h0l.77.44.14-.23a1.58,1.58,0,0,0,.45-.17,3.46,3.46,0,0,0,1.57-2.72,1.77,1.77,0,0,0-.05-.41Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "100.872px 347.252px 0px",
            }}
            id="elxaudmwv1fzc"
            className="animable"
          ></path>
          <g id="elevo5p1gu2c">
            <path
              d="M102.63,345.64l-.83-.48h0a1.12,1.12,0,0,0-1.1.11A3.48,3.48,0,0,0,99.12,348a1.08,1.08,0,0,0,.46,1h0l.77.44.14-.23a1.58,1.58,0,0,0,.45-.17,3.46,3.46,0,0,0,1.57-2.72,1.77,1.77,0,0,0-.05-.41Z"
              style={{
                opacity: "0.4",
                transformOrigin: "100.872px 347.252px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M101.49,345.73a3.48,3.48,0,0,0-1.58,2.72c0,1,.71,1.41,1.58.91a3.49,3.49,0,0,0,1.57-2.72C103.06,345.64,102.35,345.23,101.49,345.73Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "101.485px 347.545px 0px",
            }}
            id="elquq0zyc65up"
            className="animable"
          ></path>
          <g id="elwarqrk22n0m">
            <path
              d="M101.49,345.73a3.48,3.48,0,0,0-1.58,2.72c0,1,.71,1.41,1.58.91a3.49,3.49,0,0,0,1.57-2.72C103.06,345.64,102.35,345.23,101.49,345.73Z"
              style={{
                opacity: "0.2",
                transformOrigin: "101.485px 347.545px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M109.45,318.21l-.83-.48h0a1.1,1.1,0,0,0-1.1.11,3.46,3.46,0,0,0-1.57,2.72,1.1,1.1,0,0,0,.46,1h0l.77.44.14-.23a1.62,1.62,0,0,0,.45-.18,3.46,3.46,0,0,0,1.57-2.72,1.62,1.62,0,0,0,0-.4Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "107.698px 319.816px 0px",
            }}
            id="eltwr7b7mp5dc"
            className="animable"
          ></path>
          <g id="el8tt9x01urfi">
            <path
              d="M109.45,318.21l-.83-.48h0a1.1,1.1,0,0,0-1.1.11,3.46,3.46,0,0,0-1.57,2.72,1.1,1.1,0,0,0,.46,1h0l.77.44.14-.23a1.62,1.62,0,0,0,.45-.18,3.46,3.46,0,0,0,1.57-2.72,1.62,1.62,0,0,0,0-.4Z"
              style={{
                opacity: "0.4",
                transformOrigin: "107.698px 319.816px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M108.31,318.3a3.46,3.46,0,0,0-1.57,2.72c0,1,.7,1.41,1.57.91a3.49,3.49,0,0,0,1.57-2.72C109.88,318.2,109.17,317.8,108.31,318.3Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "108.31px 320.114px 0px",
            }}
            id="elhitp55bia4"
            className="animable"
          ></path>
          <g id="elh3gwv3cqll">
            <path
              d="M108.31,318.3a3.46,3.46,0,0,0-1.57,2.72c0,1,.7,1.41,1.57.91a3.49,3.49,0,0,0,1.57-2.72C109.88,318.2,109.17,317.8,108.31,318.3Z"
              style={{
                opacity: "0.2",
                transformOrigin: "108.31px 320.114px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M102.63,322.15l-.83-.48h0a1.1,1.1,0,0,0-1.1.12,3.46,3.46,0,0,0-1.57,2.72,1.08,1.08,0,0,0,.46,1h0l.77.44.14-.24a1.58,1.58,0,0,0,.45-.17,3.46,3.46,0,0,0,1.57-2.72,1.62,1.62,0,0,0-.05-.4Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "100.877px 323.763px 0px",
            }}
            id="elt6z75asyb3q"
            className="animable"
          ></path>
          <g id="elemerfb9crq">
            <path
              d="M102.63,322.15l-.83-.48h0a1.1,1.1,0,0,0-1.1.12,3.46,3.46,0,0,0-1.57,2.72,1.08,1.08,0,0,0,.46,1h0l.77.44.14-.24a1.58,1.58,0,0,0,.45-.17,3.46,3.46,0,0,0,1.57-2.72,1.62,1.62,0,0,0-.05-.4Z"
              style={{
                opacity: "0.4",
                transformOrigin: "100.877px 323.763px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M101.49,322.23A3.49,3.49,0,0,0,99.91,325c0,1,.71,1.4,1.58.9a3.49,3.49,0,0,0,1.57-2.72C103.06,322.14,102.35,321.73,101.49,322.23Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "101.485px 324.067px 0px",
            }}
            id="el0s2lh6dx0c6n"
            className="animable"
          ></path>
          <g id="eltr4qirql8n">
            <path
              d="M101.49,322.23A3.49,3.49,0,0,0,99.91,325c0,1,.71,1.4,1.58.9a3.49,3.49,0,0,0,1.57-2.72C103.06,322.14,102.35,321.73,101.49,322.23Z"
              style={{
                opacity: "0.2",
                transformOrigin: "101.485px 324.067px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M109.45,294.67l-.83-.48h0a1.1,1.1,0,0,0-1.1.11,3.46,3.46,0,0,0-1.57,2.72,1.1,1.1,0,0,0,.46,1h0l.77.44.14-.23a2,2,0,0,0,.45-.18,3.46,3.46,0,0,0,1.57-2.72,1.62,1.62,0,0,0,0-.4Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "107.698px 296.276px 0px",
            }}
            id="el0fkxhys2sl9"
            className="animable"
          ></path>
          <g id="el5c9z102ervx">
            <path
              d="M109.45,294.67l-.83-.48h0a1.1,1.1,0,0,0-1.1.11,3.46,3.46,0,0,0-1.57,2.72,1.1,1.1,0,0,0,.46,1h0l.77.44.14-.23a2,2,0,0,0,.45-.18,3.46,3.46,0,0,0,1.57-2.72,1.62,1.62,0,0,0,0-.4Z"
              style={{
                opacity: "0.4",
                transformOrigin: "107.698px 296.276px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M108.31,294.76a3.46,3.46,0,0,0-1.57,2.72c0,1,.7,1.41,1.57.91a3.49,3.49,0,0,0,1.57-2.73C109.88,294.66,109.17,294.26,108.31,294.76Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "108.31px 296.574px 0px",
            }}
            id="elspsa60odj9"
            className="animable"
          ></path>
          <g id="el9dwxg9g838a">
            <path
              d="M108.31,294.76a3.46,3.46,0,0,0-1.57,2.72c0,1,.7,1.41,1.57.91a3.49,3.49,0,0,0,1.57-2.73C109.88,294.66,109.17,294.26,108.31,294.76Z"
              style={{
                opacity: "0.2",
                transformOrigin: "108.31px 296.574px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M102.63,298.6l-.83-.47h0a1.1,1.1,0,0,0-1.1.12A3.46,3.46,0,0,0,99.12,301a1.08,1.08,0,0,0,.46,1h0l.77.45.14-.24a1.58,1.58,0,0,0,.45-.17,3.46,3.46,0,0,0,1.57-2.72,1.62,1.62,0,0,0-.05-.4Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "100.872px 300.243px 0px",
            }}
            id="elov2824mjfx"
            className="animable"
          ></path>
          <g id="elzdnk6rmyvln">
            <path
              d="M102.63,298.6l-.83-.47h0a1.1,1.1,0,0,0-1.1.12A3.46,3.46,0,0,0,99.12,301a1.08,1.08,0,0,0,.46,1h0l.77.45.14-.24a1.58,1.58,0,0,0,.45-.17,3.46,3.46,0,0,0,1.57-2.72,1.62,1.62,0,0,0-.05-.4Z"
              style={{
                opacity: "0.4",
                transformOrigin: "100.872px 300.243px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M101.49,298.69a3.49,3.49,0,0,0-1.58,2.73c0,1,.71,1.4,1.58.9a3.49,3.49,0,0,0,1.57-2.72C103.06,298.6,102.35,298.19,101.49,298.69Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "101.485px 300.506px 0px",
            }}
            id="elpzlsgg6kv7"
            className="animable"
          ></path>
          <g id="elyu0azzh1qzg">
            <path
              d="M101.49,298.69a3.49,3.49,0,0,0-1.58,2.73c0,1,.71,1.4,1.58.9a3.49,3.49,0,0,0,1.57-2.72C103.06,298.6,102.35,298.19,101.49,298.69Z"
              style={{
                opacity: "0.2",
                transformOrigin: "101.485px 300.506px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M109.45,271.18l-.83-.48h0a1.1,1.1,0,0,0-1.1.11,3.46,3.46,0,0,0-1.57,2.72,1.1,1.1,0,0,0,.46,1h0l.77.44.14-.23a2,2,0,0,0,.45-.18,3.46,3.46,0,0,0,1.57-2.72,1.62,1.62,0,0,0,0-.4Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "107.698px 272.786px 0px",
            }}
            id="elw71d40t2xxs"
            className="animable"
          ></path>
          <g id="elux4mxw7b8c">
            <path
              d="M109.45,271.18l-.83-.48h0a1.1,1.1,0,0,0-1.1.11,3.46,3.46,0,0,0-1.57,2.72,1.1,1.1,0,0,0,.46,1h0l.77.44.14-.23a2,2,0,0,0,.45-.18,3.46,3.46,0,0,0,1.57-2.72,1.62,1.62,0,0,0,0-.4Z"
              style={{
                opacity: "0.4",
                transformOrigin: "107.698px 272.786px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M108.31,271.27a3.46,3.46,0,0,0-1.57,2.72c0,1,.7,1.41,1.57.91a3.51,3.51,0,0,0,1.57-2.73C109.88,271.17,109.17,270.77,108.31,271.27Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "108.31px 273.084px 0px",
            }}
            id="el4yipesiysit"
            className="animable"
          ></path>
          <g id="elj027virxuxr">
            <path
              d="M108.31,271.27a3.46,3.46,0,0,0-1.57,2.72c0,1,.7,1.41,1.57.91a3.51,3.51,0,0,0,1.57-2.73C109.88,271.17,109.17,270.77,108.31,271.27Z"
              style={{
                opacity: "0.2",
                transformOrigin: "108.31px 273.084px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M102.63,275.11l-.83-.47h0a1.1,1.1,0,0,0-1.1.12,3.45,3.45,0,0,0-1.57,2.72,1.08,1.08,0,0,0,.46,1h0l.77.45.14-.24a1.58,1.58,0,0,0,.45-.17,3.46,3.46,0,0,0,1.57-2.72,1.62,1.62,0,0,0-.05-.4Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "100.877px 276.738px 0px",
            }}
            id="el2vpa59wscv"
            className="animable"
          ></path>
          <g id="elupdzj5ahpa">
            <path
              d="M102.63,275.11l-.83-.47h0a1.1,1.1,0,0,0-1.1.12,3.45,3.45,0,0,0-1.57,2.72,1.08,1.08,0,0,0,.46,1h0l.77.45.14-.24a1.58,1.58,0,0,0,.45-.17,3.46,3.46,0,0,0,1.57-2.72,1.62,1.62,0,0,0-.05-.4Z"
              style={{
                opacity: "0.4",
                transformOrigin: "100.877px 276.738px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M101.49,275.2a3.48,3.48,0,0,0-1.58,2.72c0,1,.71,1.41,1.58.91a3.49,3.49,0,0,0,1.57-2.72C103.06,275.11,102.35,274.7,101.49,275.2Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "101.485px 277.015px 0px",
            }}
            id="elgy1srn4btfk"
            className="animable"
          ></path>
          <g id="eluw86irzgwgp">
            <path
              d="M101.49,275.2a3.48,3.48,0,0,0-1.58,2.72c0,1,.71,1.41,1.58.91a3.49,3.49,0,0,0,1.57-2.72C103.06,275.11,102.35,274.7,101.49,275.2Z"
              style={{
                opacity: "0.2",
                transformOrigin: "101.485px 277.015px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M57.44,325.27,88.36,343.1a2.23,2.23,0,0,1,1,1.74v8.54c0,.63-.45.89-1,.57L57.44,336.12a2.23,2.23,0,0,1-1-1.74v-8.54C56.44,325.21,56.89,325,57.44,325.27Z"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "72.9px 339.621px 0px",
            }}
            id="el67jfk3in5ol"
            className="animable"
          ></path>
          <path
            d="M58.32,329a2.12,2.12,0,0,0,1,1.66l27.16,15.67c.55.32,1,.09,1-.51a2.15,2.15,0,0,0-1-1.66L59.32,328.52C58.76,328.2,58.32,328.43,58.32,329Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "72.9px 337.425px 0px",
            }}
            id="elzxom9f9jlh"
            className="animable"
          ></path>
          <path
            d="M58.32,333.37a2.12,2.12,0,0,0,1,1.66L86.48,350.7c.55.32,1,.09,1-.51a2.15,2.15,0,0,0-1-1.66L59.32,332.86C58.76,332.54,58.32,332.77,58.32,333.37Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "72.9px 341.78px 0px",
            }}
            id="eltesjro8bxj"
            className="animable"
          ></path>
          <path
            d="M59.32,332.86l15,8.65v2.17l-15-8.65a2.12,2.12,0,0,1-1-1.66C58.32,332.77,58.76,332.54,59.32,332.86Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "66.32px 338.198px 0px",
            }}
            id="el2lm7b2bescc"
            className="animable"
          ></path>
          <path
            d="M57.44,348.75l30.92,17.83a2.23,2.23,0,0,1,1,1.74v8.54c0,.63-.45.89-1,.57L57.44,359.6a2.23,2.23,0,0,1-1-1.74v-8.54C56.44,348.69,56.89,348.43,57.44,348.75Z"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "72.9px 363.09px 0px",
            }}
            id="elrhzowt9wp89"
            className="animable"
          ></path>
          <path
            d="M58.32,352.51a2.12,2.12,0,0,0,1,1.66l27.16,15.67c.55.32,1,.09,1-.51a2.15,2.15,0,0,0-1-1.66L59.32,352C58.76,351.68,58.32,351.91,58.32,352.51Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "72.9px 360.92px 0px",
            }}
            id="elwfj29m7uxna"
            className="animable"
          ></path>
          <path
            d="M58.32,356.85a2.12,2.12,0,0,0,1,1.66l27.16,15.67c.55.32,1,.09,1-.51a2.15,2.15,0,0,0-1-1.66L59.32,356.34C58.76,356,58.32,356.25,58.32,356.85Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "72.9px 365.256px 0px",
            }}
            id="el2j824h3ljgd"
            className="animable"
          ></path>
          <path
            d="M59.32,356.34l22.52,13v2.17l-22.52-13a2.12,2.12,0,0,1-1-1.66C58.32,356.25,58.76,356,59.32,356.34Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "70.08px 363.848px 0px",
            }}
            id="elioeexi23ypd"
            className="animable"
          ></path>
          <path
            d="M57.44,301.94l30.92,17.84a2.23,2.23,0,0,1,1,1.74v8.53c0,.64-.45.9-1,.58L57.44,312.8a2.23,2.23,0,0,1-1-1.74v-8.54C56.44,301.88,56.89,301.62,57.44,301.94Z"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "72.9px 316.285px 0px",
            }}
            id="eljnlilsvz8r"
            className="animable"
          ></path>
          <path
            d="M58.32,305.71a2.12,2.12,0,0,0,1,1.66L86.48,323c.55.32,1,.09,1-.51a2.15,2.15,0,0,0-1-1.66L59.32,305.2C58.76,304.88,58.32,305.11,58.32,305.71Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "72.9px 314.1px 0px",
            }}
            id="elqdp67uygpyd"
            className="animable"
          ></path>
          <path
            d="M58.32,310.05a2.12,2.12,0,0,0,1,1.66l27.16,15.67c.55.32,1,.09,1-.51a2.15,2.15,0,0,0-1-1.66L59.32,309.54C58.76,309.22,58.32,309.45,58.32,310.05Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "72.9px 318.46px 0px",
            }}
            id="elvuz4zyhzlo"
            className="animable"
          ></path>
          <path
            d="M59.32,309.54l24.4,14.07v2.17l-24.4-14.07a2.12,2.12,0,0,1-1-1.66C58.32,309.45,58.76,309.22,59.32,309.54Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "71.02px 317.588px 0px",
            }}
            id="el3n2r3pph3wf"
            className="animable"
          ></path>
          <path
            d="M57.44,254.9l30.92,17.83a2.23,2.23,0,0,1,1,1.74V283c0,.63-.45.89-1,.57L57.44,265.75a2.23,2.23,0,0,1-1-1.74v-8.54C56.44,254.84,56.89,254.58,57.44,254.9Z"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "72.9px 269.235px 0px",
            }}
            id="eldaxf848a8y6"
            className="animable"
          ></path>
          <path
            d="M58.32,258.66a2.12,2.12,0,0,0,1,1.66L86.48,276c.55.32,1,.09,1-.51a2.15,2.15,0,0,0-1-1.66L59.32,258.15C58.76,257.83,58.32,258.06,58.32,258.66Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "72.9px 267.075px 0px",
            }}
            id="elqgtb01gt7vn"
            className="animable"
          ></path>
          <path
            d="M58.32,263a2.12,2.12,0,0,0,1,1.66l27.16,15.67c.55.32,1,.09,1-.51a2.15,2.15,0,0,0-1-1.66L59.32,262.49C58.76,262.17,58.32,262.4,58.32,263Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "72.9px 271.41px 0px",
            }}
            id="el1nwlo6apa3k"
            className="animable"
          ></path>
          <path
            d="M59.32,262.49l18.76,10.82v2.17L59.32,264.66a2.12,2.12,0,0,1-1-1.66C58.32,262.4,58.76,262.17,59.32,262.49Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "68.2px 268.913px 0px",
            }}
            id="elkzbyjjguze"
            className="animable"
          ></path>
          <path
            d="M57.44,278.4l30.92,17.84a2.23,2.23,0,0,1,1,1.73v8.54c0,.64-.45.9-1,.58L57.44,289.26a2.23,2.23,0,0,1-1-1.74V279C56.44,278.34,56.89,278.08,57.44,278.4Z"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "72.9px 292.745px 0px",
            }}
            id="el2obiy1rgdax"
            className="animable"
          ></path>
          <path
            d="M58.32,282.17a2.14,2.14,0,0,0,1,1.66l27.16,15.66c.55.32,1,.1,1-.5a2.17,2.17,0,0,0-1-1.67L59.32,281.66C58.76,281.34,58.32,281.57,58.32,282.17Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "72.9px 290.576px 0px",
            }}
            id="elt447k1ceqg"
            className="animable"
          ></path>
          <path
            d="M58.32,286.51a2.12,2.12,0,0,0,1,1.66l27.16,15.67c.55.32,1,.09,1-.51a2.13,2.13,0,0,0-1-1.66L59.32,286C58.76,285.68,58.32,285.91,58.32,286.51Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "72.9px 294.92px 0px",
            }}
            id="elzb9zfu20clc"
            className="animable"
          ></path>
          <path
            d="M59.32,286l24.4,14.07v2.17l-24.4-14.07a2.12,2.12,0,0,1-1-1.66C58.32,285.91,58.76,285.68,59.32,286Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "71.02px 294.048px 0px",
            }}
            id="elp9advfdlrk"
            className="animable"
          ></path>
          <path
            d="M95.19,263.17l36.33-21a2.13,2.13,0,0,0,.94-1.63v-1.22a2.11,2.11,0,0,0-.94-1.63l-36.33-21a2.08,2.08,0,0,0-1.88,0L57,237.72a2.08,2.08,0,0,0-.94,1.63v1.22A2.08,2.08,0,0,0,57,242.2l36.33,21A2.08,2.08,0,0,0,95.19,263.17Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "94.26px 239.935px 0px",
            }}
            id="elcnklekvetee"
            className="animable"
          ></path>
          <g id="elx6l7k2hcw8e">
            <path
              d="M95.19,263.17l36.33-21a2.13,2.13,0,0,0,.94-1.63v-1.22a2.11,2.11,0,0,0-.94-1.63l-36.33-21a2.08,2.08,0,0,0-1.88,0L57,237.72a2.08,2.08,0,0,0-.94,1.63v1.22A2.08,2.08,0,0,0,57,242.2l36.33,21A2.08,2.08,0,0,0,95.19,263.17Z"
              style={{
                opacity: "0.35",
                transformOrigin: "94.26px 239.935px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M131.52,238.8l-36.33,21a2.08,2.08,0,0,1-1.88,0L57,238.81a.58.58,0,0,1,0-1.09l36.33-21a2.08,2.08,0,0,1,1.88,0l36.33,21A.57.57,0,0,1,131.52,238.8Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "94.2681px 238.26px 0px",
            }}
            id="elzhkj2r79qn"
            className="animable"
          ></path>
          <path
            d="M94.24,260v3.4a1.92,1.92,0,0,0,.94-.23l36.34-21a2.08,2.08,0,0,0,.94-1.63v-1.22a2.11,2.11,0,0,0-.77-1.51c.34.3.28.7-.17,1l-36.34,21A1.92,1.92,0,0,1,94.24,260Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "113.35px 250.605px 0px",
            }}
            id="el32bt43fh5kb"
            className="animable"
          ></path>
          <g id="el5lnmqxveasf">
            <path
              d="M94.24,260v3.4a1.92,1.92,0,0,0,.94-.23l36.34-21a2.08,2.08,0,0,0,.94-1.63v-1.22a2.11,2.11,0,0,0-.77-1.51c.34.3.28.7-.17,1l-36.34,21A1.92,1.92,0,0,1,94.24,260Z"
              style={{
                opacity: "0.2",
                transformOrigin: "113.35px 250.605px 0px",
              }}
              className="animable"
            ></path>
          </g>
          <path
            d="M95.19,253l24.57-14.18a2.08,2.08,0,0,0,.94-1.63V236a2.06,2.06,0,0,0-.94-1.62L104,225.23a6.09,6.09,0,0,1-1.58-1.41l-7.53-10.14a1.25,1.25,0,0,0-1.59-.33L68.73,227.54a2.08,2.08,0,0,0-.94,1.63v8a2.08,2.08,0,0,0,.94,1.63L93.31,253A2.08,2.08,0,0,0,95.19,253Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "94.245px 233.21px 0px",
            }}
            id="el5nlrgtllb3d"
            className="animable"
          ></path>
          <path
            d="M93.31,249.6l-15.76-9.1a4.94,4.94,0,0,1-.82-.61,5.68,5.68,0,0,1-.77-.8L68.44,229a.94.94,0,0,1,.29-1.41L93.3,213.35a1.25,1.25,0,0,1,1.59.33l7.53,10.14a5.79,5.79,0,0,0,1.45,1.47l15.89,9a.57.57,0,0,1,0,1.08L95.19,249.6A2.08,2.08,0,0,1,93.31,249.6Z"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "94.1924px 231.51px 0px",
            }}
            id="elee41nt46rl"
            className="animable"
          ></path>
          <path
            d="M68.73,227.54,93.3,213.35a1.25,1.25,0,0,1,1.59.33l7.53,10.14a5.14,5.14,0,0,0,.77.8S76.74,239.9,76.73,239.89a5.68,5.68,0,0,1-.77-.8L68.44,229A.94.94,0,0,1,68.73,227.54Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "85.6991px 226.543px 0px",
            }}
            id="elhjo7u3yj9j"
            className="animable"
          ></path>
          <path
            d="M113.8,234.57a2.46,2.46,0,0,0-2.21,0,.68.68,0,0,0,0,1.28,2.46,2.46,0,0,0,2.21,0A.68.68,0,0,0,113.8,234.57Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "112.695px 235.21px 0px",
            }}
            id="eli3dyfwyey0b"
            className="animable"
          ></path>
          <path
            d="M109.39,237.12a2.46,2.46,0,0,0-2.21,0,.67.67,0,0,0,0,1.27,2.46,2.46,0,0,0,2.21,0A.67.67,0,0,0,109.39,237.12Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "108.285px 237.755px 0px",
            }}
            id="elho11wqtvi8n"
            className="animable"
          ></path>
          <path
            d="M105,239.67a2.4,2.4,0,0,0-2.21,0,.67.67,0,0,0,0,1.27,2.46,2.46,0,0,0,2.21,0A.67.67,0,0,0,105,239.67Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "103.895px 240.301px 0px",
            }}
            id="eljpvdjxx1t5"
            className="animable"
          ></path>
          <path
            d="M100.57,242.21a2.44,2.44,0,0,0-2.2,0,.67.67,0,0,0,0,1.27,2.44,2.44,0,0,0,2.2,0A.67.67,0,0,0,100.57,242.21Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "99.47px 242.845px 0px",
            }}
            id="el52prlvogpna"
            className="animable"
          ></path>
          <path
            d="M110.49,232.67a2.38,2.38,0,0,0-2.2,0,.67.67,0,0,0,0,1.27,2.44,2.44,0,0,0,2.2,0A.67.67,0,0,0,110.49,232.67Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "109.39px 233.301px 0px",
            }}
            id="el0ss7jb1oygy"
            className="animable"
          ></path>
          <path
            d="M106.08,235.21a2.44,2.44,0,0,0-2.2,0,.67.67,0,0,0,0,1.27,2.38,2.38,0,0,0,2.2,0A.67.67,0,0,0,106.08,235.21Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "104.98px 235.849px 0px",
            }}
            id="el9kvwisr5yj"
            className="animable"
          ></path>
          <ellipse
            cx="100.57"
            cy="238.39"
            rx="1.56"
            ry="0.9"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "100.57px 238.39px 0px",
            }}
            id="elf8giyl6d0vg"
            className="animable"
          ></ellipse>
          <path
            d="M97.26,240.3a2.44,2.44,0,0,0-2.2,0,.67.67,0,0,0,0,1.27,2.38,2.38,0,0,0,2.2,0A.67.67,0,0,0,97.26,240.3Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "96.16px 240.939px 0px",
            }}
            id="el4p3q2noua34"
            className="animable"
          ></path>
          <path
            d="M107.18,230.76a2.38,2.38,0,0,0-2.2,0,.67.67,0,0,0,0,1.27,2.44,2.44,0,0,0,2.2,0A.67.67,0,0,0,107.18,230.76Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "106.08px 231.391px 0px",
            }}
            id="el5abixxqoe63"
            className="animable"
          ></path>
          <path
            d="M102.77,233.3a2.44,2.44,0,0,0-2.2,0,.67.67,0,0,0,0,1.27,2.38,2.38,0,0,0,2.2,0A.67.67,0,0,0,102.77,233.3Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "101.67px 233.939px 0px",
            }}
            id="elldwrnqt9gac"
            className="animable"
          ></path>
          <path
            d="M98.37,235.85a2.46,2.46,0,0,0-2.21,0,.67.67,0,0,0,0,1.27,2.46,2.46,0,0,0,2.21,0A.67.67,0,0,0,98.37,235.85Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "97.265px 236.485px 0px",
            }}
            id="elnwukpeeggu"
            className="animable"
          ></path>
          <path
            d="M96.14,244.71a2.4,2.4,0,0,0-2.21,0,.67.67,0,0,0,0,1.27,2.46,2.46,0,0,0,2.21,0A.67.67,0,0,0,96.14,244.71Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "95.035px 245.341px 0px",
            }}
            id="elu0fq35awq4"
            className="animable"
          ></path>
          <path
            d="M92.83,242.8a2.38,2.38,0,0,0-2.2,0,.67.67,0,0,0,0,1.27,2.44,2.44,0,0,0,2.2,0A.67.67,0,0,0,92.83,242.8Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "91.73px 243.431px 0px",
            }}
            id="el29e9sf9ltcu"
            className="animable"
          ></path>
          <ellipse
            cx="92.85"
            cy="239.03"
            rx="1.56"
            ry="0.9"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "92.85px 239.03px 0px",
            }}
            id="el6t1851fr9iu"
            className="animable"
          ></ellipse>
          <ellipse
            cx="102.77"
            cy="229.49"
            rx="1.56"
            ry="0.9"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "102.77px 229.49px 0px",
            }}
            id="elfxs6fuxinf5"
            className="animable"
          ></ellipse>
          <path
            d="M99.47,231.39a2.46,2.46,0,0,0-2.21,0,.68.68,0,0,0,0,1.28,2.46,2.46,0,0,0,2.21,0A.68.68,0,0,0,99.47,231.39Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "98.365px 232.03px 0px",
            }}
            id="elae8qrq60iqu"
            className="animable"
          ></path>
          <path
            d="M95.06,233.94a2.46,2.46,0,0,0-2.21,0,.67.67,0,0,0,0,1.27,2.46,2.46,0,0,0,2.21,0A.67.67,0,0,0,95.06,233.94Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "93.955px 234.575px 0px",
            }}
            id="elgjej54mf7u7"
            className="animable"
          ></path>
          <ellipse
            cx="89.55"
            cy="237.12"
            rx="1.56"
            ry="0.9"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "89.55px 237.12px 0px",
            }}
            id="elgpx9ufqjk2t"
            className="animable"
          ></ellipse>
          <path
            d="M89.52,240.89a2.44,2.44,0,0,0-2.2,0,.67.67,0,0,0,0,1.27,2.44,2.44,0,0,0,2.2,0A.67.67,0,0,0,89.52,240.89Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "88.42px 241.525px 0px",
            }}
            id="elvtlcljuxl2l"
            className="animable"
          ></path>
          <path
            d="M86.22,239A2.46,2.46,0,0,0,84,239a.67.67,0,0,0,0,1.27,2.46,2.46,0,0,0,2.21,0A.67.67,0,0,0,86.22,239Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "85.1075px 239.634px 0px",
            }}
            id="elfs02qpjsf8s"
            className="animable"
          ></path>
          <path
            d="M94.19,249.82v3.39a1.88,1.88,0,0,0,1-.22l24.58-14.19a2,2,0,0,0,.94-1.63V236a2.07,2.07,0,0,0-.77-1.5c.34.29.28.7-.17,1L95.18,249.6A1.88,1.88,0,0,1,94.19,249.82Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "107.45px 243.857px 0px",
            }}
            id="elslqbv0bb9ti"
            className="animable"
          ></path>
          <path
            d="M99.17,223.39l0,0a.82.82,0,0,0-1-.22L76.7,235.49a.63.63,0,0,0-.19.94l0,0a.83.83,0,0,0,1.06.22L99,224.34A.64.64,0,0,0,99.17,223.39Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "87.8433px 229.92px 0px",
            }}
            id="elzb0mkl9yqp"
            className="animable"
          ></path>
          <path
            d="M99.17,223.39l0,0a.82.82,0,0,0-1-.22l-15.9,9.18.89,1.19L99,224.34A.64.64,0,0,0,99.17,223.39Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "90.7906px 228.313px 0px",
            }}
            id="elslp18yxuud"
            className="animable"
          ></path>
          <path
            d="M97.4,221l0,0a.83.83,0,0,0-1.06-.22L74.94,233.12a.62.62,0,0,0-.2.94l0,0a.84.84,0,0,0,1.06.22L97.2,222A.62.62,0,0,0,97.4,221Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "86.0887px 227.529px 0px",
            }}
            id="el8twtbs65hel"
            className="animable"
          ></path>
          <path
            d="M97.4,221l0,0a.83.83,0,0,0-1.06-.22L91,223.84l.89,1.19L97.2,222A.62.62,0,0,0,97.4,221Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "94.2871px 222.853px 0px",
            }}
            id="elvmsupde0vbg"
            className="animable"
          ></path>
          <path
            d="M95.63,218.65l0,0a.83.83,0,0,0-1.06-.22L73.17,230.74a.64.64,0,0,0-.2.95l0,0a.83.83,0,0,0,1.06.21l21.37-12.34A.62.62,0,0,0,95.63,218.65Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "84.2902px 225.167px 0px",
            }}
            id="elpfp9v81umak"
            className="animable"
          ></path>
          <path
            d="M95.63,218.65l0,0a.83.83,0,0,0-1.06-.22l-11.14,6.41L84.3,226l11.13-6.41A.62.62,0,0,0,95.63,218.65Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "89.5984px 222.163px 0px",
            }}
            id="el08pddkai1znc"
            className="animable"
          ></path>
          <path
            d="M93.86,216.27l0,0a.83.83,0,0,0-1.06-.22L71.4,228.37a.62.62,0,0,0-.19.94l0,0a.83.83,0,0,0,1.06.22l21.38-12.34A.64.64,0,0,0,93.86,216.27Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "82.5218px 222.79px 0px",
            }}
            id="ellhkiroii5nm"
            className="animable"
          ></path>
          <path
            d="M93.86,216.27l0,0a.83.83,0,0,0-1.06-.22L73.37,227.23l.89,1.19,19.41-11.2A.64.64,0,0,0,93.86,216.27Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "83.6824px 222.183px 0px",
            }}
            id="elbd86m87uodo"
            className="animable"
          ></path>
        </g>
      </g>
      <g
        id="freepik--speech-bubble-1--inject-9"
        style={{ transformOrigin: "64.655px 175.673px 0px" }}
        className="animable"
      >
        <g
          id="freepik--speech-bubble--inject-9"
          style={{ transformOrigin: "64.655px 175.673px 0px" }}
          className="animable"
        >
          <g
            id="freepik--speech-bubble--inject-9"
            style={{ transformOrigin: "64.655px 175.673px 0px" }}
            className="animable"
          >
            <path
              d="M67.2,212.88l-4-7.54L66.41,196v-5.7L56.54,196v5.7l4.24,7.36a.69.69,0,0,0,.29.25h0Z"
              style={{
                fill: "rgb(143, 18, 35)",
                transformOrigin: "61.87px 201.59px 0px",
              }}
              id="elm9f3yilcuol"
              className="animable"
            ></path>
            <g id="elmjidg11ooa">
              <path
                d="M67.2,212.88l-4-7.54L66.41,196v-5.7L56.54,196v5.7l4.24,7.36a.69.69,0,0,0,.29.25h0Z"
                style={{
                  opacity: "0.2",
                  transformOrigin: "61.87px 201.59px 0px",
                }}
                className="animable"
              ></path>
            </g>
            <path
              d="M89.72,145.61a6.52,6.52,0,0,0-3-5.12l-2.41-1.4a6.57,6.57,0,0,0-5.92,0L42.52,159.86a6.54,6.54,0,0,0-3,5.13v40.67a6.52,6.52,0,0,0,3,5.13l2.41,1.39a6.5,6.5,0,0,0,5.92,0l11.89-6.87L67,212.65a.64.64,0,0,0,1.15-.11l4.48-12.92,14.16-8.21a6.52,6.52,0,0,0,3-5.12Z"
              style={{
                fill: "rgb(143, 18, 35)",
                transformOrigin: "64.655px 175.673px 0px",
              }}
              id="eli5759c7muzb"
              className="animable"
            ></path>
            <path
              d="M78.47,182.24a.48.48,0,0,0,0-.47l-1.42-1.56a2.07,2.07,0,0,1-.17-1.84,0,0,0,0,0,0,0h0A3.49,3.49,0,0,1,78,176.47l2.26-1.64a.66.66,0,0,0,.26-.48,21.51,21.51,0,0,0,.19-2.9,20.15,20.15,0,0,0-.18-2.72c0-.15-.12-.22-.25-.17l-2.26,1a.81.81,0,0,1-1.14-.52s0,0,0-.06a2.75,2.75,0,0,1,.18-2l1.42-3.19a.54.54,0,0,0,0-.48,6.37,6.37,0,0,0-3-2.26c-.11,0-.25,0-.35.21l-1.79,2.91A2,2,0,0,1,72,165.18h0c-.5,0-.84-.38-.9-1l-.25-2.87c0-.17-.12-.24-.24-.21a14.4,14.4,0,0,0-4.22,2.42.79.79,0,0,0-.24.49l-.26,3.17a3.66,3.66,0,0,1-.9,2l0,0c-.5.55-1.06.78-1.46.59L61.67,169c-.1-.05-.25,0-.36.19a31.88,31.88,0,0,0-3,5.68.51.51,0,0,0,0,.47l1.41,1.56a2,2,0,0,1,.17,1.83s0,0,0,.06a3.44,3.44,0,0,1-1.14,1.83l-2.28,1.66a.75.75,0,0,0-.25.47,23.57,23.57,0,0,0-.19,2.91,18.77,18.77,0,0,0,.18,2.69c0,.17.13.24.26.18l2.26-.95a.82.82,0,0,1,1.15.54v0a2.77,2.77,0,0,1-.17,2l-1.42,3.19a.54.54,0,0,0,0,.48,6.39,6.39,0,0,0,3,2.27c.1,0,.25-.06.35-.22L63.4,193a2,2,0,0,1,1.46-1.07h0c.49,0,.83.38.88,1l.26,2.87c0,.16.11.25.24.2a11,11,0,0,0,2.1-1,15.59,15.59,0,0,0,2.11-1.46.7.7,0,0,0,.24-.48l.27-3.17a3.75,3.75,0,0,1,.89-2l0,0c.5-.56,1-.79,1.45-.6l1.78.87c.1,0,.25,0,.35-.19A31.28,31.28,0,0,0,78.47,182.24Zm-10.08,4.62c-3.44,2-6.23-.15-6.22-4.74s2.81-9.94,6.25-11.92,6.23.16,6.22,4.76S71.83,184.89,68.39,186.86Z"
              style={{
                fill: "rgb(255, 255, 255)",
                transformOrigin: "68.3699px 178.555px 0px",
              }}
              id="elosutbsvf7qh"
              className="animable"
            ></path>
            <g id="elibh0u6tgehf">
              <path
                d="M39.56,205.66a6.52,6.52,0,0,0,3,5.13l2.41,1.39a6.58,6.58,0,0,0,5.41.24c-1.39.53-2.45-.26-2.45-1.95V169.8a6,6,0,0,1,.87-2.92l-8.34-4.81a6.13,6.13,0,0,0-.86,2.92Z"
                style={{
                  opacity: "0.2",
                  transformOrigin: "44.97px 187.479px 0px",
                }}
                className="animable"
              ></path>
            </g>
            <g id="elqohlosltsr">
              <path
                d="M89.63,144.77c-.35-1.25-1.49-1.66-2.86-.87L50.85,164.68a5.87,5.87,0,0,0-2.09,2.21l-8.33-4.81a6,6,0,0,1,2.09-2.21L78.43,139.1a6.57,6.57,0,0,1,5.92,0l2.42,1.39A6.55,6.55,0,0,1,89.63,144.77Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: "0.3",
                  transformOrigin: "65.03px 152.643px 0px",
                }}
                className="animable"
              ></path>
            </g>
          </g>
        </g>
      </g>
      <g
        id="freepik--Cloud--inject-9"
        style={{ transformOrigin: "237.725px 106.931px 0px" }}
        className="animable"
      >
        <g
          id="freepik--cloud--inject-9"
          style={{ transformOrigin: "237.725px 106.931px 0px" }}
          className="animable"
        >
          <g
            id="freepik--cloud--inject-9"
            style={{ transformOrigin: "237.725px 106.931px 0px" }}
            className="animable"
          >
            <g id="elkryxfnwdpak">
              <path
                d="M317.32,77.34v0l-.41-.23-.24-.14-8.95-5.17c0-.2,0-.41,0-.62,0-11-3.7-18.68-9.52-21.91h0l-17.19-9.94v0c-4.73-2.72-10.89-2.47-17.62,1.42a40.13,40.13,0,0,0-8.51,6.75,17.88,17.88,0,0,0-3.72-3h0L234.6,35h0c-6.08-4-14.22-3.95-23.18,1.23-18.82,10.86-34.07,40-34.07,65.09a52.75,52.75,0,0,0,.63,8.31L175.63,111c-12,6.91-21.68,25.45-21.68,41.41h0c0,8.82,3,15.1,7.63,17.8h0L179,180.25h0c3.78,2.17,8.66,2,14-1.09L224.5,161l84-48.48c7.18-4.15,13-15.27,13-24.85h0C321.47,82.61,319.87,79,317.32,77.34Z"
                style={{
                  fill: "rgb(143, 18, 35)",
                  opacity: "0.8",
                  transformOrigin: "237.725px 106.931px 0px",
                }}
                className="animable"
              ></path>
            </g>
            <g id="elf9bqx9ekrgo">
              <path
                d="M317.32,77.34v0l-.41-.23-.24-.14-8.95-5.17c0-.2,0-.41,0-.62,0-11-3.7-18.68-9.52-21.91h0l-17.19-9.94v0c-4.73-2.72-10.89-2.47-17.62,1.42a40.13,40.13,0,0,0-8.51,6.75,17.88,17.88,0,0,0-3.72-3h0L234.6,35h0c-6.08-4-14.22-3.95-23.18,1.23-18.82,10.86-34.07,40-34.07,65.09a52.75,52.75,0,0,0,.63,8.31L175.63,111c-12,6.91-21.68,25.45-21.68,41.41h0c0,8.82,3,15.1,7.63,17.8h0L179,180.25h0c3.78,2.17,8.66,2,14-1.09L224.5,161l84-48.48c7.18-4.15,13-15.27,13-24.85h0C321.47,82.61,319.87,79,317.32,77.34Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: "0.2",
                  transformOrigin: "237.725px 106.931px 0px",
                }}
                className="animable"
              ></path>
            </g>
            <g id="eldtuyyo3e91q">
              <path
                d="M298.25,49.24h0c-4.7-2.62-10.8-2.31-17.45,1.53a40.66,40.66,0,0,0-8.92,7.17L256.1,48.78l-1.55-.9.38-.39a41.19,41.19,0,0,1,8.5-6.74c6.74-3.89,12.91-4.14,17.63-1.42v0Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: "0.35",
                  transformOrigin: "276.4px 47.7308px 0px",
                }}
                className="animable"
              ></path>
            </g>
            <g id="elwlou5nhh0j">
              <path
                d="M254.93,47.49c.41.41.79.84,1.17,1.29l-1.55-.9Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: "0.8",
                  transformOrigin: "255.325px 48.135px 0px",
                }}
                className="animable"
              ></path>
            </g>
            <g id="elbbpessn92n">
              <path
                d="M250.79,44.31h0c-5.93-3.3-13.62-2.92-22,1.93s-16.34,13.63-22.32,24l-17.33-10c6-10.37,13.77-19.07,22.3-24,9-5.17,17.11-5.25,23.19-1.21v0Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: "0.35",
                  transformOrigin: "219.965px 51.2021px 0px",
                }}
                className="animable"
              ></path>
            </g>
            <g id="el6qrk3t66jqh">
              <path
                d="M195.32,119.65,193,121c-8.11,4.68-15.19,14.72-18.89,25.67l-17.35-10c3-8.73,8.06-16.86,14.12-22.18l7.13-4.84Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: "0.35",
                  transformOrigin: "176.04px 128.16px 0px",
                }}
                className="animable"
              ></path>
            </g>
            <path
              d="M308.47,77.79l-1.25.72a54.24,54.24,0,0,0,.53-7.35c0-19.86-12.08-29-27-20.39-6.91,4-13.21,11.09-18,19.55-.67-23.91-15.65-34.69-34-24.08-18.81,10.87-34.07,40-34.07,65.1a52.75,52.75,0,0,0,.63,8.31L193,121c-12,6.92-21.67,25.46-21.67,41.42h0c0,16,9.7,23.64,21.67,16.73L224.5,161h0l84-48.48c7.18-4.15,13-15.27,13-24.85h0C321.47,78.05,315.65,73.64,308.47,77.79Z"
              style={{
                fill: "rgb(143, 18, 35)",
                transformOrigin: "246.415px 111.929px 0px",
              }}
              id="elng44y6rcjts"
              className="animable"
            ></path>
            <g id="el6oop3ojr59y">
              <path
                d="M308.47,77.79l-1.25.72a54.24,54.24,0,0,0,.53-7.35c0-19.86-12.08-29-27-20.39-6.91,4-13.21,11.09-18,19.55-.67-23.91-15.65-34.69-34-24.08-18.81,10.87-34.07,40-34.07,65.1a52.75,52.75,0,0,0,.63,8.31L193,121c-12,6.92-21.67,25.46-21.67,41.42h0c0,16,9.7,23.64,21.67,16.73L224.5,161h0l84-48.48c7.18-4.15,13-15.27,13-24.85h0C321.47,78.05,315.65,73.64,308.47,77.79Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: "0.7",
                  transformOrigin: "246.415px 111.929px 0px",
                }}
                className="animable"
              ></path>
            </g>
            <g id="el9ga4y6xb33">
              <path
                d="M184.53,177.26c-5.34,0-8.79-5.83-8.79-14.84,0-14.28,8.91-31.48,19.45-37.57l2.35-1.36a4.46,4.46,0,0,0,2.17-4.54h0a48.75,48.75,0,0,1-.58-7.61c0-23.63,14.29-51.11,31.85-61.25a22.92,22.92,0,0,1,11.3-3.49c9.51,0,15.67,9.13,16.08,23.84h0a4.44,4.44,0,0,0,8.31,2.06h0C271.23,64.41,277,58.06,283,54.62A17.19,17.19,0,0,1,291.49,52c7.18,0,11.82,7.52,11.82,19.18a51.4,51.4,0,0,1-.48,6.75h0a4.44,4.44,0,0,0,6.61,4.45l1.25-.72a6.21,6.21,0,0,1,2.94-1c2.35,0,3.4,3.49,3.4,7,0,8-4.94,17.63-10.78,21l-115.5,66.68a12.7,12.7,0,0,1-6.22,1.95Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: "0.7",
                  transformOrigin: "246.385px 111.945px 0px",
                }}
                className="animable"
              ></path>
            </g>
          </g>
          <path
            d="M225,102.36c.65-.37,1.14-.42,1.48-.14a2.09,2.09,0,0,1,.7,1l10.57,34.61a2.76,2.76,0,0,1,.2.86,2.52,2.52,0,0,1-.32,1.18,2,2,0,0,1-.75.86l-6.11,3.52c-.64.38-1.11.46-1.38.25a1.32,1.32,0,0,1-.51-.77l-1.36-4.58-12.89,7.44-1.36,6.15a4.46,4.46,0,0,1-.51,1.36,3.39,3.39,0,0,1-1.38,1.35L205.3,159a.65.65,0,0,1-.76,0,1,1,0,0,1-.31-.82,5,5,0,0,1,.19-1.09L215,110.29a8.34,8.34,0,0,1,.7-1.83,3.65,3.65,0,0,1,1.48-1.56Zm-7.85,32.78,7.85-4.53-3.92-13.25Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "221.088px 130.582px 0px",
            }}
            id="elmr3x2m9818f"
            className="animable"
          ></path>
          <path
            d="M257.06,83.87a18.45,18.45,0,0,1,5.58-2.28,6.35,6.35,0,0,1,4.21.4,5.92,5.92,0,0,1,2.69,3.2,16.14,16.14,0,0,1,.95,6,26.7,26.7,0,0,1-.95,7.2,24.73,24.73,0,0,1-2.69,6.27,26.55,26.55,0,0,1-4.21,5.28,28.48,28.48,0,0,1-5.58,4.19l-6.2,3.58v13.18a3.13,3.13,0,0,1-.39,1.46,2.51,2.51,0,0,1-.92,1l-6.35,3.67a.76.76,0,0,1-.92,0,1.17,1.17,0,0,1-.39-1V94.37a3.1,3.1,0,0,1,.39-1.45,2.54,2.54,0,0,1,.92-1Zm-6.2,23.81,6-3.44a10.15,10.15,0,0,0,3.37-3.15,8.11,8.11,0,0,0,1.33-4.67c0-1.82-.44-2.86-1.33-3.15a4.35,4.35,0,0,0-3.37.75l-6,3.45Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "256.191px 109.288px 0px",
            }}
            id="elm5gt201l62"
            className="animable"
          ></path>
          <path
            d="M276.45,117.91a.78.78,0,0,1-.92,0,1.19,1.19,0,0,1-.39-1V75.17a3.13,3.13,0,0,1,.39-1.45,2.54,2.54,0,0,1,.92-1L282.8,69a.78.78,0,0,1,.92,0,1.19,1.19,0,0,1,.39,1v41.75a3.13,3.13,0,0,1-.39,1.45,2.61,2.61,0,0,1-.92,1Z"
            style={{
              fill: "rgb(143, 18, 35)",
              transformOrigin: "279.625px 93.455px 0px",
            }}
            id="elgdyb34na0yh"
            className="animable"
          ></path>
        </g>
      </g>
    </svg>
  );
}
